(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-json.js', './korge-root-korlibs-datastructure.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./korge-root-korlibs-datastructure.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'korgee-korge-ldtk'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'korgee-korge-ldtk'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'korgee-korge-ldtk'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'korgee-korge-ldtk'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'korgee-korge-ldtk'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'korgee-korge-ldtk'.");
    }
    if (typeof this['korge-root-korlibs-datastructure'] === 'undefined') {
      throw new Error("Error loading module 'korgee-korge-ldtk'. Its dependency 'korge-root-korlibs-datastructure' was not found. Please, check whether 'korge-root-korlibs-datastructure' is loaded prior to 'korgee-korge-ldtk'.");
    }
    root['korgee-korge-ldtk'] = factory(typeof this['korgee-korge-ldtk'] === 'undefined' ? {} : this['korgee-korge-ldtk'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib'], this['kotlinx-serialization-kotlinx-serialization-json'], this['korge-root-korlibs-datastructure']);
  }
}(this, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_com_soywiz_korge_korlibs_datastructure) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
  var protoOf = kotlin_kotlin.$_$.uc;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s;
  var JsonElementSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.b;
  var IntSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
  var JsonArraySerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p1;
  var objectMeta = kotlin_kotlin.$_$.tc;
  var setMetadataFor = kotlin_kotlin.$_$.vc;
  var VOID = kotlin_kotlin.$_$.f;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x1;
  var Unit_instance = kotlin_kotlin.$_$.a5;
  var objectCreate = kotlin_kotlin.$_$.sc;
  var getStringHashCode = kotlin_kotlin.$_$.tb;
  var hashCode = kotlin_kotlin.$_$.ub;
  var THROW_CCE = kotlin_kotlin.$_$.qg;
  var equals = kotlin_kotlin.$_$.lb;
  var classMeta = kotlin_kotlin.$_$.jb;
  var DoubleSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m1;
  var LinkedHashSetSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r1;
  var IntArraySerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n;
  var Mixin = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.y;
  var toString = kotlin_kotlin.$_$.zc;
  var BooleanSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l;
  var JsonObjectSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.c;
  var getBooleanHashCode = kotlin_kotlin.$_$.pb;
  var getNumberHashCode = kotlin_kotlin.$_$.rb;
  var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.k;
  var lazy = kotlin_kotlin.$_$.oh;
  var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a1;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.q1;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var Enum = kotlin_kotlin.$_$.gg;
  var Json = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.d;
  var getKClass = kotlin_kotlin.$_$.d;
  var arrayOf = kotlin_kotlin.$_$.fh;
  var createKType = kotlin_kotlin.$_$.a;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g2;
  var isInterface = kotlin_kotlin.$_$.gc;
  //endregion
  //region block: pre-declaration
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(FieldInstance, 'FieldInstance', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(EntityInstance, 'EntityInstance', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(FieldDefinition, 'FieldDefinition', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(EntityDefinition, 'EntityDefinition', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Definitions, 'Definitions', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
  setMetadataFor($serializer_4, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(TilesetRectangle, 'TilesetRectangle', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
  setMetadataFor(Companion_3, 'Companion', objectMeta, VOID, [KSerializer, SerializerFactory]);
  setMetadataFor(AllowedRefs, 'AllowedRefs', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_3});
  setMetadataFor(Companion_4, 'Companion', objectMeta, VOID, [KSerializer, SerializerFactory]);
  setMetadataFor(EditorDisplayMode, 'EditorDisplayMode', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_4});
  setMetadataFor(Companion_5, 'Companion', objectMeta, VOID, [KSerializer, SerializerFactory]);
  setMetadataFor(EditorDisplayPos, 'EditorDisplayPos', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_5});
  setMetadataFor(Companion_6, 'Companion', objectMeta, VOID, [KSerializer, SerializerFactory]);
  setMetadataFor(TextLanguageMode, 'TextLanguageMode', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_6});
  setMetadataFor(Companion_7, 'Companion', objectMeta, VOID, [KSerializer, SerializerFactory]);
  setMetadataFor(LimitBehavior, 'LimitBehavior', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_7});
  setMetadataFor(Companion_8, 'Companion', objectMeta, VOID, [KSerializer, SerializerFactory]);
  setMetadataFor(LimitScope, 'LimitScope', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_8});
  setMetadataFor(Companion_9, 'Companion', objectMeta, VOID, [KSerializer, SerializerFactory]);
  setMetadataFor(RenderMode, 'RenderMode', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_9});
  setMetadataFor(Companion_10, 'Companion', objectMeta, VOID, [KSerializer, SerializerFactory]);
  setMetadataFor(TileRenderMode, 'TileRenderMode', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_10});
  setMetadataFor(Companion_11, 'Companion', objectMeta);
  setMetadataFor($serializer_5, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(EnumDefinition, 'EnumDefinition', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
  setMetadataFor(Companion_12, 'Companion', objectMeta);
  setMetadataFor($serializer_6, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(LayerDefinition, 'LayerDefinition', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
  setMetadataFor(Companion_13, 'Companion', objectMeta);
  setMetadataFor($serializer_7, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(TilesetDefinition, 'TilesetDefinition', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
  setMetadataFor($serializer_8, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(EnumValueDefinition, 'EnumValueDefinition', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
  setMetadataFor(Companion_14, 'Companion', objectMeta);
  setMetadataFor($serializer_9, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(AutoLayerRuleGroup, 'AutoLayerRuleGroup', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
  setMetadataFor($serializer_10, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(IntGridValueDefinition, 'IntGridValueDefinition', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
  setMetadataFor(Companion_15, 'Companion', objectMeta, VOID, [KSerializer, SerializerFactory]);
  setMetadataFor(Type, 'Type', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_15});
  setMetadataFor($serializer_11, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(TileCustomMetadata, 'TileCustomMetadata', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
  setMetadataFor(Companion_16, 'Companion', objectMeta, VOID, [KSerializer, SerializerFactory]);
  setMetadataFor(EmbedAtlas, 'EmbedAtlas', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_16});
  setMetadataFor($serializer_12, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(EnumTagValue, 'EnumTagValue', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
  setMetadataFor(Companion_17, 'Companion', objectMeta);
  setMetadataFor($serializer_13, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(AutoLayerRuleDefinition, 'AutoLayerRuleDefinition', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_13});
  setMetadataFor(Companion_18, 'Companion', objectMeta, VOID, [KSerializer, SerializerFactory]);
  setMetadataFor(Checker, 'Checker', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_18});
  setMetadataFor(Companion_19, 'Companion', objectMeta, VOID, [KSerializer, SerializerFactory]);
  setMetadataFor(TileMode, 'TileMode', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_19});
  setMetadataFor(Companion_20, 'Companion', objectMeta);
  setMetadataFor($serializer_14, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(LDTKJson, 'LDTKJson', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_14});
  setMetadataFor(Companion_21, 'Companion', objectMeta);
  setMetadataFor($serializer_15, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Level, 'Level', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
  setMetadataFor(Companion_22, 'Companion', objectMeta);
  setMetadataFor($serializer_16, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(LayerInstance, 'LayerInstance', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_16});
  setMetadataFor($serializer_17, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(TileInstance, 'TileInstance', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_17});
  setMetadataFor(Companion_23, 'Companion', objectMeta);
  setMetadataFor($serializer_18, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ForcedRefs, 'ForcedRefs', classMeta, VOID, VOID, ForcedRefs, VOID, {0: $serializer_getInstance_18});
  setMetadataFor(Companion_24, 'Companion', objectMeta, VOID, [KSerializer, SerializerFactory]);
  setMetadataFor(Flag, 'Flag', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_24});
  setMetadataFor(Companion_25, 'Companion', objectMeta, VOID, [KSerializer, SerializerFactory]);
  setMetadataFor(IdentifierStyle, 'IdentifierStyle', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_25});
  setMetadataFor(Companion_26, 'Companion', objectMeta, VOID, [KSerializer, SerializerFactory]);
  setMetadataFor(ImageExportMode, 'ImageExportMode', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_26});
  setMetadataFor(Companion_27, 'Companion', objectMeta, VOID, [KSerializer, SerializerFactory]);
  setMetadataFor(WorldLayout, 'WorldLayout', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_27});
  setMetadataFor(Companion_28, 'Companion', objectMeta);
  setMetadataFor($serializer_19, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(World, 'World', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_19});
  setMetadataFor(Companion_29, 'Companion', objectMeta);
  setMetadataFor($serializer_20, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(LevelBackgroundPosition, 'LevelBackgroundPosition', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_20});
  setMetadataFor($serializer_21, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(NeighbourLevel, 'NeighbourLevel', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_21});
  setMetadataFor(Companion_30, 'Companion', objectMeta, VOID, [KSerializer, SerializerFactory]);
  setMetadataFor(BgPos, 'BgPos', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_30});
  setMetadataFor($serializer_22, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(FieldInstanceEntityReference, 'FieldInstanceEntityReference', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_22});
  setMetadataFor($serializer_23, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(FieldInstanceGridPoint, 'FieldInstanceGridPoint', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_23});
  setMetadataFor($serializer_24, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(IntGridValueInstance, 'IntGridValueInstance', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_24});
  //endregion
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.FieldInstance', this, 6);
    tmp0_serialDesc.du('__identifier', false);
    tmp0_serialDesc.du('__tile', true);
    tmp0_serialDesc.du('__type', false);
    tmp0_serialDesc.du('__value', false);
    tmp0_serialDesc.du('defUid', false);
    tmp0_serialDesc.du('realEditorValues', false);
    this.xd4_1 = tmp0_serialDesc;
  }
  protoOf($serializer).pl = function () {
    return this.xd4_1;
  };
  protoOf($serializer).su = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable($serializer_getInstance_4()), StringSerializer_getInstance(), get_nullable(JsonElementSerializer_getInstance()), IntSerializer_getInstance(), JsonArraySerializer_getInstance()];
  };
  protoOf($serializer).ql = function (decoder) {
    var tmp0_desc = this.xd4_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = 0;
    var tmp9_local5 = null;
    var tmp10_input = decoder.no(tmp0_desc);
    if (tmp10_input.dp()) {
      tmp4_local0 = tmp10_input.xo(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.bp(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.xo(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.bp(tmp0_desc, 3, JsonElementSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.so(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.zo(tmp0_desc, 5, JsonArraySerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.xo(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.bp(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.xo(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.bp(tmp0_desc, 3, JsonElementSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.so(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.zo(tmp0_desc, 5, JsonArraySerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.oo(tmp0_desc);
    return FieldInstance_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function FieldInstance_init_$Init$(seen1, identifier, tile, type, value, defUid, realEditorValues, serializationConstructorMarker, $this) {
    if (!(61 === (61 & seen1))) {
      throwMissingFieldException(seen1, 61, $serializer_getInstance().xd4_1);
    }
    $this.yd4_1 = identifier;
    if (0 === (seen1 & 2))
      $this.zd4_1 = null;
    else
      $this.zd4_1 = tile;
    $this.ad5_1 = type;
    $this.bd5_1 = value;
    $this.cd5_1 = defUid;
    $this.dd5_1 = realEditorValues;
    return $this;
  }
  function FieldInstance_init_$Create$(seen1, identifier, tile, type, value, defUid, realEditorValues, serializationConstructorMarker) {
    return FieldInstance_init_$Init$(seen1, identifier, tile, type, value, defUid, realEditorValues, serializationConstructorMarker, objectCreate(protoOf(FieldInstance)));
  }
  function FieldInstance() {
  }
  protoOf(FieldInstance).toString = function () {
    return 'FieldInstance(identifier=' + this.yd4_1 + ', tile=' + this.zd4_1 + ', type=' + this.ad5_1 + ', value=' + this.bd5_1 + ', defUid=' + this.cd5_1 + ', realEditorValues=' + this.dd5_1 + ')';
  };
  protoOf(FieldInstance).hashCode = function () {
    var result = getStringHashCode(this.yd4_1);
    result = imul(result, 31) + (this.zd4_1 == null ? 0 : this.zd4_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.ad5_1) | 0;
    result = imul(result, 31) + (this.bd5_1 == null ? 0 : hashCode(this.bd5_1)) | 0;
    result = imul(result, 31) + this.cd5_1 | 0;
    result = imul(result, 31) + this.dd5_1.hashCode() | 0;
    return result;
  };
  protoOf(FieldInstance).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FieldInstance))
      return false;
    var tmp0_other_with_cast = other instanceof FieldInstance ? other : THROW_CCE();
    if (!(this.yd4_1 === tmp0_other_with_cast.yd4_1))
      return false;
    if (!equals(this.zd4_1, tmp0_other_with_cast.zd4_1))
      return false;
    if (!(this.ad5_1 === tmp0_other_with_cast.ad5_1))
      return false;
    if (!equals(this.bd5_1, tmp0_other_with_cast.bd5_1))
      return false;
    if (!(this.cd5_1 === tmp0_other_with_cast.cd5_1))
      return false;
    if (!this.dd5_1.equals(tmp0_other_with_cast.dd5_1))
      return false;
    return true;
  };
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.ed5_1 = [null, null, new ArrayListSerializer(DoubleSerializer_getInstance()), null, new LinkedHashSetSerializer(StringSerializer_getInstance()), null, null, new ArrayListSerializer($serializer_getInstance()), null, null, null, null];
  }
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.EntityInstance', this, 12);
    tmp0_serialDesc.du('__grid', false);
    tmp0_serialDesc.du('__identifier', false);
    tmp0_serialDesc.du('__pivot', false);
    tmp0_serialDesc.du('__smartColor', false);
    tmp0_serialDesc.du('__tags', false);
    tmp0_serialDesc.du('__tile', true);
    tmp0_serialDesc.du('defUid', false);
    tmp0_serialDesc.du('fieldInstances', false);
    tmp0_serialDesc.du('height', false);
    tmp0_serialDesc.du('iid', false);
    tmp0_serialDesc.du('px', false);
    tmp0_serialDesc.du('width', false);
    this.fd5_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).pl = function () {
    return this.fd5_1;
  };
  protoOf($serializer_0).su = function () {
    var tmp0_cached = Companion_getInstance().ed5_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntArraySerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2], StringSerializer_getInstance(), tmp0_cached[4], get_nullable($serializer_getInstance_4()), IntSerializer_getInstance(), tmp0_cached[7], IntSerializer_getInstance(), StringSerializer_getInstance(), IntArraySerializer_getInstance(), IntSerializer_getInstance()];
  };
  protoOf($serializer_0).ql = function (decoder) {
    var tmp0_desc = this.fd5_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = 0;
    var tmp11_local7 = null;
    var tmp12_local8 = 0;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = 0;
    var tmp16_input = decoder.no(tmp0_desc);
    var tmp17_cached = Companion_getInstance().ed5_1;
    if (tmp16_input.dp()) {
      tmp4_local0 = tmp16_input.zo(tmp0_desc, 0, IntArraySerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp16_input.xo(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp16_input.zo(tmp0_desc, 2, tmp17_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp16_input.xo(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp16_input.zo(tmp0_desc, 4, tmp17_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp16_input.bp(tmp0_desc, 5, $serializer_getInstance_4(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp16_input.so(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp16_input.zo(tmp0_desc, 7, tmp17_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp16_input.so(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp16_input.xo(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp16_input.zo(tmp0_desc, 10, IntArraySerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp16_input.so(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp16_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp16_input.zo(tmp0_desc, 0, IntArraySerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp16_input.xo(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp16_input.zo(tmp0_desc, 2, tmp17_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp16_input.xo(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp16_input.zo(tmp0_desc, 4, tmp17_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp16_input.bp(tmp0_desc, 5, $serializer_getInstance_4(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp16_input.so(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp16_input.zo(tmp0_desc, 7, tmp17_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp16_input.so(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp16_input.xo(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp16_input.zo(tmp0_desc, 10, IntArraySerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp16_input.so(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp16_input.oo(tmp0_desc);
    return EntityInstance_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, null);
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function EntityInstance_init_$Init$(seen1, grid, identifier, pivot, smartColor, tags, tile, defUid, fieldInstances, height, iid, px, width, serializationConstructorMarker, $this) {
    if (!(4063 === (4063 & seen1))) {
      throwMissingFieldException(seen1, 4063, $serializer_getInstance_0().fd5_1);
    }
    $this.gd5_1 = grid;
    $this.hd5_1 = identifier;
    $this.id5_1 = pivot;
    $this.jd5_1 = smartColor;
    $this.kd5_1 = tags;
    if (0 === (seen1 & 32))
      $this.ld5_1 = null;
    else
      $this.ld5_1 = tile;
    $this.md5_1 = defUid;
    $this.nd5_1 = fieldInstances;
    $this.od5_1 = height;
    $this.pd5_1 = iid;
    $this.qd5_1 = px;
    $this.rd5_1 = width;
    $this.sd5_1 = new Mixin();
    return $this;
  }
  function EntityInstance_init_$Create$(seen1, grid, identifier, pivot, smartColor, tags, tile, defUid, fieldInstances, height, iid, px, width, serializationConstructorMarker) {
    return EntityInstance_init_$Init$(seen1, grid, identifier, pivot, smartColor, tags, tile, defUid, fieldInstances, height, iid, px, width, serializationConstructorMarker, objectCreate(protoOf(EntityInstance)));
  }
  function EntityInstance() {
  }
  protoOf(EntityInstance).h23 = function (_set____db54di) {
    this.sd5_1.h23(_set____db54di);
  };
  protoOf(EntityInstance).i23 = function () {
    return this.sd5_1.i23();
  };
  protoOf(EntityInstance).toString = function () {
    return 'EntityInstance(grid=' + toString(this.gd5_1) + ', identifier=' + this.hd5_1 + ', pivot=' + this.id5_1 + ', smartColor=' + this.jd5_1 + ', tags=' + this.kd5_1 + ', tile=' + this.ld5_1 + ', defUid=' + this.md5_1 + ', fieldInstances=' + this.nd5_1 + ', height=' + this.od5_1 + ', iid=' + this.pd5_1 + ', px=' + toString(this.qd5_1) + ', width=' + this.rd5_1 + ')';
  };
  protoOf(EntityInstance).hashCode = function () {
    var result = hashCode(this.gd5_1);
    result = imul(result, 31) + getStringHashCode(this.hd5_1) | 0;
    result = imul(result, 31) + hashCode(this.id5_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.jd5_1) | 0;
    result = imul(result, 31) + hashCode(this.kd5_1) | 0;
    result = imul(result, 31) + (this.ld5_1 == null ? 0 : this.ld5_1.hashCode()) | 0;
    result = imul(result, 31) + this.md5_1 | 0;
    result = imul(result, 31) + hashCode(this.nd5_1) | 0;
    result = imul(result, 31) + this.od5_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.pd5_1) | 0;
    result = imul(result, 31) + hashCode(this.qd5_1) | 0;
    result = imul(result, 31) + this.rd5_1 | 0;
    return result;
  };
  protoOf(EntityInstance).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EntityInstance))
      return false;
    var tmp0_other_with_cast = other instanceof EntityInstance ? other : THROW_CCE();
    if (!equals(this.gd5_1, tmp0_other_with_cast.gd5_1))
      return false;
    if (!(this.hd5_1 === tmp0_other_with_cast.hd5_1))
      return false;
    if (!equals(this.id5_1, tmp0_other_with_cast.id5_1))
      return false;
    if (!(this.jd5_1 === tmp0_other_with_cast.jd5_1))
      return false;
    if (!equals(this.kd5_1, tmp0_other_with_cast.kd5_1))
      return false;
    if (!equals(this.ld5_1, tmp0_other_with_cast.ld5_1))
      return false;
    if (!(this.md5_1 === tmp0_other_with_cast.md5_1))
      return false;
    if (!equals(this.nd5_1, tmp0_other_with_cast.nd5_1))
      return false;
    if (!(this.od5_1 === tmp0_other_with_cast.od5_1))
      return false;
    if (!(this.pd5_1 === tmp0_other_with_cast.pd5_1))
      return false;
    if (!equals(this.qd5_1, tmp0_other_with_cast.qd5_1))
      return false;
    if (!(this.rd5_1 === tmp0_other_with_cast.rd5_1))
      return false;
    return true;
  };
  function Companion_0() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.xd5_1 = [null, new ArrayListSerializer(StringSerializer_getInstance()), Companion_getInstance_3().w13(), new ArrayListSerializer(StringSerializer_getInstance()), null, null, null, null, null, null, null, null, Companion_getInstance_4().w13(), Companion_getInstance_5().w13(), null, null, null, null, null, null, null, null, Companion_getInstance_6().w13(), null, null, null, null];
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.FieldDefinition', this, 27);
    tmp0_serialDesc.du('__type', false);
    tmp0_serialDesc.du('acceptFileTypes', true);
    tmp0_serialDesc.du('allowedRefs', false);
    tmp0_serialDesc.du('allowedRefTags', false);
    tmp0_serialDesc.du('allowOutOfLevelRef', false);
    tmp0_serialDesc.du('arrayMaxLength', true);
    tmp0_serialDesc.du('arrayMinLength', true);
    tmp0_serialDesc.du('autoChainRef', false);
    tmp0_serialDesc.du('canBeNull', false);
    tmp0_serialDesc.du('defaultOverride', true);
    tmp0_serialDesc.du('editorAlwaysShow', false);
    tmp0_serialDesc.du('editorCutLongValues', false);
    tmp0_serialDesc.du('editorDisplayMode', false);
    tmp0_serialDesc.du('editorDisplayPos', false);
    tmp0_serialDesc.du('editorTextPrefix', true);
    tmp0_serialDesc.du('editorTextSuffix', true);
    tmp0_serialDesc.du('identifier', false);
    tmp0_serialDesc.du('isArray', false);
    tmp0_serialDesc.du('max', true);
    tmp0_serialDesc.du('min', true);
    tmp0_serialDesc.du('regex', true);
    tmp0_serialDesc.du('symmetricalRef', false);
    tmp0_serialDesc.du('textLanguageMode', true);
    tmp0_serialDesc.du('tilesetUid', true);
    tmp0_serialDesc.du('type', false);
    tmp0_serialDesc.du('uid', false);
    tmp0_serialDesc.du('useForSmartColor', false);
    this.yd5_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).pl = function () {
    return this.yd5_1;
  };
  protoOf($serializer_1).su = function () {
    var tmp0_cached = Companion_getInstance_0().xd5_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(tmp0_cached[1]), tmp0_cached[2], tmp0_cached[3], BooleanSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(JsonObjectSerializer_getInstance()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[12], tmp0_cached[13], get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(DoubleSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), get_nullable(tmp0_cached[22]), get_nullable(IntSerializer_getInstance()), StringSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  protoOf($serializer_1).ql = function (decoder) {
    var tmp0_desc = this.yd5_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = false;
    var tmp12_local8 = false;
    var tmp13_local9 = null;
    var tmp14_local10 = false;
    var tmp15_local11 = false;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_local16 = null;
    var tmp21_local17 = false;
    var tmp22_local18 = null;
    var tmp23_local19 = null;
    var tmp24_local20 = null;
    var tmp25_local21 = false;
    var tmp26_local22 = null;
    var tmp27_local23 = null;
    var tmp28_local24 = null;
    var tmp29_local25 = 0;
    var tmp30_local26 = false;
    var tmp31_input = decoder.no(tmp0_desc);
    var tmp32_cached = Companion_getInstance_0().xd5_1;
    if (tmp31_input.dp()) {
      tmp4_local0 = tmp31_input.xo(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp31_input.bp(tmp0_desc, 1, tmp32_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp31_input.zo(tmp0_desc, 2, tmp32_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp31_input.zo(tmp0_desc, 3, tmp32_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp31_input.po(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp31_input.bp(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp31_input.bp(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp31_input.po(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp31_input.po(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp31_input.bp(tmp0_desc, 9, JsonObjectSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp31_input.po(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp31_input.po(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp31_input.zo(tmp0_desc, 12, tmp32_cached[12], tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp31_input.zo(tmp0_desc, 13, tmp32_cached[13], tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp31_input.bp(tmp0_desc, 14, StringSerializer_getInstance(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp31_input.bp(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp31_input.xo(tmp0_desc, 16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp31_input.po(tmp0_desc, 17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp31_input.bp(tmp0_desc, 18, DoubleSerializer_getInstance(), tmp22_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp31_input.bp(tmp0_desc, 19, DoubleSerializer_getInstance(), tmp23_local19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp31_input.bp(tmp0_desc, 20, StringSerializer_getInstance(), tmp24_local20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp31_input.po(tmp0_desc, 21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp26_local22 = tmp31_input.bp(tmp0_desc, 22, tmp32_cached[22], tmp26_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
      tmp27_local23 = tmp31_input.bp(tmp0_desc, 23, IntSerializer_getInstance(), tmp27_local23);
      tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
      tmp28_local24 = tmp31_input.xo(tmp0_desc, 24);
      tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
      tmp29_local25 = tmp31_input.so(tmp0_desc, 25);
      tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
      tmp30_local26 = tmp31_input.po(tmp0_desc, 26);
      tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp31_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp31_input.xo(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp31_input.bp(tmp0_desc, 1, tmp32_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp31_input.zo(tmp0_desc, 2, tmp32_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp31_input.zo(tmp0_desc, 3, tmp32_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp31_input.po(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp31_input.bp(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp31_input.bp(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp31_input.po(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp31_input.po(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp31_input.bp(tmp0_desc, 9, JsonObjectSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp31_input.po(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp31_input.po(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp31_input.zo(tmp0_desc, 12, tmp32_cached[12], tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp31_input.zo(tmp0_desc, 13, tmp32_cached[13], tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp31_input.bp(tmp0_desc, 14, StringSerializer_getInstance(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp31_input.bp(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp31_input.xo(tmp0_desc, 16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp31_input.po(tmp0_desc, 17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp31_input.bp(tmp0_desc, 18, DoubleSerializer_getInstance(), tmp22_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp31_input.bp(tmp0_desc, 19, DoubleSerializer_getInstance(), tmp23_local19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp31_input.bp(tmp0_desc, 20, StringSerializer_getInstance(), tmp24_local20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp31_input.po(tmp0_desc, 21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp26_local22 = tmp31_input.bp(tmp0_desc, 22, tmp32_cached[22], tmp26_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          case 23:
            tmp27_local23 = tmp31_input.bp(tmp0_desc, 23, IntSerializer_getInstance(), tmp27_local23);
            tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
            break;
          case 24:
            tmp28_local24 = tmp31_input.xo(tmp0_desc, 24);
            tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
            break;
          case 25:
            tmp29_local25 = tmp31_input.so(tmp0_desc, 25);
            tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
            break;
          case 26:
            tmp30_local26 = tmp31_input.po(tmp0_desc, 26);
            tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp31_input.oo(tmp0_desc);
    return FieldDefinition_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, tmp28_local24, tmp29_local25, tmp30_local26, null);
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function FieldDefinition_init_$Init$(seen1, type, acceptFileTypes, allowedRefs, allowedRefTags, allowOutOfLevelRef, arrayMaxLength, arrayMinLength, autoChainRef, canBeNull, defaultOverride, editorAlwaysShow, editorCutLongValues, editorDisplayMode, editorDisplayPos, editorTextPrefix, editorTextSuffix, identifier, isArray, max, min, regex, symmetricalRef, textLanguageMode, tilesetUid, fieldDefinitionType, uid, useForSmartColor, serializationConstructorMarker, $this) {
    if (!(119750045 === (119750045 & seen1))) {
      throwMissingFieldException(seen1, 119750045, $serializer_getInstance_1().yd5_1);
    }
    $this.zd5_1 = type;
    if (0 === (seen1 & 2))
      $this.ad6_1 = null;
    else
      $this.ad6_1 = acceptFileTypes;
    $this.bd6_1 = allowedRefs;
    $this.cd6_1 = allowedRefTags;
    $this.dd6_1 = allowOutOfLevelRef;
    if (0 === (seen1 & 32))
      $this.ed6_1 = null;
    else
      $this.ed6_1 = arrayMaxLength;
    if (0 === (seen1 & 64))
      $this.fd6_1 = null;
    else
      $this.fd6_1 = arrayMinLength;
    $this.gd6_1 = autoChainRef;
    $this.hd6_1 = canBeNull;
    if (0 === (seen1 & 512))
      $this.id6_1 = null;
    else
      $this.id6_1 = defaultOverride;
    $this.jd6_1 = editorAlwaysShow;
    $this.kd6_1 = editorCutLongValues;
    $this.ld6_1 = editorDisplayMode;
    $this.md6_1 = editorDisplayPos;
    if (0 === (seen1 & 16384))
      $this.nd6_1 = null;
    else
      $this.nd6_1 = editorTextPrefix;
    if (0 === (seen1 & 32768))
      $this.od6_1 = null;
    else
      $this.od6_1 = editorTextSuffix;
    $this.pd6_1 = identifier;
    $this.qd6_1 = isArray;
    if (0 === (seen1 & 262144))
      $this.rd6_1 = null;
    else
      $this.rd6_1 = max;
    if (0 === (seen1 & 524288))
      $this.sd6_1 = null;
    else
      $this.sd6_1 = min;
    if (0 === (seen1 & 1048576))
      $this.td6_1 = null;
    else
      $this.td6_1 = regex;
    $this.ud6_1 = symmetricalRef;
    if (0 === (seen1 & 4194304))
      $this.vd6_1 = null;
    else
      $this.vd6_1 = textLanguageMode;
    if (0 === (seen1 & 8388608))
      $this.wd6_1 = null;
    else
      $this.wd6_1 = tilesetUid;
    $this.xd6_1 = fieldDefinitionType;
    $this.yd6_1 = uid;
    $this.zd6_1 = useForSmartColor;
    return $this;
  }
  function FieldDefinition_init_$Create$(seen1, type, acceptFileTypes, allowedRefs, allowedRefTags, allowOutOfLevelRef, arrayMaxLength, arrayMinLength, autoChainRef, canBeNull, defaultOverride, editorAlwaysShow, editorCutLongValues, editorDisplayMode, editorDisplayPos, editorTextPrefix, editorTextSuffix, identifier, isArray, max, min, regex, symmetricalRef, textLanguageMode, tilesetUid, fieldDefinitionType, uid, useForSmartColor, serializationConstructorMarker) {
    return FieldDefinition_init_$Init$(seen1, type, acceptFileTypes, allowedRefs, allowedRefTags, allowOutOfLevelRef, arrayMaxLength, arrayMinLength, autoChainRef, canBeNull, defaultOverride, editorAlwaysShow, editorCutLongValues, editorDisplayMode, editorDisplayPos, editorTextPrefix, editorTextSuffix, identifier, isArray, max, min, regex, symmetricalRef, textLanguageMode, tilesetUid, fieldDefinitionType, uid, useForSmartColor, serializationConstructorMarker, objectCreate(protoOf(FieldDefinition)));
  }
  function FieldDefinition() {
  }
  protoOf(FieldDefinition).toString = function () {
    return 'FieldDefinition(type=' + this.zd5_1 + ', acceptFileTypes=' + this.ad6_1 + ', allowedRefs=' + this.bd6_1 + ', allowedRefTags=' + this.cd6_1 + ', allowOutOfLevelRef=' + this.dd6_1 + ', arrayMaxLength=' + this.ed6_1 + ', arrayMinLength=' + this.fd6_1 + ', autoChainRef=' + this.gd6_1 + ', canBeNull=' + this.hd6_1 + ', defaultOverride=' + this.id6_1 + ', editorAlwaysShow=' + this.jd6_1 + ', editorCutLongValues=' + this.kd6_1 + ', editorDisplayMode=' + this.ld6_1 + ', editorDisplayPos=' + this.md6_1 + ', editorTextPrefix=' + this.nd6_1 + ', editorTextSuffix=' + this.od6_1 + ', identifier=' + this.pd6_1 + ', isArray=' + this.qd6_1 + ', max=' + this.rd6_1 + ', min=' + this.sd6_1 + ', regex=' + this.td6_1 + ', symmetricalRef=' + this.ud6_1 + ', textLanguageMode=' + this.vd6_1 + ', tilesetUid=' + this.wd6_1 + ', fieldDefinitionType=' + this.xd6_1 + ', uid=' + this.yd6_1 + ', useForSmartColor=' + this.zd6_1 + ')';
  };
  protoOf(FieldDefinition).hashCode = function () {
    var result = getStringHashCode(this.zd5_1);
    result = imul(result, 31) + (this.ad6_1 == null ? 0 : hashCode(this.ad6_1)) | 0;
    result = imul(result, 31) + this.bd6_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.cd6_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.dd6_1) | 0;
    result = imul(result, 31) + (this.ed6_1 == null ? 0 : this.ed6_1) | 0;
    result = imul(result, 31) + (this.fd6_1 == null ? 0 : this.fd6_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.gd6_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.hd6_1) | 0;
    result = imul(result, 31) + (this.id6_1 == null ? 0 : this.id6_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.jd6_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.kd6_1) | 0;
    result = imul(result, 31) + this.ld6_1.hashCode() | 0;
    result = imul(result, 31) + this.md6_1.hashCode() | 0;
    result = imul(result, 31) + (this.nd6_1 == null ? 0 : getStringHashCode(this.nd6_1)) | 0;
    result = imul(result, 31) + (this.od6_1 == null ? 0 : getStringHashCode(this.od6_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.pd6_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.qd6_1) | 0;
    result = imul(result, 31) + (this.rd6_1 == null ? 0 : getNumberHashCode(this.rd6_1)) | 0;
    result = imul(result, 31) + (this.sd6_1 == null ? 0 : getNumberHashCode(this.sd6_1)) | 0;
    result = imul(result, 31) + (this.td6_1 == null ? 0 : getStringHashCode(this.td6_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ud6_1) | 0;
    result = imul(result, 31) + (this.vd6_1 == null ? 0 : this.vd6_1.hashCode()) | 0;
    result = imul(result, 31) + (this.wd6_1 == null ? 0 : this.wd6_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.xd6_1) | 0;
    result = imul(result, 31) + this.yd6_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.zd6_1) | 0;
    return result;
  };
  protoOf(FieldDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FieldDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof FieldDefinition ? other : THROW_CCE();
    if (!(this.zd5_1 === tmp0_other_with_cast.zd5_1))
      return false;
    if (!equals(this.ad6_1, tmp0_other_with_cast.ad6_1))
      return false;
    if (!this.bd6_1.equals(tmp0_other_with_cast.bd6_1))
      return false;
    if (!equals(this.cd6_1, tmp0_other_with_cast.cd6_1))
      return false;
    if (!(this.dd6_1 === tmp0_other_with_cast.dd6_1))
      return false;
    if (!(this.ed6_1 == tmp0_other_with_cast.ed6_1))
      return false;
    if (!(this.fd6_1 == tmp0_other_with_cast.fd6_1))
      return false;
    if (!(this.gd6_1 === tmp0_other_with_cast.gd6_1))
      return false;
    if (!(this.hd6_1 === tmp0_other_with_cast.hd6_1))
      return false;
    if (!equals(this.id6_1, tmp0_other_with_cast.id6_1))
      return false;
    if (!(this.jd6_1 === tmp0_other_with_cast.jd6_1))
      return false;
    if (!(this.kd6_1 === tmp0_other_with_cast.kd6_1))
      return false;
    if (!this.ld6_1.equals(tmp0_other_with_cast.ld6_1))
      return false;
    if (!this.md6_1.equals(tmp0_other_with_cast.md6_1))
      return false;
    if (!(this.nd6_1 == tmp0_other_with_cast.nd6_1))
      return false;
    if (!(this.od6_1 == tmp0_other_with_cast.od6_1))
      return false;
    if (!(this.pd6_1 === tmp0_other_with_cast.pd6_1))
      return false;
    if (!(this.qd6_1 === tmp0_other_with_cast.qd6_1))
      return false;
    if (!equals(this.rd6_1, tmp0_other_with_cast.rd6_1))
      return false;
    if (!equals(this.sd6_1, tmp0_other_with_cast.sd6_1))
      return false;
    if (!(this.td6_1 == tmp0_other_with_cast.td6_1))
      return false;
    if (!(this.ud6_1 === tmp0_other_with_cast.ud6_1))
      return false;
    if (!equals(this.vd6_1, tmp0_other_with_cast.vd6_1))
      return false;
    if (!(this.wd6_1 == tmp0_other_with_cast.wd6_1))
      return false;
    if (!(this.xd6_1 === tmp0_other_with_cast.xd6_1))
      return false;
    if (!(this.yd6_1 === tmp0_other_with_cast.yd6_1))
      return false;
    if (!(this.zd6_1 === tmp0_other_with_cast.zd6_1))
      return false;
    return true;
  };
  function Companion_1() {
    Companion_instance_1 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.ed7_1 = [null, new ArrayListSerializer($serializer_getInstance_1()), null, null, null, null, null, Companion_getInstance_7().w13(), Companion_getInstance_8().w13(), null, null, null, null, null, Companion_getInstance_9().w13(), null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null, Companion_getInstance_10().w13(), null, null, null];
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.EntityDefinition', this, 25);
    tmp0_serialDesc.du('color', false);
    tmp0_serialDesc.du('fieldDefs', false);
    tmp0_serialDesc.du('fillOpacity', false);
    tmp0_serialDesc.du('height', false);
    tmp0_serialDesc.du('hollow', false);
    tmp0_serialDesc.du('identifier', false);
    tmp0_serialDesc.du('keepAspectRatio', false);
    tmp0_serialDesc.du('limitBehavior', false);
    tmp0_serialDesc.du('limitScope', false);
    tmp0_serialDesc.du('lineOpacity', false);
    tmp0_serialDesc.du('maxCount', false);
    tmp0_serialDesc.du('nineSliceBorders', false);
    tmp0_serialDesc.du('pivotX', false);
    tmp0_serialDesc.du('pivotY', false);
    tmp0_serialDesc.du('renderMode', false);
    tmp0_serialDesc.du('resizableX', false);
    tmp0_serialDesc.du('resizableY', false);
    tmp0_serialDesc.du('showName', false);
    tmp0_serialDesc.du('tags', false);
    tmp0_serialDesc.du('tileOpacity', false);
    tmp0_serialDesc.du('tileRect', true);
    tmp0_serialDesc.du('tileRenderMode', false);
    tmp0_serialDesc.du('tilesetId', true);
    tmp0_serialDesc.du('uid', false);
    tmp0_serialDesc.du('width', false);
    this.fd7_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).pl = function () {
    return this.fd7_1;
  };
  protoOf($serializer_2).su = function () {
    var tmp0_cached = Companion_getInstance_1().ed7_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], DoubleSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[7], tmp0_cached[8], DoubleSerializer_getInstance(), IntSerializer_getInstance(), IntArraySerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), tmp0_cached[14], BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[18], DoubleSerializer_getInstance(), get_nullable($serializer_getInstance_4()), tmp0_cached[21], get_nullable(IntSerializer_getInstance()), IntSerializer_getInstance(), IntSerializer_getInstance()];
  };
  protoOf($serializer_2).ql = function (decoder) {
    var tmp0_desc = this.fd7_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = 0;
    var tmp8_local4 = false;
    var tmp9_local5 = null;
    var tmp10_local6 = false;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = 0.0;
    var tmp14_local10 = 0;
    var tmp15_local11 = null;
    var tmp16_local12 = 0.0;
    var tmp17_local13 = 0.0;
    var tmp18_local14 = null;
    var tmp19_local15 = false;
    var tmp20_local16 = false;
    var tmp21_local17 = false;
    var tmp22_local18 = null;
    var tmp23_local19 = 0.0;
    var tmp24_local20 = null;
    var tmp25_local21 = null;
    var tmp26_local22 = null;
    var tmp27_local23 = 0;
    var tmp28_local24 = 0;
    var tmp29_input = decoder.no(tmp0_desc);
    var tmp30_cached = Companion_getInstance_1().ed7_1;
    if (tmp29_input.dp()) {
      tmp4_local0 = tmp29_input.xo(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp29_input.zo(tmp0_desc, 1, tmp30_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp29_input.vo(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp29_input.so(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp29_input.po(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp29_input.xo(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp29_input.po(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp29_input.zo(tmp0_desc, 7, tmp30_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp29_input.zo(tmp0_desc, 8, tmp30_cached[8], tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp29_input.vo(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp29_input.so(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp29_input.zo(tmp0_desc, 11, IntArraySerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp29_input.vo(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp29_input.vo(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp29_input.zo(tmp0_desc, 14, tmp30_cached[14], tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp29_input.po(tmp0_desc, 15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp29_input.po(tmp0_desc, 16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp29_input.po(tmp0_desc, 17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp29_input.zo(tmp0_desc, 18, tmp30_cached[18], tmp22_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp29_input.vo(tmp0_desc, 19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp29_input.bp(tmp0_desc, 20, $serializer_getInstance_4(), tmp24_local20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp29_input.zo(tmp0_desc, 21, tmp30_cached[21], tmp25_local21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp26_local22 = tmp29_input.bp(tmp0_desc, 22, IntSerializer_getInstance(), tmp26_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
      tmp27_local23 = tmp29_input.so(tmp0_desc, 23);
      tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
      tmp28_local24 = tmp29_input.so(tmp0_desc, 24);
      tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp29_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp29_input.xo(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp29_input.zo(tmp0_desc, 1, tmp30_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp29_input.vo(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp29_input.so(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp29_input.po(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp29_input.xo(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp29_input.po(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp29_input.zo(tmp0_desc, 7, tmp30_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp29_input.zo(tmp0_desc, 8, tmp30_cached[8], tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp29_input.vo(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp29_input.so(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp29_input.zo(tmp0_desc, 11, IntArraySerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp29_input.vo(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp29_input.vo(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp29_input.zo(tmp0_desc, 14, tmp30_cached[14], tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp29_input.po(tmp0_desc, 15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp29_input.po(tmp0_desc, 16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp29_input.po(tmp0_desc, 17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp29_input.zo(tmp0_desc, 18, tmp30_cached[18], tmp22_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp29_input.vo(tmp0_desc, 19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp29_input.bp(tmp0_desc, 20, $serializer_getInstance_4(), tmp24_local20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp29_input.zo(tmp0_desc, 21, tmp30_cached[21], tmp25_local21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp26_local22 = tmp29_input.bp(tmp0_desc, 22, IntSerializer_getInstance(), tmp26_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          case 23:
            tmp27_local23 = tmp29_input.so(tmp0_desc, 23);
            tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
            break;
          case 24:
            tmp28_local24 = tmp29_input.so(tmp0_desc, 24);
            tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp29_input.oo(tmp0_desc);
    return EntityDefinition_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, tmp28_local24, null);
  };
  var $serializer_instance_2;
  function $serializer_getInstance_2() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function EntityDefinition_init_$Init$(seen1, color, fieldDefs, fillOpacity, height, hollow, identifier, keepAspectRatio, limitBehavior, limitScope, lineOpacity, maxCount, nineSliceBorders, pivotX, pivotY, renderMode, resizableX, resizableY, showName, tags, tileOpacity, tileRect, tileRenderMode, tilesetID, uid, width, serializationConstructorMarker, $this) {
    if (!(28311551 === (28311551 & seen1))) {
      throwMissingFieldException(seen1, 28311551, $serializer_getInstance_2().fd7_1);
    }
    $this.gd7_1 = color;
    $this.hd7_1 = fieldDefs;
    $this.id7_1 = fillOpacity;
    $this.jd7_1 = height;
    $this.kd7_1 = hollow;
    $this.ld7_1 = identifier;
    $this.md7_1 = keepAspectRatio;
    $this.nd7_1 = limitBehavior;
    $this.od7_1 = limitScope;
    $this.pd7_1 = lineOpacity;
    $this.qd7_1 = maxCount;
    $this.rd7_1 = nineSliceBorders;
    $this.sd7_1 = pivotX;
    $this.td7_1 = pivotY;
    $this.ud7_1 = renderMode;
    $this.vd7_1 = resizableX;
    $this.wd7_1 = resizableY;
    $this.xd7_1 = showName;
    $this.yd7_1 = tags;
    $this.zd7_1 = tileOpacity;
    if (0 === (seen1 & 1048576))
      $this.ad8_1 = null;
    else
      $this.ad8_1 = tileRect;
    $this.bd8_1 = tileRenderMode;
    if (0 === (seen1 & 4194304))
      $this.cd8_1 = null;
    else
      $this.cd8_1 = tilesetID;
    $this.dd8_1 = uid;
    $this.ed8_1 = width;
    $this.fd8_1 = new Mixin();
    return $this;
  }
  function EntityDefinition_init_$Create$(seen1, color, fieldDefs, fillOpacity, height, hollow, identifier, keepAspectRatio, limitBehavior, limitScope, lineOpacity, maxCount, nineSliceBorders, pivotX, pivotY, renderMode, resizableX, resizableY, showName, tags, tileOpacity, tileRect, tileRenderMode, tilesetID, uid, width, serializationConstructorMarker) {
    return EntityDefinition_init_$Init$(seen1, color, fieldDefs, fillOpacity, height, hollow, identifier, keepAspectRatio, limitBehavior, limitScope, lineOpacity, maxCount, nineSliceBorders, pivotX, pivotY, renderMode, resizableX, resizableY, showName, tags, tileOpacity, tileRect, tileRenderMode, tilesetID, uid, width, serializationConstructorMarker, objectCreate(protoOf(EntityDefinition)));
  }
  function EntityDefinition() {
  }
  protoOf(EntityDefinition).h23 = function (_set____db54di) {
    this.fd8_1.h23(_set____db54di);
  };
  protoOf(EntityDefinition).i23 = function () {
    return this.fd8_1.i23();
  };
  protoOf(EntityDefinition).toString = function () {
    return 'EntityDefinition(color=' + this.gd7_1 + ', fieldDefs=' + this.hd7_1 + ', fillOpacity=' + this.id7_1 + ', height=' + this.jd7_1 + ', hollow=' + this.kd7_1 + ', identifier=' + this.ld7_1 + ', keepAspectRatio=' + this.md7_1 + ', limitBehavior=' + this.nd7_1 + ', limitScope=' + this.od7_1 + ', lineOpacity=' + this.pd7_1 + ', maxCount=' + this.qd7_1 + ', nineSliceBorders=' + toString(this.rd7_1) + ', pivotX=' + this.sd7_1 + ', pivotY=' + this.td7_1 + ', renderMode=' + this.ud7_1 + ', resizableX=' + this.vd7_1 + ', resizableY=' + this.wd7_1 + ', showName=' + this.xd7_1 + ', tags=' + this.yd7_1 + ', tileOpacity=' + this.zd7_1 + ', tileRect=' + this.ad8_1 + ', tileRenderMode=' + this.bd8_1 + ', tilesetID=' + this.cd8_1 + ', uid=' + this.dd8_1 + ', width=' + this.ed8_1 + ')';
  };
  protoOf(EntityDefinition).hashCode = function () {
    var result = getStringHashCode(this.gd7_1);
    result = imul(result, 31) + hashCode(this.hd7_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.id7_1) | 0;
    result = imul(result, 31) + this.jd7_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.kd7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ld7_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.md7_1) | 0;
    result = imul(result, 31) + this.nd7_1.hashCode() | 0;
    result = imul(result, 31) + this.od7_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.pd7_1) | 0;
    result = imul(result, 31) + this.qd7_1 | 0;
    result = imul(result, 31) + hashCode(this.rd7_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.sd7_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.td7_1) | 0;
    result = imul(result, 31) + this.ud7_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.vd7_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.wd7_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.xd7_1) | 0;
    result = imul(result, 31) + hashCode(this.yd7_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.zd7_1) | 0;
    result = imul(result, 31) + (this.ad8_1 == null ? 0 : this.ad8_1.hashCode()) | 0;
    result = imul(result, 31) + this.bd8_1.hashCode() | 0;
    result = imul(result, 31) + (this.cd8_1 == null ? 0 : this.cd8_1) | 0;
    result = imul(result, 31) + this.dd8_1 | 0;
    result = imul(result, 31) + this.ed8_1 | 0;
    return result;
  };
  protoOf(EntityDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EntityDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof EntityDefinition ? other : THROW_CCE();
    if (!(this.gd7_1 === tmp0_other_with_cast.gd7_1))
      return false;
    if (!equals(this.hd7_1, tmp0_other_with_cast.hd7_1))
      return false;
    if (!equals(this.id7_1, tmp0_other_with_cast.id7_1))
      return false;
    if (!(this.jd7_1 === tmp0_other_with_cast.jd7_1))
      return false;
    if (!(this.kd7_1 === tmp0_other_with_cast.kd7_1))
      return false;
    if (!(this.ld7_1 === tmp0_other_with_cast.ld7_1))
      return false;
    if (!(this.md7_1 === tmp0_other_with_cast.md7_1))
      return false;
    if (!this.nd7_1.equals(tmp0_other_with_cast.nd7_1))
      return false;
    if (!this.od7_1.equals(tmp0_other_with_cast.od7_1))
      return false;
    if (!equals(this.pd7_1, tmp0_other_with_cast.pd7_1))
      return false;
    if (!(this.qd7_1 === tmp0_other_with_cast.qd7_1))
      return false;
    if (!equals(this.rd7_1, tmp0_other_with_cast.rd7_1))
      return false;
    if (!equals(this.sd7_1, tmp0_other_with_cast.sd7_1))
      return false;
    if (!equals(this.td7_1, tmp0_other_with_cast.td7_1))
      return false;
    if (!this.ud7_1.equals(tmp0_other_with_cast.ud7_1))
      return false;
    if (!(this.vd7_1 === tmp0_other_with_cast.vd7_1))
      return false;
    if (!(this.wd7_1 === tmp0_other_with_cast.wd7_1))
      return false;
    if (!(this.xd7_1 === tmp0_other_with_cast.xd7_1))
      return false;
    if (!equals(this.yd7_1, tmp0_other_with_cast.yd7_1))
      return false;
    if (!equals(this.zd7_1, tmp0_other_with_cast.zd7_1))
      return false;
    if (!equals(this.ad8_1, tmp0_other_with_cast.ad8_1))
      return false;
    if (!this.bd8_1.equals(tmp0_other_with_cast.bd8_1))
      return false;
    if (!(this.cd8_1 == tmp0_other_with_cast.cd8_1))
      return false;
    if (!(this.dd8_1 === tmp0_other_with_cast.dd8_1))
      return false;
    if (!(this.ed8_1 === tmp0_other_with_cast.ed8_1))
      return false;
    return true;
  };
  function Companion_2() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.gd8_1 = [new ArrayListSerializer($serializer_getInstance_2()), new ArrayListSerializer($serializer_getInstance_5()), new ArrayListSerializer($serializer_getInstance_5()), new ArrayListSerializer($serializer_getInstance_6()), new ArrayListSerializer($serializer_getInstance_1()), new ArrayListSerializer($serializer_getInstance_7())];
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.Definitions', this, 6);
    tmp0_serialDesc.du('entities', false);
    tmp0_serialDesc.du('enums', false);
    tmp0_serialDesc.du('externalEnums', false);
    tmp0_serialDesc.du('layers', false);
    tmp0_serialDesc.du('levelFields', false);
    tmp0_serialDesc.du('tilesets', false);
    this.hd8_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).pl = function () {
    return this.hd8_1;
  };
  protoOf($serializer_3).su = function () {
    var tmp0_cached = Companion_getInstance_2().gd8_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1], tmp0_cached[2], tmp0_cached[3], tmp0_cached[4], tmp0_cached[5]];
  };
  protoOf($serializer_3).ql = function (decoder) {
    var tmp0_desc = this.hd8_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.no(tmp0_desc);
    var tmp11_cached = Companion_getInstance_2().gd8_1;
    if (tmp10_input.dp()) {
      tmp4_local0 = tmp10_input.zo(tmp0_desc, 0, tmp11_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.zo(tmp0_desc, 1, tmp11_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.zo(tmp0_desc, 2, tmp11_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.zo(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.zo(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.zo(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.zo(tmp0_desc, 0, tmp11_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.zo(tmp0_desc, 1, tmp11_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.zo(tmp0_desc, 2, tmp11_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.zo(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.zo(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.zo(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.oo(tmp0_desc);
    return Definitions_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  var $serializer_instance_3;
  function $serializer_getInstance_3() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function Definitions_init_$Init$(seen1, entities, enums, externalEnums, layers, levelFields, tilesets, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen1))) {
      throwMissingFieldException(seen1, 63, $serializer_getInstance_3().hd8_1);
    }
    $this.id8_1 = entities;
    $this.jd8_1 = enums;
    $this.kd8_1 = externalEnums;
    $this.ld8_1 = layers;
    $this.md8_1 = levelFields;
    $this.nd8_1 = tilesets;
    $this.od8_1 = new Mixin();
    return $this;
  }
  function Definitions_init_$Create$(seen1, entities, enums, externalEnums, layers, levelFields, tilesets, serializationConstructorMarker) {
    return Definitions_init_$Init$(seen1, entities, enums, externalEnums, layers, levelFields, tilesets, serializationConstructorMarker, objectCreate(protoOf(Definitions)));
  }
  function Definitions() {
  }
  protoOf(Definitions).h23 = function (_set____db54di) {
    this.od8_1.h23(_set____db54di);
  };
  protoOf(Definitions).i23 = function () {
    return this.od8_1.i23();
  };
  protoOf(Definitions).toString = function () {
    return 'Definitions(entities=' + this.id8_1 + ', enums=' + this.jd8_1 + ', externalEnums=' + this.kd8_1 + ', layers=' + this.ld8_1 + ', levelFields=' + this.md8_1 + ', tilesets=' + this.nd8_1 + ')';
  };
  protoOf(Definitions).hashCode = function () {
    var result = hashCode(this.id8_1);
    result = imul(result, 31) + hashCode(this.jd8_1) | 0;
    result = imul(result, 31) + hashCode(this.kd8_1) | 0;
    result = imul(result, 31) + hashCode(this.ld8_1) | 0;
    result = imul(result, 31) + hashCode(this.md8_1) | 0;
    result = imul(result, 31) + hashCode(this.nd8_1) | 0;
    return result;
  };
  protoOf(Definitions).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Definitions))
      return false;
    var tmp0_other_with_cast = other instanceof Definitions ? other : THROW_CCE();
    if (!equals(this.id8_1, tmp0_other_with_cast.id8_1))
      return false;
    if (!equals(this.jd8_1, tmp0_other_with_cast.jd8_1))
      return false;
    if (!equals(this.kd8_1, tmp0_other_with_cast.kd8_1))
      return false;
    if (!equals(this.ld8_1, tmp0_other_with_cast.ld8_1))
      return false;
    if (!equals(this.md8_1, tmp0_other_with_cast.md8_1))
      return false;
    if (!equals(this.nd8_1, tmp0_other_with_cast.nd8_1))
      return false;
    return true;
  };
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.TilesetRectangle', this, 5);
    tmp0_serialDesc.du('h', false);
    tmp0_serialDesc.du('tilesetUid', false);
    tmp0_serialDesc.du('w', false);
    tmp0_serialDesc.du('x', false);
    tmp0_serialDesc.du('y', false);
    this.pd8_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).pl = function () {
    return this.pd8_1;
  };
  protoOf($serializer_4).su = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
  };
  protoOf($serializer_4).ql = function (decoder) {
    var tmp0_desc = this.pd8_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_local4 = 0;
    var tmp9_input = decoder.no(tmp0_desc);
    if (tmp9_input.dp()) {
      tmp4_local0 = tmp9_input.so(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.so(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.so(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.so(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.so(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.so(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.so(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.so(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.so(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.so(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.oo(tmp0_desc);
    return TilesetRectangle_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  var $serializer_instance_4;
  function $serializer_getInstance_4() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function TilesetRectangle_init_$Init$(seen1, h, tilesetUid, w, x, y, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen1))) {
      throwMissingFieldException(seen1, 31, $serializer_getInstance_4().pd8_1);
    }
    $this.qd8_1 = h;
    $this.rd8_1 = tilesetUid;
    $this.sd8_1 = w;
    $this.td8_1 = x;
    $this.ud8_1 = y;
    return $this;
  }
  function TilesetRectangle_init_$Create$(seen1, h, tilesetUid, w, x, y, serializationConstructorMarker) {
    return TilesetRectangle_init_$Init$(seen1, h, tilesetUid, w, x, y, serializationConstructorMarker, objectCreate(protoOf(TilesetRectangle)));
  }
  function TilesetRectangle() {
  }
  protoOf(TilesetRectangle).toString = function () {
    return 'TilesetRectangle(h=' + this.qd8_1 + ', tilesetUid=' + this.rd8_1 + ', w=' + this.sd8_1 + ', x=' + this.td8_1 + ', y=' + this.ud8_1 + ')';
  };
  protoOf(TilesetRectangle).hashCode = function () {
    var result = this.qd8_1;
    result = imul(result, 31) + this.rd8_1 | 0;
    result = imul(result, 31) + this.sd8_1 | 0;
    result = imul(result, 31) + this.td8_1 | 0;
    result = imul(result, 31) + this.ud8_1 | 0;
    return result;
  };
  protoOf(TilesetRectangle).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TilesetRectangle))
      return false;
    var tmp0_other_with_cast = other instanceof TilesetRectangle ? other : THROW_CCE();
    if (!(this.qd8_1 === tmp0_other_with_cast.qd8_1))
      return false;
    if (!(this.rd8_1 === tmp0_other_with_cast.rd8_1))
      return false;
    if (!(this.sd8_1 === tmp0_other_with_cast.sd8_1))
      return false;
    if (!(this.td8_1 === tmp0_other_with_cast.td8_1))
      return false;
    if (!(this.ud8_1 === tmp0_other_with_cast.ud8_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.td5_1.m2();
  }
  function AllowedRefs$Companion$_anonymous__v2lmwp() {
    return createSimpleEnumSerializer('korlibs.korge.ldtk.AllowedRefs', values());
  }
  var AllowedRefs_Any_instance;
  var AllowedRefs_OnlySame_instance;
  var AllowedRefs_OnlyTags_instance;
  function Companion_3() {
    Companion_instance_3 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.td5_1 = lazy(tmp_0, AllowedRefs$Companion$_anonymous__v2lmwp);
  }
  protoOf(Companion_3).pl = function () {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.AllowedRefs', STRING_getInstance());
  };
  protoOf(Companion_3).ql = function (decoder) {
    var value = decoder.io();
    var tmp;
    switch (value) {
      case 'Any':
        tmp = AllowedRefs_Any_getInstance();
        break;
      case 'OnlySame':
        tmp = AllowedRefs_OnlySame_getInstance();
        break;
      case 'OnlyTags':
        tmp = AllowedRefs_OnlyTags_getInstance();
        break;
      default:
        throw IllegalArgumentException_init_$Create$('AllowedRefs could not parse: ' + value);
    }
    return tmp;
  };
  protoOf(Companion_3).w13 = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(Companion_3).bv = function (typeParamsSerializers) {
    return this.w13();
  };
  var Companion_instance_3;
  function Companion_getInstance_3() {
    AllowedRefs_initEntries();
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function values() {
    return [AllowedRefs_Any_getInstance(), AllowedRefs_OnlySame_getInstance(), AllowedRefs_OnlyTags_getInstance()];
  }
  var AllowedRefs_entriesInitialized;
  function AllowedRefs_initEntries() {
    if (AllowedRefs_entriesInitialized)
      return Unit_instance;
    AllowedRefs_entriesInitialized = true;
    AllowedRefs_Any_instance = new AllowedRefs('Any', 0, 'Any');
    AllowedRefs_OnlySame_instance = new AllowedRefs('OnlySame', 1, 'OnlySame');
    AllowedRefs_OnlyTags_instance = new AllowedRefs('OnlyTags', 2, 'OnlyTags');
    Companion_getInstance_3();
  }
  function AllowedRefs(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.xd8_1 = value;
  }
  function _get_$cachedSerializer__te6jhj_0($this) {
    return $this.ud5_1.m2();
  }
  function EditorDisplayMode$Companion$_anonymous__77qsc7() {
    return createSimpleEnumSerializer('korlibs.korge.ldtk.EditorDisplayMode', values_0());
  }
  var EditorDisplayMode_ArrayCountNoLabel_instance;
  var EditorDisplayMode_ArrayCountWithLabel_instance;
  var EditorDisplayMode_EntityTile_instance;
  var EditorDisplayMode_Hidden_instance;
  var EditorDisplayMode_NameAndValue_instance;
  var EditorDisplayMode_PointPath_instance;
  var EditorDisplayMode_PointPathLoop_instance;
  var EditorDisplayMode_PointStar_instance;
  var EditorDisplayMode_Points_instance;
  var EditorDisplayMode_RadiusGrid_instance;
  var EditorDisplayMode_RadiusPx_instance;
  var EditorDisplayMode_RefLinkBetweenCenters_instance;
  var EditorDisplayMode_RefLinkBetweenPivots_instance;
  var EditorDisplayMode_ValueOnly_instance;
  function Companion_4() {
    Companion_instance_4 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ud5_1 = lazy(tmp_0, EditorDisplayMode$Companion$_anonymous__77qsc7);
  }
  protoOf(Companion_4).pl = function () {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.EditorDisplayMode', STRING_getInstance());
  };
  protoOf(Companion_4).ql = function (decoder) {
    var value = decoder.io();
    var tmp;
    switch (value) {
      case 'ArrayCountNoLabel':
        tmp = EditorDisplayMode_ArrayCountNoLabel_getInstance();
        break;
      case 'ArrayCountWithLabel':
        tmp = EditorDisplayMode_ArrayCountWithLabel_getInstance();
        break;
      case 'EntityTile':
        tmp = EditorDisplayMode_EntityTile_getInstance();
        break;
      case 'Hidden':
        tmp = EditorDisplayMode_Hidden_getInstance();
        break;
      case 'NameAndValue':
        tmp = EditorDisplayMode_NameAndValue_getInstance();
        break;
      case 'PointPath':
        tmp = EditorDisplayMode_PointPath_getInstance();
        break;
      case 'PointPathLoop':
        tmp = EditorDisplayMode_PointPathLoop_getInstance();
        break;
      case 'PointStar':
        tmp = EditorDisplayMode_PointStar_getInstance();
        break;
      case 'Points':
        tmp = EditorDisplayMode_Points_getInstance();
        break;
      case 'RadiusGrid':
        tmp = EditorDisplayMode_RadiusGrid_getInstance();
        break;
      case 'RadiusPx':
        tmp = EditorDisplayMode_RadiusPx_getInstance();
        break;
      case 'RefLinkBetweenCenters':
        tmp = EditorDisplayMode_RefLinkBetweenCenters_getInstance();
        break;
      case 'RefLinkBetweenPivots':
        tmp = EditorDisplayMode_RefLinkBetweenPivots_getInstance();
        break;
      case 'ValueOnly':
        tmp = EditorDisplayMode_ValueOnly_getInstance();
        break;
      default:
        throw IllegalArgumentException_init_$Create$('EditorDisplayMode could not parse: ' + value);
    }
    return tmp;
  };
  protoOf(Companion_4).w13 = function () {
    return _get_$cachedSerializer__te6jhj_0(this);
  };
  protoOf(Companion_4).bv = function (typeParamsSerializers) {
    return this.w13();
  };
  var Companion_instance_4;
  function Companion_getInstance_4() {
    EditorDisplayMode_initEntries();
    if (Companion_instance_4 == null)
      new Companion_4();
    return Companion_instance_4;
  }
  function values_0() {
    return [EditorDisplayMode_ArrayCountNoLabel_getInstance(), EditorDisplayMode_ArrayCountWithLabel_getInstance(), EditorDisplayMode_EntityTile_getInstance(), EditorDisplayMode_Hidden_getInstance(), EditorDisplayMode_NameAndValue_getInstance(), EditorDisplayMode_PointPath_getInstance(), EditorDisplayMode_PointPathLoop_getInstance(), EditorDisplayMode_PointStar_getInstance(), EditorDisplayMode_Points_getInstance(), EditorDisplayMode_RadiusGrid_getInstance(), EditorDisplayMode_RadiusPx_getInstance(), EditorDisplayMode_RefLinkBetweenCenters_getInstance(), EditorDisplayMode_RefLinkBetweenPivots_getInstance(), EditorDisplayMode_ValueOnly_getInstance()];
  }
  var EditorDisplayMode_entriesInitialized;
  function EditorDisplayMode_initEntries() {
    if (EditorDisplayMode_entriesInitialized)
      return Unit_instance;
    EditorDisplayMode_entriesInitialized = true;
    EditorDisplayMode_ArrayCountNoLabel_instance = new EditorDisplayMode('ArrayCountNoLabel', 0, 'ArrayCountNoLabel');
    EditorDisplayMode_ArrayCountWithLabel_instance = new EditorDisplayMode('ArrayCountWithLabel', 1, 'ArrayCountWithLabel');
    EditorDisplayMode_EntityTile_instance = new EditorDisplayMode('EntityTile', 2, 'EntityTile');
    EditorDisplayMode_Hidden_instance = new EditorDisplayMode('Hidden', 3, 'Hidden');
    EditorDisplayMode_NameAndValue_instance = new EditorDisplayMode('NameAndValue', 4, 'NameAndValue');
    EditorDisplayMode_PointPath_instance = new EditorDisplayMode('PointPath', 5, 'PointPath');
    EditorDisplayMode_PointPathLoop_instance = new EditorDisplayMode('PointPathLoop', 6, 'PointPathLoop');
    EditorDisplayMode_PointStar_instance = new EditorDisplayMode('PointStar', 7, 'PointStar');
    EditorDisplayMode_Points_instance = new EditorDisplayMode('Points', 8, 'Points');
    EditorDisplayMode_RadiusGrid_instance = new EditorDisplayMode('RadiusGrid', 9, 'RadiusGrid');
    EditorDisplayMode_RadiusPx_instance = new EditorDisplayMode('RadiusPx', 10, 'RadiusPx');
    EditorDisplayMode_RefLinkBetweenCenters_instance = new EditorDisplayMode('RefLinkBetweenCenters', 11, 'RefLinkBetweenCenters');
    EditorDisplayMode_RefLinkBetweenPivots_instance = new EditorDisplayMode('RefLinkBetweenPivots', 12, 'RefLinkBetweenPivots');
    EditorDisplayMode_ValueOnly_instance = new EditorDisplayMode('ValueOnly', 13, 'ValueOnly');
    Companion_getInstance_4();
  }
  function EditorDisplayMode(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.ad9_1 = value;
  }
  function _get_$cachedSerializer__te6jhj_1($this) {
    return $this.vd5_1.m2();
  }
  function EditorDisplayPos$Companion$_anonymous__f71kr4() {
    return createSimpleEnumSerializer('korlibs.korge.ldtk.EditorDisplayPos', values_1());
  }
  var EditorDisplayPos_Above_instance;
  var EditorDisplayPos_Beneath_instance;
  var EditorDisplayPos_Center_instance;
  function Companion_5() {
    Companion_instance_5 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.vd5_1 = lazy(tmp_0, EditorDisplayPos$Companion$_anonymous__f71kr4);
  }
  protoOf(Companion_5).pl = function () {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.EditorDisplayPos', STRING_getInstance());
  };
  protoOf(Companion_5).ql = function (decoder) {
    var value = decoder.io();
    var tmp;
    switch (value) {
      case 'Above':
        tmp = EditorDisplayPos_Above_getInstance();
        break;
      case 'Beneath':
        tmp = EditorDisplayPos_Beneath_getInstance();
        break;
      case 'Center':
        tmp = EditorDisplayPos_Center_getInstance();
        break;
      default:
        throw IllegalArgumentException_init_$Create$('EditorDisplayPos could not parse: ' + value);
    }
    return tmp;
  };
  protoOf(Companion_5).w13 = function () {
    return _get_$cachedSerializer__te6jhj_1(this);
  };
  protoOf(Companion_5).bv = function (typeParamsSerializers) {
    return this.w13();
  };
  var Companion_instance_5;
  function Companion_getInstance_5() {
    EditorDisplayPos_initEntries();
    if (Companion_instance_5 == null)
      new Companion_5();
    return Companion_instance_5;
  }
  function values_1() {
    return [EditorDisplayPos_Above_getInstance(), EditorDisplayPos_Beneath_getInstance(), EditorDisplayPos_Center_getInstance()];
  }
  var EditorDisplayPos_entriesInitialized;
  function EditorDisplayPos_initEntries() {
    if (EditorDisplayPos_entriesInitialized)
      return Unit_instance;
    EditorDisplayPos_entriesInitialized = true;
    EditorDisplayPos_Above_instance = new EditorDisplayPos('Above', 0, 'Above');
    EditorDisplayPos_Beneath_instance = new EditorDisplayPos('Beneath', 1, 'Beneath');
    EditorDisplayPos_Center_instance = new EditorDisplayPos('Center', 2, 'Center');
    Companion_getInstance_5();
  }
  function EditorDisplayPos(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.dd9_1 = value;
  }
  function _get_$cachedSerializer__te6jhj_2($this) {
    return $this.wd5_1.m2();
  }
  function TextLanguageMode$Companion$_anonymous__u336u1() {
    return createSimpleEnumSerializer('korlibs.korge.ldtk.TextLanguageMode', values_2());
  }
  var TextLanguageMode_LangC_instance;
  var TextLanguageMode_LangHaxe_instance;
  var TextLanguageMode_LangJS_instance;
  var TextLanguageMode_LangJSON_instance;
  var TextLanguageMode_LangLog_instance;
  var TextLanguageMode_LangLua_instance;
  var TextLanguageMode_LangMarkdown_instance;
  var TextLanguageMode_LangPython_instance;
  var TextLanguageMode_LangRuby_instance;
  var TextLanguageMode_LangXML_instance;
  function Companion_6() {
    Companion_instance_6 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.wd5_1 = lazy(tmp_0, TextLanguageMode$Companion$_anonymous__u336u1);
  }
  protoOf(Companion_6).pl = function () {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.TextLanguageMode', STRING_getInstance());
  };
  protoOf(Companion_6).ql = function (decoder) {
    var value = decoder.io();
    var tmp;
    switch (value) {
      case 'LangC':
        tmp = TextLanguageMode_LangC_getInstance();
        break;
      case 'LangHaxe':
        tmp = TextLanguageMode_LangHaxe_getInstance();
        break;
      case 'LangJS':
        tmp = TextLanguageMode_LangJS_getInstance();
        break;
      case 'LangJson':
        tmp = TextLanguageMode_LangJSON_getInstance();
        break;
      case 'LangLog':
        tmp = TextLanguageMode_LangLog_getInstance();
        break;
      case 'LangLua':
        tmp = TextLanguageMode_LangLua_getInstance();
        break;
      case 'LangMarkdown':
        tmp = TextLanguageMode_LangMarkdown_getInstance();
        break;
      case 'LangPython':
        tmp = TextLanguageMode_LangPython_getInstance();
        break;
      case 'LangRuby':
        tmp = TextLanguageMode_LangRuby_getInstance();
        break;
      case 'LangXml':
        tmp = TextLanguageMode_LangXML_getInstance();
        break;
      default:
        throw IllegalArgumentException_init_$Create$('TextLanguageMode could not parse: ' + value);
    }
    return tmp;
  };
  protoOf(Companion_6).w13 = function () {
    return _get_$cachedSerializer__te6jhj_2(this);
  };
  protoOf(Companion_6).bv = function (typeParamsSerializers) {
    return this.w13();
  };
  var Companion_instance_6;
  function Companion_getInstance_6() {
    TextLanguageMode_initEntries();
    if (Companion_instance_6 == null)
      new Companion_6();
    return Companion_instance_6;
  }
  function values_2() {
    return [TextLanguageMode_LangC_getInstance(), TextLanguageMode_LangHaxe_getInstance(), TextLanguageMode_LangJS_getInstance(), TextLanguageMode_LangJSON_getInstance(), TextLanguageMode_LangLog_getInstance(), TextLanguageMode_LangLua_getInstance(), TextLanguageMode_LangMarkdown_getInstance(), TextLanguageMode_LangPython_getInstance(), TextLanguageMode_LangRuby_getInstance(), TextLanguageMode_LangXML_getInstance()];
  }
  var TextLanguageMode_entriesInitialized;
  function TextLanguageMode_initEntries() {
    if (TextLanguageMode_entriesInitialized)
      return Unit_instance;
    TextLanguageMode_entriesInitialized = true;
    TextLanguageMode_LangC_instance = new TextLanguageMode('LangC', 0, 'LangC');
    TextLanguageMode_LangHaxe_instance = new TextLanguageMode('LangHaxe', 1, 'LangHaxe');
    TextLanguageMode_LangJS_instance = new TextLanguageMode('LangJS', 2, 'LangJS');
    TextLanguageMode_LangJSON_instance = new TextLanguageMode('LangJSON', 3, 'LangJson');
    TextLanguageMode_LangLog_instance = new TextLanguageMode('LangLog', 4, 'LangLog');
    TextLanguageMode_LangLua_instance = new TextLanguageMode('LangLua', 5, 'LangLua');
    TextLanguageMode_LangMarkdown_instance = new TextLanguageMode('LangMarkdown', 6, 'LangMarkdown');
    TextLanguageMode_LangPython_instance = new TextLanguageMode('LangPython', 7, 'LangPython');
    TextLanguageMode_LangRuby_instance = new TextLanguageMode('LangRuby', 8, 'LangRuby');
    TextLanguageMode_LangXML_instance = new TextLanguageMode('LangXML', 9, 'LangXml');
    Companion_getInstance_6();
  }
  function TextLanguageMode(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.gd9_1 = value;
  }
  function _get_$cachedSerializer__te6jhj_3($this) {
    return $this.ad7_1.m2();
  }
  function LimitBehavior$Companion$_anonymous__hsp10i() {
    return createSimpleEnumSerializer('korlibs.korge.ldtk.LimitBehavior', values_3());
  }
  var LimitBehavior_DiscardOldOnes_instance;
  var LimitBehavior_MoveLastOne_instance;
  var LimitBehavior_PreventAdding_instance;
  function Companion_7() {
    Companion_instance_7 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ad7_1 = lazy(tmp_0, LimitBehavior$Companion$_anonymous__hsp10i);
  }
  protoOf(Companion_7).pl = function () {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.LimitBehavior', STRING_getInstance());
  };
  protoOf(Companion_7).ql = function (decoder) {
    var value = decoder.io();
    var tmp;
    switch (value) {
      case 'DiscardOldOnes':
        tmp = LimitBehavior_DiscardOldOnes_getInstance();
        break;
      case 'MoveLastOne':
        tmp = LimitBehavior_MoveLastOne_getInstance();
        break;
      case 'PreventAdding':
        tmp = LimitBehavior_PreventAdding_getInstance();
        break;
      default:
        throw IllegalArgumentException_init_$Create$('LimitBehavior could not parse: ' + value);
    }
    return tmp;
  };
  protoOf(Companion_7).w13 = function () {
    return _get_$cachedSerializer__te6jhj_3(this);
  };
  protoOf(Companion_7).bv = function (typeParamsSerializers) {
    return this.w13();
  };
  var Companion_instance_7;
  function Companion_getInstance_7() {
    LimitBehavior_initEntries();
    if (Companion_instance_7 == null)
      new Companion_7();
    return Companion_instance_7;
  }
  function values_3() {
    return [LimitBehavior_DiscardOldOnes_getInstance(), LimitBehavior_MoveLastOne_getInstance(), LimitBehavior_PreventAdding_getInstance()];
  }
  var LimitBehavior_entriesInitialized;
  function LimitBehavior_initEntries() {
    if (LimitBehavior_entriesInitialized)
      return Unit_instance;
    LimitBehavior_entriesInitialized = true;
    LimitBehavior_DiscardOldOnes_instance = new LimitBehavior('DiscardOldOnes', 0, 'DiscardOldOnes');
    LimitBehavior_MoveLastOne_instance = new LimitBehavior('MoveLastOne', 1, 'MoveLastOne');
    LimitBehavior_PreventAdding_instance = new LimitBehavior('PreventAdding', 2, 'PreventAdding');
    Companion_getInstance_7();
  }
  function LimitBehavior(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.jd9_1 = value;
  }
  function _get_$cachedSerializer__te6jhj_4($this) {
    return $this.bd7_1.m2();
  }
  function LimitScope$Companion$_anonymous__ndoxsa() {
    return createSimpleEnumSerializer('korlibs.korge.ldtk.LimitScope', values_4());
  }
  var LimitScope_PerLayer_instance;
  var LimitScope_PerLevel_instance;
  var LimitScope_PerWorld_instance;
  function Companion_8() {
    Companion_instance_8 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.bd7_1 = lazy(tmp_0, LimitScope$Companion$_anonymous__ndoxsa);
  }
  protoOf(Companion_8).pl = function () {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.LimitScope', STRING_getInstance());
  };
  protoOf(Companion_8).ql = function (decoder) {
    var value = decoder.io();
    var tmp;
    switch (value) {
      case 'PerLayer':
        tmp = LimitScope_PerLayer_getInstance();
        break;
      case 'PerLevel':
        tmp = LimitScope_PerLevel_getInstance();
        break;
      case 'PerWorld':
        tmp = LimitScope_PerWorld_getInstance();
        break;
      default:
        throw IllegalArgumentException_init_$Create$('LimitScope could not parse: ' + value);
    }
    return tmp;
  };
  protoOf(Companion_8).w13 = function () {
    return _get_$cachedSerializer__te6jhj_4(this);
  };
  protoOf(Companion_8).bv = function (typeParamsSerializers) {
    return this.w13();
  };
  var Companion_instance_8;
  function Companion_getInstance_8() {
    LimitScope_initEntries();
    if (Companion_instance_8 == null)
      new Companion_8();
    return Companion_instance_8;
  }
  function values_4() {
    return [LimitScope_PerLayer_getInstance(), LimitScope_PerLevel_getInstance(), LimitScope_PerWorld_getInstance()];
  }
  var LimitScope_entriesInitialized;
  function LimitScope_initEntries() {
    if (LimitScope_entriesInitialized)
      return Unit_instance;
    LimitScope_entriesInitialized = true;
    LimitScope_PerLayer_instance = new LimitScope('PerLayer', 0, 'PerLayer');
    LimitScope_PerLevel_instance = new LimitScope('PerLevel', 1, 'PerLevel');
    LimitScope_PerWorld_instance = new LimitScope('PerWorld', 2, 'PerWorld');
    Companion_getInstance_8();
  }
  function LimitScope(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.md9_1 = value;
  }
  function _get_$cachedSerializer__te6jhj_5($this) {
    return $this.cd7_1.m2();
  }
  function RenderMode$Companion$_anonymous__ho71fu() {
    return createSimpleEnumSerializer('korlibs.korge.ldtk.RenderMode', values_5());
  }
  var RenderMode_Cross_instance;
  var RenderMode_Ellipse_instance;
  var RenderMode_Rectangle_instance;
  var RenderMode_Tile_instance;
  function Companion_9() {
    Companion_instance_9 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.cd7_1 = lazy(tmp_0, RenderMode$Companion$_anonymous__ho71fu);
  }
  protoOf(Companion_9).pl = function () {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.RenderMode', STRING_getInstance());
  };
  protoOf(Companion_9).ql = function (decoder) {
    var value = decoder.io();
    var tmp;
    switch (value) {
      case 'Cross':
        tmp = RenderMode_Cross_getInstance();
        break;
      case 'Ellipse':
        tmp = RenderMode_Ellipse_getInstance();
        break;
      case 'Rectangle':
        tmp = RenderMode_Rectangle_getInstance();
        break;
      case 'Tile':
        tmp = RenderMode_Tile_getInstance();
        break;
      default:
        throw IllegalArgumentException_init_$Create$('RenderMode could not parse: ' + value);
    }
    return tmp;
  };
  protoOf(Companion_9).w13 = function () {
    return _get_$cachedSerializer__te6jhj_5(this);
  };
  protoOf(Companion_9).bv = function (typeParamsSerializers) {
    return this.w13();
  };
  var Companion_instance_9;
  function Companion_getInstance_9() {
    RenderMode_initEntries();
    if (Companion_instance_9 == null)
      new Companion_9();
    return Companion_instance_9;
  }
  function values_5() {
    return [RenderMode_Cross_getInstance(), RenderMode_Ellipse_getInstance(), RenderMode_Rectangle_getInstance(), RenderMode_Tile_getInstance()];
  }
  var RenderMode_entriesInitialized;
  function RenderMode_initEntries() {
    if (RenderMode_entriesInitialized)
      return Unit_instance;
    RenderMode_entriesInitialized = true;
    RenderMode_Cross_instance = new RenderMode('Cross', 0, 'Cross');
    RenderMode_Ellipse_instance = new RenderMode('Ellipse', 1, 'Ellipse');
    RenderMode_Rectangle_instance = new RenderMode('Rectangle', 2, 'Rectangle');
    RenderMode_Tile_instance = new RenderMode('Tile', 3, 'Tile');
    Companion_getInstance_9();
  }
  function RenderMode(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.pd9_1 = value;
  }
  function _get_$cachedSerializer__te6jhj_6($this) {
    return $this.dd7_1.m2();
  }
  function TileRenderMode$Companion$_anonymous__shhaw() {
    return createSimpleEnumSerializer('korlibs.korge.ldtk.TileRenderMode', values_6());
  }
  var TileRenderMode_Cover_instance;
  var TileRenderMode_FitInside_instance;
  var TileRenderMode_FullSizeCropped_instance;
  var TileRenderMode_FullSizeUncropped_instance;
  var TileRenderMode_NineSlice_instance;
  var TileRenderMode_Repeat_instance;
  var TileRenderMode_Stretch_instance;
  function Companion_10() {
    Companion_instance_10 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.dd7_1 = lazy(tmp_0, TileRenderMode$Companion$_anonymous__shhaw);
  }
  protoOf(Companion_10).pl = function () {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.TileRenderMode', STRING_getInstance());
  };
  protoOf(Companion_10).ql = function (decoder) {
    var value = decoder.io();
    var tmp;
    switch (value) {
      case 'Cover':
        tmp = TileRenderMode_Cover_getInstance();
        break;
      case 'FitInside':
        tmp = TileRenderMode_FitInside_getInstance();
        break;
      case 'FullSizeCropped':
        tmp = TileRenderMode_FullSizeCropped_getInstance();
        break;
      case 'FullSizeUncropped':
        tmp = TileRenderMode_FullSizeUncropped_getInstance();
        break;
      case 'NineSlice':
        tmp = TileRenderMode_NineSlice_getInstance();
        break;
      case 'Repeat':
        tmp = TileRenderMode_Repeat_getInstance();
        break;
      case 'Stretch':
        tmp = TileRenderMode_Stretch_getInstance();
        break;
      default:
        throw IllegalArgumentException_init_$Create$('TileRenderMode could not parse: ' + value);
    }
    return tmp;
  };
  protoOf(Companion_10).w13 = function () {
    return _get_$cachedSerializer__te6jhj_6(this);
  };
  protoOf(Companion_10).bv = function (typeParamsSerializers) {
    return this.w13();
  };
  var Companion_instance_10;
  function Companion_getInstance_10() {
    TileRenderMode_initEntries();
    if (Companion_instance_10 == null)
      new Companion_10();
    return Companion_instance_10;
  }
  function values_6() {
    return [TileRenderMode_Cover_getInstance(), TileRenderMode_FitInside_getInstance(), TileRenderMode_FullSizeCropped_getInstance(), TileRenderMode_FullSizeUncropped_getInstance(), TileRenderMode_NineSlice_getInstance(), TileRenderMode_Repeat_getInstance(), TileRenderMode_Stretch_getInstance()];
  }
  var TileRenderMode_entriesInitialized;
  function TileRenderMode_initEntries() {
    if (TileRenderMode_entriesInitialized)
      return Unit_instance;
    TileRenderMode_entriesInitialized = true;
    TileRenderMode_Cover_instance = new TileRenderMode('Cover', 0, 'Cover');
    TileRenderMode_FitInside_instance = new TileRenderMode('FitInside', 1, 'FitInside');
    TileRenderMode_FullSizeCropped_instance = new TileRenderMode('FullSizeCropped', 2, 'FullSizeCropped');
    TileRenderMode_FullSizeUncropped_instance = new TileRenderMode('FullSizeUncropped', 3, 'FullSizeUncropped');
    TileRenderMode_NineSlice_instance = new TileRenderMode('NineSlice', 4, 'NineSlice');
    TileRenderMode_Repeat_instance = new TileRenderMode('Repeat', 5, 'Repeat');
    TileRenderMode_Stretch_instance = new TileRenderMode('Stretch', 6, 'Stretch');
    Companion_getInstance_10();
  }
  function TileRenderMode(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.sd9_1 = value;
  }
  function Companion_11() {
    Companion_instance_11 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.td9_1 = [null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, new ArrayListSerializer($serializer_getInstance_8())];
  }
  var Companion_instance_11;
  function Companion_getInstance_11() {
    if (Companion_instance_11 == null)
      new Companion_11();
    return Companion_instance_11;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.EnumDefinition', this, 7);
    tmp0_serialDesc.du('externalFileChecksum', true);
    tmp0_serialDesc.du('externalRelPath', true);
    tmp0_serialDesc.du('iconTilesetUid', true);
    tmp0_serialDesc.du('identifier', false);
    tmp0_serialDesc.du('tags', false);
    tmp0_serialDesc.du('uid', false);
    tmp0_serialDesc.du('values', false);
    this.ud9_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).pl = function () {
    return this.ud9_1;
  };
  protoOf($serializer_5).su = function () {
    var tmp0_cached = Companion_getInstance_11().td9_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), StringSerializer_getInstance(), tmp0_cached[4], IntSerializer_getInstance(), tmp0_cached[6]];
  };
  protoOf($serializer_5).ql = function (decoder) {
    var tmp0_desc = this.ud9_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = 0;
    var tmp10_local6 = null;
    var tmp11_input = decoder.no(tmp0_desc);
    var tmp12_cached = Companion_getInstance_11().td9_1;
    if (tmp11_input.dp()) {
      tmp4_local0 = tmp11_input.bp(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.bp(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.bp(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.xo(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.zo(tmp0_desc, 4, tmp12_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.so(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.zo(tmp0_desc, 6, tmp12_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.bp(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.bp(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.bp(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.xo(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.zo(tmp0_desc, 4, tmp12_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.so(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.zo(tmp0_desc, 6, tmp12_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.oo(tmp0_desc);
    return EnumDefinition_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  var $serializer_instance_5;
  function $serializer_getInstance_5() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function EnumDefinition_init_$Init$(seen1, externalFileChecksum, externalRelPath, iconTilesetUid, identifier, tags, uid, values, serializationConstructorMarker, $this) {
    if (!(120 === (120 & seen1))) {
      throwMissingFieldException(seen1, 120, $serializer_getInstance_5().ud9_1);
    }
    if (0 === (seen1 & 1))
      $this.vd9_1 = null;
    else
      $this.vd9_1 = externalFileChecksum;
    if (0 === (seen1 & 2))
      $this.wd9_1 = null;
    else
      $this.wd9_1 = externalRelPath;
    if (0 === (seen1 & 4))
      $this.xd9_1 = null;
    else
      $this.xd9_1 = iconTilesetUid;
    $this.yd9_1 = identifier;
    $this.zd9_1 = tags;
    $this.ada_1 = uid;
    $this.bda_1 = values;
    return $this;
  }
  function EnumDefinition_init_$Create$(seen1, externalFileChecksum, externalRelPath, iconTilesetUid, identifier, tags, uid, values, serializationConstructorMarker) {
    return EnumDefinition_init_$Init$(seen1, externalFileChecksum, externalRelPath, iconTilesetUid, identifier, tags, uid, values, serializationConstructorMarker, objectCreate(protoOf(EnumDefinition)));
  }
  function EnumDefinition() {
  }
  protoOf(EnumDefinition).toString = function () {
    return 'EnumDefinition(externalFileChecksum=' + this.vd9_1 + ', externalRelPath=' + this.wd9_1 + ', iconTilesetUid=' + this.xd9_1 + ', identifier=' + this.yd9_1 + ', tags=' + this.zd9_1 + ', uid=' + this.ada_1 + ', values=' + this.bda_1 + ')';
  };
  protoOf(EnumDefinition).hashCode = function () {
    var result = this.vd9_1 == null ? 0 : getStringHashCode(this.vd9_1);
    result = imul(result, 31) + (this.wd9_1 == null ? 0 : getStringHashCode(this.wd9_1)) | 0;
    result = imul(result, 31) + (this.xd9_1 == null ? 0 : this.xd9_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.yd9_1) | 0;
    result = imul(result, 31) + hashCode(this.zd9_1) | 0;
    result = imul(result, 31) + this.ada_1 | 0;
    result = imul(result, 31) + hashCode(this.bda_1) | 0;
    return result;
  };
  protoOf(EnumDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EnumDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof EnumDefinition ? other : THROW_CCE();
    if (!(this.vd9_1 == tmp0_other_with_cast.vd9_1))
      return false;
    if (!(this.wd9_1 == tmp0_other_with_cast.wd9_1))
      return false;
    if (!(this.xd9_1 == tmp0_other_with_cast.xd9_1))
      return false;
    if (!(this.yd9_1 === tmp0_other_with_cast.yd9_1))
      return false;
    if (!equals(this.zd9_1, tmp0_other_with_cast.zd9_1))
      return false;
    if (!(this.ada_1 === tmp0_other_with_cast.ada_1))
      return false;
    if (!equals(this.bda_1, tmp0_other_with_cast.bda_1))
      return false;
    return true;
  };
  function Companion_12() {
    Companion_instance_12 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.dda_1 = [null, new ArrayListSerializer($serializer_getInstance_9()), null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_10()), null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null, null, Companion_getInstance_15().w13(), null];
  }
  var Companion_instance_12;
  function Companion_getInstance_12() {
    if (Companion_instance_12 == null)
      new Companion_12();
    return Companion_instance_12;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.LayerDefinition', this, 24);
    tmp0_serialDesc.du('__type', false);
    tmp0_serialDesc.du('autoRuleGroups', false);
    tmp0_serialDesc.du('autoSourceLayerDefUid', true);
    tmp0_serialDesc.du('displayOpacity', false);
    tmp0_serialDesc.du('excludedTags', false);
    tmp0_serialDesc.du('gridSize', false);
    tmp0_serialDesc.du('guideGridHei', false);
    tmp0_serialDesc.du('guideGridWid', false);
    tmp0_serialDesc.du('hideFieldsWhenInactive', false);
    tmp0_serialDesc.du('hideInList', false);
    tmp0_serialDesc.du('identifier', false);
    tmp0_serialDesc.du('inactiveOpacity', false);
    tmp0_serialDesc.du('intGridValues', false);
    tmp0_serialDesc.du('parallaxFactorX', false);
    tmp0_serialDesc.du('parallaxFactorY', false);
    tmp0_serialDesc.du('parallaxScaling', false);
    tmp0_serialDesc.du('pxOffsetX', false);
    tmp0_serialDesc.du('pxOffsetY', false);
    tmp0_serialDesc.du('requiredTags', false);
    tmp0_serialDesc.du('tilePivotX', false);
    tmp0_serialDesc.du('tilePivotY', false);
    tmp0_serialDesc.du('tilesetDefUid', true);
    tmp0_serialDesc.du('type', false);
    tmp0_serialDesc.du('uid', false);
    this.eda_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).pl = function () {
    return this.eda_1;
  };
  protoOf($serializer_6).su = function () {
    var tmp0_cached = Companion_getInstance_12().dda_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], get_nullable(IntSerializer_getInstance()), DoubleSerializer_getInstance(), tmp0_cached[4], IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), DoubleSerializer_getInstance(), tmp0_cached[12], DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), BooleanSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[18], DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), tmp0_cached[22], IntSerializer_getInstance()];
  };
  protoOf($serializer_6).ql = function (decoder) {
    var tmp0_desc = this.eda_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = 0.0;
    var tmp8_local4 = null;
    var tmp9_local5 = 0;
    var tmp10_local6 = 0;
    var tmp11_local7 = 0;
    var tmp12_local8 = false;
    var tmp13_local9 = false;
    var tmp14_local10 = null;
    var tmp15_local11 = 0.0;
    var tmp16_local12 = null;
    var tmp17_local13 = 0.0;
    var tmp18_local14 = 0.0;
    var tmp19_local15 = false;
    var tmp20_local16 = 0;
    var tmp21_local17 = 0;
    var tmp22_local18 = null;
    var tmp23_local19 = 0.0;
    var tmp24_local20 = 0.0;
    var tmp25_local21 = null;
    var tmp26_local22 = null;
    var tmp27_local23 = 0;
    var tmp28_input = decoder.no(tmp0_desc);
    var tmp29_cached = Companion_getInstance_12().dda_1;
    if (tmp28_input.dp()) {
      tmp4_local0 = tmp28_input.xo(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp28_input.zo(tmp0_desc, 1, tmp29_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp28_input.bp(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp28_input.vo(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp28_input.zo(tmp0_desc, 4, tmp29_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp28_input.so(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp28_input.so(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp28_input.so(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp28_input.po(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp28_input.po(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp28_input.xo(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp28_input.vo(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp28_input.zo(tmp0_desc, 12, tmp29_cached[12], tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp28_input.vo(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp28_input.vo(tmp0_desc, 14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp28_input.po(tmp0_desc, 15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp28_input.so(tmp0_desc, 16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp28_input.so(tmp0_desc, 17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp28_input.zo(tmp0_desc, 18, tmp29_cached[18], tmp22_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp28_input.vo(tmp0_desc, 19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp28_input.vo(tmp0_desc, 20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp28_input.bp(tmp0_desc, 21, IntSerializer_getInstance(), tmp25_local21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp26_local22 = tmp28_input.zo(tmp0_desc, 22, tmp29_cached[22], tmp26_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
      tmp27_local23 = tmp28_input.so(tmp0_desc, 23);
      tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp28_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp28_input.xo(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp28_input.zo(tmp0_desc, 1, tmp29_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp28_input.bp(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp28_input.vo(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp28_input.zo(tmp0_desc, 4, tmp29_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp28_input.so(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp28_input.so(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp28_input.so(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp28_input.po(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp28_input.po(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp28_input.xo(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp28_input.vo(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp28_input.zo(tmp0_desc, 12, tmp29_cached[12], tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp28_input.vo(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp28_input.vo(tmp0_desc, 14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp28_input.po(tmp0_desc, 15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp28_input.so(tmp0_desc, 16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp28_input.so(tmp0_desc, 17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp28_input.zo(tmp0_desc, 18, tmp29_cached[18], tmp22_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp28_input.vo(tmp0_desc, 19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp28_input.vo(tmp0_desc, 20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp28_input.bp(tmp0_desc, 21, IntSerializer_getInstance(), tmp25_local21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp26_local22 = tmp28_input.zo(tmp0_desc, 22, tmp29_cached[22], tmp26_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          case 23:
            tmp27_local23 = tmp28_input.so(tmp0_desc, 23);
            tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp28_input.oo(tmp0_desc);
    return LayerDefinition_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, null);
  };
  var $serializer_instance_6;
  function $serializer_getInstance_6() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function LayerDefinition_init_$Init$(seen1, type, autoRuleGroups, autoSourceLayerDefUid, displayOpacity, excludedTags, gridSize, guideGridHei, guideGridWid, hideFieldsWhenInactive, hideInList, identifier, inactiveOpacity, intGridValues, parallaxFactorX, parallaxFactorY, parallaxScaling, pxOffsetX, pxOffsetY, requiredTags, tilePivotX, tilePivotY, tilesetDefUid, layerDefinitionType, uid, serializationConstructorMarker, $this) {
    if (!(14680059 === (14680059 & seen1))) {
      throwMissingFieldException(seen1, 14680059, $serializer_getInstance_6().eda_1);
    }
    $this.fda_1 = type;
    $this.gda_1 = autoRuleGroups;
    if (0 === (seen1 & 4))
      $this.hda_1 = null;
    else
      $this.hda_1 = autoSourceLayerDefUid;
    $this.ida_1 = displayOpacity;
    $this.jda_1 = excludedTags;
    $this.kda_1 = gridSize;
    $this.lda_1 = guideGridHei;
    $this.mda_1 = guideGridWid;
    $this.nda_1 = hideFieldsWhenInactive;
    $this.oda_1 = hideInList;
    $this.pda_1 = identifier;
    $this.qda_1 = inactiveOpacity;
    $this.rda_1 = intGridValues;
    $this.sda_1 = parallaxFactorX;
    $this.tda_1 = parallaxFactorY;
    $this.uda_1 = parallaxScaling;
    $this.vda_1 = pxOffsetX;
    $this.wda_1 = pxOffsetY;
    $this.xda_1 = requiredTags;
    $this.yda_1 = tilePivotX;
    $this.zda_1 = tilePivotY;
    if (0 === (seen1 & 2097152))
      $this.adb_1 = null;
    else
      $this.adb_1 = tilesetDefUid;
    $this.bdb_1 = layerDefinitionType;
    $this.cdb_1 = uid;
    return $this;
  }
  function LayerDefinition_init_$Create$(seen1, type, autoRuleGroups, autoSourceLayerDefUid, displayOpacity, excludedTags, gridSize, guideGridHei, guideGridWid, hideFieldsWhenInactive, hideInList, identifier, inactiveOpacity, intGridValues, parallaxFactorX, parallaxFactorY, parallaxScaling, pxOffsetX, pxOffsetY, requiredTags, tilePivotX, tilePivotY, tilesetDefUid, layerDefinitionType, uid, serializationConstructorMarker) {
    return LayerDefinition_init_$Init$(seen1, type, autoRuleGroups, autoSourceLayerDefUid, displayOpacity, excludedTags, gridSize, guideGridHei, guideGridWid, hideFieldsWhenInactive, hideInList, identifier, inactiveOpacity, intGridValues, parallaxFactorX, parallaxFactorY, parallaxScaling, pxOffsetX, pxOffsetY, requiredTags, tilePivotX, tilePivotY, tilesetDefUid, layerDefinitionType, uid, serializationConstructorMarker, objectCreate(protoOf(LayerDefinition)));
  }
  function LayerDefinition() {
  }
  protoOf(LayerDefinition).toString = function () {
    return 'LayerDefinition(type=' + this.fda_1 + ', autoRuleGroups=' + this.gda_1 + ', autoSourceLayerDefUid=' + this.hda_1 + ', displayOpacity=' + this.ida_1 + ', excludedTags=' + this.jda_1 + ', gridSize=' + this.kda_1 + ', guideGridHei=' + this.lda_1 + ', guideGridWid=' + this.mda_1 + ', hideFieldsWhenInactive=' + this.nda_1 + ', hideInList=' + this.oda_1 + ', identifier=' + this.pda_1 + ', inactiveOpacity=' + this.qda_1 + ', intGridValues=' + this.rda_1 + ', parallaxFactorX=' + this.sda_1 + ', parallaxFactorY=' + this.tda_1 + ', parallaxScaling=' + this.uda_1 + ', pxOffsetX=' + this.vda_1 + ', pxOffsetY=' + this.wda_1 + ', requiredTags=' + this.xda_1 + ', tilePivotX=' + this.yda_1 + ', tilePivotY=' + this.zda_1 + ', tilesetDefUid=' + this.adb_1 + ', layerDefinitionType=' + this.bdb_1 + ', uid=' + this.cdb_1 + ')';
  };
  protoOf(LayerDefinition).hashCode = function () {
    var result = getStringHashCode(this.fda_1);
    result = imul(result, 31) + hashCode(this.gda_1) | 0;
    result = imul(result, 31) + (this.hda_1 == null ? 0 : this.hda_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ida_1) | 0;
    result = imul(result, 31) + hashCode(this.jda_1) | 0;
    result = imul(result, 31) + this.kda_1 | 0;
    result = imul(result, 31) + this.lda_1 | 0;
    result = imul(result, 31) + this.mda_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.nda_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.oda_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.pda_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.qda_1) | 0;
    result = imul(result, 31) + hashCode(this.rda_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.sda_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.tda_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.uda_1) | 0;
    result = imul(result, 31) + this.vda_1 | 0;
    result = imul(result, 31) + this.wda_1 | 0;
    result = imul(result, 31) + hashCode(this.xda_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.yda_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.zda_1) | 0;
    result = imul(result, 31) + (this.adb_1 == null ? 0 : this.adb_1) | 0;
    result = imul(result, 31) + this.bdb_1.hashCode() | 0;
    result = imul(result, 31) + this.cdb_1 | 0;
    return result;
  };
  protoOf(LayerDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LayerDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof LayerDefinition ? other : THROW_CCE();
    if (!(this.fda_1 === tmp0_other_with_cast.fda_1))
      return false;
    if (!equals(this.gda_1, tmp0_other_with_cast.gda_1))
      return false;
    if (!(this.hda_1 == tmp0_other_with_cast.hda_1))
      return false;
    if (!equals(this.ida_1, tmp0_other_with_cast.ida_1))
      return false;
    if (!equals(this.jda_1, tmp0_other_with_cast.jda_1))
      return false;
    if (!(this.kda_1 === tmp0_other_with_cast.kda_1))
      return false;
    if (!(this.lda_1 === tmp0_other_with_cast.lda_1))
      return false;
    if (!(this.mda_1 === tmp0_other_with_cast.mda_1))
      return false;
    if (!(this.nda_1 === tmp0_other_with_cast.nda_1))
      return false;
    if (!(this.oda_1 === tmp0_other_with_cast.oda_1))
      return false;
    if (!(this.pda_1 === tmp0_other_with_cast.pda_1))
      return false;
    if (!equals(this.qda_1, tmp0_other_with_cast.qda_1))
      return false;
    if (!equals(this.rda_1, tmp0_other_with_cast.rda_1))
      return false;
    if (!equals(this.sda_1, tmp0_other_with_cast.sda_1))
      return false;
    if (!equals(this.tda_1, tmp0_other_with_cast.tda_1))
      return false;
    if (!(this.uda_1 === tmp0_other_with_cast.uda_1))
      return false;
    if (!(this.vda_1 === tmp0_other_with_cast.vda_1))
      return false;
    if (!(this.wda_1 === tmp0_other_with_cast.wda_1))
      return false;
    if (!equals(this.xda_1, tmp0_other_with_cast.xda_1))
      return false;
    if (!equals(this.yda_1, tmp0_other_with_cast.yda_1))
      return false;
    if (!equals(this.zda_1, tmp0_other_with_cast.zda_1))
      return false;
    if (!(this.adb_1 == tmp0_other_with_cast.adb_1))
      return false;
    if (!this.bdb_1.equals(tmp0_other_with_cast.bdb_1))
      return false;
    if (!(this.cdb_1 === tmp0_other_with_cast.cdb_1))
      return false;
    return true;
  };
  function Companion_13() {
    Companion_instance_13 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.edb_1 = [null, null, null, new ArrayListSerializer($serializer_getInstance_11()), Companion_getInstance_16().w13(), new ArrayListSerializer($serializer_getInstance_12()), null, null, null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null, null];
  }
  var Companion_instance_13;
  function Companion_getInstance_13() {
    if (Companion_instance_13 == null)
      new Companion_13();
    return Companion_instance_13;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.TilesetDefinition', this, 17);
    tmp0_serialDesc.du('__cHei', false);
    tmp0_serialDesc.du('__cWid', false);
    tmp0_serialDesc.du('cachedPixelData', true);
    tmp0_serialDesc.du('customData', false);
    tmp0_serialDesc.du('embedAtlas', true);
    tmp0_serialDesc.du('enumTags', false);
    tmp0_serialDesc.du('identifier', false);
    tmp0_serialDesc.du('padding', false);
    tmp0_serialDesc.du('pxHei', false);
    tmp0_serialDesc.du('pxWid', false);
    tmp0_serialDesc.du('relPath', true);
    tmp0_serialDesc.du('savedSelections', false);
    tmp0_serialDesc.du('spacing', false);
    tmp0_serialDesc.du('tags', false);
    tmp0_serialDesc.du('tagsSourceEnumUid', true);
    tmp0_serialDesc.du('tileGridSize', false);
    tmp0_serialDesc.du('uid', false);
    this.fdb_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).pl = function () {
    return this.fdb_1;
  };
  protoOf($serializer_7).su = function () {
    var tmp0_cached = Companion_getInstance_13().edb_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(JsonObjectSerializer_getInstance()), tmp0_cached[3], get_nullable(tmp0_cached[4]), tmp0_cached[5], StringSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), JsonArraySerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[13], get_nullable(IntSerializer_getInstance()), IntSerializer_getInstance(), IntSerializer_getInstance()];
  };
  protoOf($serializer_7).ql = function (decoder) {
    var tmp0_desc = this.fdb_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = 0;
    var tmp12_local8 = 0;
    var tmp13_local9 = 0;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = 0;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = 0;
    var tmp20_local16 = 0;
    var tmp21_input = decoder.no(tmp0_desc);
    var tmp22_cached = Companion_getInstance_13().edb_1;
    if (tmp21_input.dp()) {
      tmp4_local0 = tmp21_input.so(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp21_input.so(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp21_input.bp(tmp0_desc, 2, JsonObjectSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp21_input.zo(tmp0_desc, 3, tmp22_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp21_input.bp(tmp0_desc, 4, tmp22_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp21_input.zo(tmp0_desc, 5, tmp22_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp21_input.xo(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp21_input.so(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp21_input.so(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp21_input.so(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp21_input.bp(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp21_input.zo(tmp0_desc, 11, JsonArraySerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp21_input.so(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp21_input.zo(tmp0_desc, 13, tmp22_cached[13], tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp21_input.bp(tmp0_desc, 14, IntSerializer_getInstance(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp21_input.so(tmp0_desc, 15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp21_input.so(tmp0_desc, 16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp21_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp21_input.so(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp21_input.so(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp21_input.bp(tmp0_desc, 2, JsonObjectSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp21_input.zo(tmp0_desc, 3, tmp22_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp21_input.bp(tmp0_desc, 4, tmp22_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp21_input.zo(tmp0_desc, 5, tmp22_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp21_input.xo(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp21_input.so(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp21_input.so(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp21_input.so(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp21_input.bp(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp21_input.zo(tmp0_desc, 11, JsonArraySerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp21_input.so(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp21_input.zo(tmp0_desc, 13, tmp22_cached[13], tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp21_input.bp(tmp0_desc, 14, IntSerializer_getInstance(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp21_input.so(tmp0_desc, 15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp21_input.so(tmp0_desc, 16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp21_input.oo(tmp0_desc);
    return TilesetDefinition_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, null);
  };
  var $serializer_instance_7;
  function $serializer_getInstance_7() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function TilesetDefinition_init_$Init$(seen1, cHei, cWid, cachedPixelData, customData, embedAtlas, enumTags, identifier, padding, pxHei, pxWid, relPath, savedSelections, spacing, tags, tagsSourceEnumUid, tileGridSize, uid, serializationConstructorMarker, $this) {
    if (!(113643 === (113643 & seen1))) {
      throwMissingFieldException(seen1, 113643, $serializer_getInstance_7().fdb_1);
    }
    $this.gdb_1 = cHei;
    $this.hdb_1 = cWid;
    if (0 === (seen1 & 4))
      $this.idb_1 = null;
    else
      $this.idb_1 = cachedPixelData;
    $this.jdb_1 = customData;
    if (0 === (seen1 & 16))
      $this.kdb_1 = null;
    else
      $this.kdb_1 = embedAtlas;
    $this.ldb_1 = enumTags;
    $this.mdb_1 = identifier;
    $this.ndb_1 = padding;
    $this.odb_1 = pxHei;
    $this.pdb_1 = pxWid;
    if (0 === (seen1 & 1024))
      $this.qdb_1 = null;
    else
      $this.qdb_1 = relPath;
    $this.rdb_1 = savedSelections;
    $this.sdb_1 = spacing;
    $this.tdb_1 = tags;
    if (0 === (seen1 & 16384))
      $this.udb_1 = null;
    else
      $this.udb_1 = tagsSourceEnumUid;
    $this.vdb_1 = tileGridSize;
    $this.wdb_1 = uid;
    return $this;
  }
  function TilesetDefinition_init_$Create$(seen1, cHei, cWid, cachedPixelData, customData, embedAtlas, enumTags, identifier, padding, pxHei, pxWid, relPath, savedSelections, spacing, tags, tagsSourceEnumUid, tileGridSize, uid, serializationConstructorMarker) {
    return TilesetDefinition_init_$Init$(seen1, cHei, cWid, cachedPixelData, customData, embedAtlas, enumTags, identifier, padding, pxHei, pxWid, relPath, savedSelections, spacing, tags, tagsSourceEnumUid, tileGridSize, uid, serializationConstructorMarker, objectCreate(protoOf(TilesetDefinition)));
  }
  function TilesetDefinition() {
  }
  protoOf(TilesetDefinition).toString = function () {
    return 'TilesetDefinition(cHei=' + this.gdb_1 + ', cWid=' + this.hdb_1 + ', cachedPixelData=' + this.idb_1 + ', customData=' + this.jdb_1 + ', embedAtlas=' + this.kdb_1 + ', enumTags=' + this.ldb_1 + ', identifier=' + this.mdb_1 + ', padding=' + this.ndb_1 + ', pxHei=' + this.odb_1 + ', pxWid=' + this.pdb_1 + ', relPath=' + this.qdb_1 + ', savedSelections=' + this.rdb_1 + ', spacing=' + this.sdb_1 + ', tags=' + this.tdb_1 + ', tagsSourceEnumUid=' + this.udb_1 + ', tileGridSize=' + this.vdb_1 + ', uid=' + this.wdb_1 + ')';
  };
  protoOf(TilesetDefinition).hashCode = function () {
    var result = this.gdb_1;
    result = imul(result, 31) + this.hdb_1 | 0;
    result = imul(result, 31) + (this.idb_1 == null ? 0 : this.idb_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.jdb_1) | 0;
    result = imul(result, 31) + (this.kdb_1 == null ? 0 : this.kdb_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.ldb_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.mdb_1) | 0;
    result = imul(result, 31) + this.ndb_1 | 0;
    result = imul(result, 31) + this.odb_1 | 0;
    result = imul(result, 31) + this.pdb_1 | 0;
    result = imul(result, 31) + (this.qdb_1 == null ? 0 : getStringHashCode(this.qdb_1)) | 0;
    result = imul(result, 31) + this.rdb_1.hashCode() | 0;
    result = imul(result, 31) + this.sdb_1 | 0;
    result = imul(result, 31) + hashCode(this.tdb_1) | 0;
    result = imul(result, 31) + (this.udb_1 == null ? 0 : this.udb_1) | 0;
    result = imul(result, 31) + this.vdb_1 | 0;
    result = imul(result, 31) + this.wdb_1 | 0;
    return result;
  };
  protoOf(TilesetDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TilesetDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof TilesetDefinition ? other : THROW_CCE();
    if (!(this.gdb_1 === tmp0_other_with_cast.gdb_1))
      return false;
    if (!(this.hdb_1 === tmp0_other_with_cast.hdb_1))
      return false;
    if (!equals(this.idb_1, tmp0_other_with_cast.idb_1))
      return false;
    if (!equals(this.jdb_1, tmp0_other_with_cast.jdb_1))
      return false;
    if (!equals(this.kdb_1, tmp0_other_with_cast.kdb_1))
      return false;
    if (!equals(this.ldb_1, tmp0_other_with_cast.ldb_1))
      return false;
    if (!(this.mdb_1 === tmp0_other_with_cast.mdb_1))
      return false;
    if (!(this.ndb_1 === tmp0_other_with_cast.ndb_1))
      return false;
    if (!(this.odb_1 === tmp0_other_with_cast.odb_1))
      return false;
    if (!(this.pdb_1 === tmp0_other_with_cast.pdb_1))
      return false;
    if (!(this.qdb_1 == tmp0_other_with_cast.qdb_1))
      return false;
    if (!this.rdb_1.equals(tmp0_other_with_cast.rdb_1))
      return false;
    if (!(this.sdb_1 === tmp0_other_with_cast.sdb_1))
      return false;
    if (!equals(this.tdb_1, tmp0_other_with_cast.tdb_1))
      return false;
    if (!(this.udb_1 == tmp0_other_with_cast.udb_1))
      return false;
    if (!(this.vdb_1 === tmp0_other_with_cast.vdb_1))
      return false;
    if (!(this.wdb_1 === tmp0_other_with_cast.wdb_1))
      return false;
    return true;
  };
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.EnumValueDefinition', this, 4);
    tmp0_serialDesc.du('__tileSrcRect', true);
    tmp0_serialDesc.du('color', false);
    tmp0_serialDesc.du('id', false);
    tmp0_serialDesc.du('tileId', true);
    this.xdb_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).pl = function () {
    return this.xdb_1;
  };
  protoOf($serializer_8).su = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(IntArraySerializer_getInstance()), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(IntSerializer_getInstance())];
  };
  protoOf($serializer_8).ql = function (decoder) {
    var tmp0_desc = this.xdb_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.no(tmp0_desc);
    if (tmp8_input.dp()) {
      tmp4_local0 = tmp8_input.bp(tmp0_desc, 0, IntArraySerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.so(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.xo(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.bp(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.bp(tmp0_desc, 0, IntArraySerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.so(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.xo(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.bp(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.oo(tmp0_desc);
    return EnumValueDefinition_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  var $serializer_instance_8;
  function $serializer_getInstance_8() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function EnumValueDefinition_init_$Init$(seen1, tileSrcRect, color, id, tileID, serializationConstructorMarker, $this) {
    if (!(6 === (6 & seen1))) {
      throwMissingFieldException(seen1, 6, $serializer_getInstance_8().xdb_1);
    }
    if (0 === (seen1 & 1))
      $this.ydb_1 = null;
    else
      $this.ydb_1 = tileSrcRect;
    $this.zdb_1 = color;
    $this.adc_1 = id;
    if (0 === (seen1 & 8))
      $this.bdc_1 = null;
    else
      $this.bdc_1 = tileID;
    return $this;
  }
  function EnumValueDefinition_init_$Create$(seen1, tileSrcRect, color, id, tileID, serializationConstructorMarker) {
    return EnumValueDefinition_init_$Init$(seen1, tileSrcRect, color, id, tileID, serializationConstructorMarker, objectCreate(protoOf(EnumValueDefinition)));
  }
  function EnumValueDefinition() {
  }
  protoOf(EnumValueDefinition).toString = function () {
    return 'EnumValueDefinition(tileSrcRect=' + toString(this.ydb_1) + ', color=' + this.zdb_1 + ', id=' + this.adc_1 + ', tileID=' + this.bdc_1 + ')';
  };
  protoOf(EnumValueDefinition).hashCode = function () {
    var result = this.ydb_1 == null ? 0 : hashCode(this.ydb_1);
    result = imul(result, 31) + this.zdb_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.adc_1) | 0;
    result = imul(result, 31) + (this.bdc_1 == null ? 0 : this.bdc_1) | 0;
    return result;
  };
  protoOf(EnumValueDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EnumValueDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof EnumValueDefinition ? other : THROW_CCE();
    if (!equals(this.ydb_1, tmp0_other_with_cast.ydb_1))
      return false;
    if (!(this.zdb_1 === tmp0_other_with_cast.zdb_1))
      return false;
    if (!(this.adc_1 === tmp0_other_with_cast.adc_1))
      return false;
    if (!(this.bdc_1 == tmp0_other_with_cast.bdc_1))
      return false;
    return true;
  };
  function Companion_14() {
    Companion_instance_14 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.cdc_1 = [null, null, null, null, new ArrayListSerializer($serializer_getInstance_13()), null];
  }
  var Companion_instance_14;
  function Companion_getInstance_14() {
    if (Companion_instance_14 == null)
      new Companion_14();
    return Companion_instance_14;
  }
  function $serializer_9() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.AutoLayerRuleGroup', this, 6);
    tmp0_serialDesc.du('active', false);
    tmp0_serialDesc.du('collapsed', true);
    tmp0_serialDesc.du('isOptional', false);
    tmp0_serialDesc.du('name', false);
    tmp0_serialDesc.du('rules', false);
    tmp0_serialDesc.du('uid', false);
    this.ddc_1 = tmp0_serialDesc;
  }
  protoOf($serializer_9).pl = function () {
    return this.ddc_1;
  };
  protoOf($serializer_9).su = function () {
    var tmp0_cached = Companion_getInstance_14().cdc_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance(), get_nullable(BooleanSerializer_getInstance()), BooleanSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[4], IntSerializer_getInstance()];
  };
  protoOf($serializer_9).ql = function (decoder) {
    var tmp0_desc = this.ddc_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = 0;
    var tmp10_input = decoder.no(tmp0_desc);
    var tmp11_cached = Companion_getInstance_14().cdc_1;
    if (tmp10_input.dp()) {
      tmp4_local0 = tmp10_input.po(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.bp(tmp0_desc, 1, BooleanSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.po(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.xo(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.zo(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.so(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.po(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.bp(tmp0_desc, 1, BooleanSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.po(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.xo(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.zo(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.so(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.oo(tmp0_desc);
    return AutoLayerRuleGroup_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  var $serializer_instance_9;
  function $serializer_getInstance_9() {
    if ($serializer_instance_9 == null)
      new $serializer_9();
    return $serializer_instance_9;
  }
  function AutoLayerRuleGroup_init_$Init$(seen1, active, collapsed, isOptional, name, rules, uid, serializationConstructorMarker, $this) {
    if (!(61 === (61 & seen1))) {
      throwMissingFieldException(seen1, 61, $serializer_getInstance_9().ddc_1);
    }
    $this.edc_1 = active;
    if (0 === (seen1 & 2))
      $this.fdc_1 = null;
    else
      $this.fdc_1 = collapsed;
    $this.gdc_1 = isOptional;
    $this.hdc_1 = name;
    $this.idc_1 = rules;
    $this.jdc_1 = uid;
    return $this;
  }
  function AutoLayerRuleGroup_init_$Create$(seen1, active, collapsed, isOptional, name, rules, uid, serializationConstructorMarker) {
    return AutoLayerRuleGroup_init_$Init$(seen1, active, collapsed, isOptional, name, rules, uid, serializationConstructorMarker, objectCreate(protoOf(AutoLayerRuleGroup)));
  }
  function AutoLayerRuleGroup() {
  }
  protoOf(AutoLayerRuleGroup).toString = function () {
    return 'AutoLayerRuleGroup(active=' + this.edc_1 + ', collapsed=' + this.fdc_1 + ', isOptional=' + this.gdc_1 + ', name=' + this.hdc_1 + ', rules=' + this.idc_1 + ', uid=' + this.jdc_1 + ')';
  };
  protoOf(AutoLayerRuleGroup).hashCode = function () {
    var result = getBooleanHashCode(this.edc_1);
    result = imul(result, 31) + (this.fdc_1 == null ? 0 : getBooleanHashCode(this.fdc_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.gdc_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.hdc_1) | 0;
    result = imul(result, 31) + hashCode(this.idc_1) | 0;
    result = imul(result, 31) + this.jdc_1 | 0;
    return result;
  };
  protoOf(AutoLayerRuleGroup).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AutoLayerRuleGroup))
      return false;
    var tmp0_other_with_cast = other instanceof AutoLayerRuleGroup ? other : THROW_CCE();
    if (!(this.edc_1 === tmp0_other_with_cast.edc_1))
      return false;
    if (!(this.fdc_1 == tmp0_other_with_cast.fdc_1))
      return false;
    if (!(this.gdc_1 === tmp0_other_with_cast.gdc_1))
      return false;
    if (!(this.hdc_1 === tmp0_other_with_cast.hdc_1))
      return false;
    if (!equals(this.idc_1, tmp0_other_with_cast.idc_1))
      return false;
    if (!(this.jdc_1 === tmp0_other_with_cast.jdc_1))
      return false;
    return true;
  };
  function $serializer_10() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.IntGridValueDefinition', this, 3);
    tmp0_serialDesc.du('color', false);
    tmp0_serialDesc.du('identifier', true);
    tmp0_serialDesc.du('value', false);
    this.kdc_1 = tmp0_serialDesc;
  }
  protoOf($serializer_10).pl = function () {
    return this.kdc_1;
  };
  protoOf($serializer_10).su = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), IntSerializer_getInstance()];
  };
  protoOf($serializer_10).ql = function (decoder) {
    var tmp0_desc = this.kdc_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_input = decoder.no(tmp0_desc);
    if (tmp7_input.dp()) {
      tmp4_local0 = tmp7_input.xo(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.bp(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.so(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.xo(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.bp(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.so(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.oo(tmp0_desc);
    return IntGridValueDefinition_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  var $serializer_instance_10;
  function $serializer_getInstance_10() {
    if ($serializer_instance_10 == null)
      new $serializer_10();
    return $serializer_instance_10;
  }
  function IntGridValueDefinition_init_$Init$(seen1, color, identifier, value, serializationConstructorMarker, $this) {
    if (!(5 === (5 & seen1))) {
      throwMissingFieldException(seen1, 5, $serializer_getInstance_10().kdc_1);
    }
    $this.ldc_1 = color;
    if (0 === (seen1 & 2))
      $this.mdc_1 = null;
    else
      $this.mdc_1 = identifier;
    $this.ndc_1 = value;
    return $this;
  }
  function IntGridValueDefinition_init_$Create$(seen1, color, identifier, value, serializationConstructorMarker) {
    return IntGridValueDefinition_init_$Init$(seen1, color, identifier, value, serializationConstructorMarker, objectCreate(protoOf(IntGridValueDefinition)));
  }
  function IntGridValueDefinition() {
  }
  protoOf(IntGridValueDefinition).toString = function () {
    return 'IntGridValueDefinition(color=' + this.ldc_1 + ', identifier=' + this.mdc_1 + ', value=' + this.ndc_1 + ')';
  };
  protoOf(IntGridValueDefinition).hashCode = function () {
    var result = getStringHashCode(this.ldc_1);
    result = imul(result, 31) + (this.mdc_1 == null ? 0 : getStringHashCode(this.mdc_1)) | 0;
    result = imul(result, 31) + this.ndc_1 | 0;
    return result;
  };
  protoOf(IntGridValueDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IntGridValueDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof IntGridValueDefinition ? other : THROW_CCE();
    if (!(this.ldc_1 === tmp0_other_with_cast.ldc_1))
      return false;
    if (!(this.mdc_1 == tmp0_other_with_cast.mdc_1))
      return false;
    if (!(this.ndc_1 === tmp0_other_with_cast.ndc_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj_7($this) {
    return $this.cda_1.m2();
  }
  function Type$Companion$_anonymous__vg0awb() {
    return createSimpleEnumSerializer('korlibs.korge.ldtk.Type', values_7());
  }
  var Type_AutoLayer_instance;
  var Type_Entities_instance;
  var Type_IntGrid_instance;
  var Type_Tiles_instance;
  function Companion_15() {
    Companion_instance_15 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.cda_1 = lazy(tmp_0, Type$Companion$_anonymous__vg0awb);
  }
  protoOf(Companion_15).pl = function () {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.Type', STRING_getInstance());
  };
  protoOf(Companion_15).ql = function (decoder) {
    var value = decoder.io();
    var tmp;
    switch (value) {
      case 'AutoLayer':
        tmp = Type_AutoLayer_getInstance();
        break;
      case 'Entities':
        tmp = Type_Entities_getInstance();
        break;
      case 'IntGrid':
        tmp = Type_IntGrid_getInstance();
        break;
      case 'Tiles':
        tmp = Type_Tiles_getInstance();
        break;
      default:
        throw IllegalArgumentException_init_$Create$('Type could not parse: ' + value);
    }
    return tmp;
  };
  protoOf(Companion_15).w13 = function () {
    return _get_$cachedSerializer__te6jhj_7(this);
  };
  protoOf(Companion_15).bv = function (typeParamsSerializers) {
    return this.w13();
  };
  var Companion_instance_15;
  function Companion_getInstance_15() {
    Type_initEntries();
    if (Companion_instance_15 == null)
      new Companion_15();
    return Companion_instance_15;
  }
  function values_7() {
    return [Type_AutoLayer_getInstance(), Type_Entities_getInstance(), Type_IntGrid_getInstance(), Type_Tiles_getInstance()];
  }
  var Type_entriesInitialized;
  function Type_initEntries() {
    if (Type_entriesInitialized)
      return Unit_instance;
    Type_entriesInitialized = true;
    Type_AutoLayer_instance = new Type('AutoLayer', 0, 'AutoLayer');
    Type_Entities_instance = new Type('Entities', 1, 'Entities');
    Type_IntGrid_instance = new Type('IntGrid', 2, 'IntGrid');
    Type_Tiles_instance = new Type('Tiles', 3, 'Tiles');
    Companion_getInstance_15();
  }
  function Type(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.qdc_1 = value;
  }
  function $serializer_11() {
    $serializer_instance_11 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.TileCustomMetadata', this, 2);
    tmp0_serialDesc.du('data', false);
    tmp0_serialDesc.du('tileId', false);
    this.rdc_1 = tmp0_serialDesc;
  }
  protoOf($serializer_11).pl = function () {
    return this.rdc_1;
  };
  protoOf($serializer_11).su = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), IntSerializer_getInstance()];
  };
  protoOf($serializer_11).ql = function (decoder) {
    var tmp0_desc = this.rdc_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.no(tmp0_desc);
    if (tmp6_input.dp()) {
      tmp4_local0 = tmp6_input.xo(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.so(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.xo(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.so(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.oo(tmp0_desc);
    return TileCustomMetadata_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  var $serializer_instance_11;
  function $serializer_getInstance_11() {
    if ($serializer_instance_11 == null)
      new $serializer_11();
    return $serializer_instance_11;
  }
  function TileCustomMetadata_init_$Init$(seen1, data, tileID, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_11().rdc_1);
    }
    $this.sdc_1 = data;
    $this.tdc_1 = tileID;
    return $this;
  }
  function TileCustomMetadata_init_$Create$(seen1, data, tileID, serializationConstructorMarker) {
    return TileCustomMetadata_init_$Init$(seen1, data, tileID, serializationConstructorMarker, objectCreate(protoOf(TileCustomMetadata)));
  }
  function TileCustomMetadata() {
  }
  protoOf(TileCustomMetadata).toString = function () {
    return 'TileCustomMetadata(data=' + this.sdc_1 + ', tileID=' + this.tdc_1 + ')';
  };
  protoOf(TileCustomMetadata).hashCode = function () {
    var result = getStringHashCode(this.sdc_1);
    result = imul(result, 31) + this.tdc_1 | 0;
    return result;
  };
  protoOf(TileCustomMetadata).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TileCustomMetadata))
      return false;
    var tmp0_other_with_cast = other instanceof TileCustomMetadata ? other : THROW_CCE();
    if (!(this.sdc_1 === tmp0_other_with_cast.sdc_1))
      return false;
    if (!(this.tdc_1 === tmp0_other_with_cast.tdc_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj_8($this) {
    return $this.ddb_1.m2();
  }
  function EmbedAtlas$Companion$_anonymous__2y90yr() {
    return createSimpleEnumSerializer('korlibs.korge.ldtk.EmbedAtlas', values_8());
  }
  var EmbedAtlas_LdtkIcons_instance;
  function Companion_16() {
    Companion_instance_16 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ddb_1 = lazy(tmp_0, EmbedAtlas$Companion$_anonymous__2y90yr);
  }
  protoOf(Companion_16).pl = function () {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.EmbedAtlas', STRING_getInstance());
  };
  protoOf(Companion_16).ql = function (decoder) {
    var value = decoder.io();
    var tmp;
    if (value === 'LdtkIcons') {
      tmp = EmbedAtlas_LdtkIcons_getInstance();
    } else {
      throw IllegalArgumentException_init_$Create$('EmbedAtlas could not parse: ' + value);
    }
    return tmp;
  };
  protoOf(Companion_16).w13 = function () {
    return _get_$cachedSerializer__te6jhj_8(this);
  };
  protoOf(Companion_16).bv = function (typeParamsSerializers) {
    return this.w13();
  };
  var Companion_instance_16;
  function Companion_getInstance_16() {
    EmbedAtlas_initEntries();
    if (Companion_instance_16 == null)
      new Companion_16();
    return Companion_instance_16;
  }
  function values_8() {
    return [EmbedAtlas_LdtkIcons_getInstance()];
  }
  var EmbedAtlas_entriesInitialized;
  function EmbedAtlas_initEntries() {
    if (EmbedAtlas_entriesInitialized)
      return Unit_instance;
    EmbedAtlas_entriesInitialized = true;
    EmbedAtlas_LdtkIcons_instance = new EmbedAtlas('LdtkIcons', 0, 'LdtkIcons');
    Companion_getInstance_16();
  }
  function EmbedAtlas(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.wdc_1 = value;
  }
  function $serializer_12() {
    $serializer_instance_12 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.EnumTagValue', this, 2);
    tmp0_serialDesc.du('enumValueId', false);
    tmp0_serialDesc.du('tileIds', false);
    this.xdc_1 = tmp0_serialDesc;
  }
  protoOf($serializer_12).pl = function () {
    return this.xdc_1;
  };
  protoOf($serializer_12).su = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), IntArraySerializer_getInstance()];
  };
  protoOf($serializer_12).ql = function (decoder) {
    var tmp0_desc = this.xdc_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.no(tmp0_desc);
    if (tmp6_input.dp()) {
      tmp4_local0 = tmp6_input.xo(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zo(tmp0_desc, 1, IntArraySerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.xo(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zo(tmp0_desc, 1, IntArraySerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.oo(tmp0_desc);
    return EnumTagValue_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  var $serializer_instance_12;
  function $serializer_getInstance_12() {
    if ($serializer_instance_12 == null)
      new $serializer_12();
    return $serializer_instance_12;
  }
  function EnumTagValue_init_$Init$(seen1, enumValueID, tileIDS, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_12().xdc_1);
    }
    $this.ydc_1 = enumValueID;
    $this.zdc_1 = tileIDS;
    return $this;
  }
  function EnumTagValue_init_$Create$(seen1, enumValueID, tileIDS, serializationConstructorMarker) {
    return EnumTagValue_init_$Init$(seen1, enumValueID, tileIDS, serializationConstructorMarker, objectCreate(protoOf(EnumTagValue)));
  }
  function EnumTagValue() {
  }
  protoOf(EnumTagValue).toString = function () {
    return 'EnumTagValue(enumValueID=' + this.ydc_1 + ', tileIDS=' + toString(this.zdc_1) + ')';
  };
  protoOf(EnumTagValue).hashCode = function () {
    var result = getStringHashCode(this.ydc_1);
    result = imul(result, 31) + hashCode(this.zdc_1) | 0;
    return result;
  };
  protoOf(EnumTagValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EnumTagValue))
      return false;
    var tmp0_other_with_cast = other instanceof EnumTagValue ? other : THROW_CCE();
    if (!(this.ydc_1 === tmp0_other_with_cast.ydc_1))
      return false;
    if (!equals(this.zdc_1, tmp0_other_with_cast.zdc_1))
      return false;
    return true;
  };
  function Companion_17() {
    Companion_instance_17 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.cdd_1 = [null, null, null, Companion_getInstance_18().w13(), null, null, null, null, null, null, null, null, null, null, null, null, Companion_getInstance_19().w13(), null, null, null, null, null];
  }
  var Companion_instance_17;
  function Companion_getInstance_17() {
    if (Companion_instance_17 == null)
      new Companion_17();
    return Companion_instance_17;
  }
  function $serializer_13() {
    $serializer_instance_13 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.AutoLayerRuleDefinition', this, 22);
    tmp0_serialDesc.du('active', false);
    tmp0_serialDesc.du('breakOnMatch', false);
    tmp0_serialDesc.du('chance', false);
    tmp0_serialDesc.du('checker', false);
    tmp0_serialDesc.du('flipX', false);
    tmp0_serialDesc.du('flipY', false);
    tmp0_serialDesc.du('outOfBoundsValue', true);
    tmp0_serialDesc.du('pattern', false);
    tmp0_serialDesc.du('perlinActive', false);
    tmp0_serialDesc.du('perlinOctaves', false);
    tmp0_serialDesc.du('perlinScale', false);
    tmp0_serialDesc.du('perlinSeed', false);
    tmp0_serialDesc.du('pivotX', false);
    tmp0_serialDesc.du('pivotY', false);
    tmp0_serialDesc.du('size', false);
    tmp0_serialDesc.du('tileIds', false);
    tmp0_serialDesc.du('tileMode', false);
    tmp0_serialDesc.du('uid', false);
    tmp0_serialDesc.du('xModulo', false);
    tmp0_serialDesc.du('xOffset', false);
    tmp0_serialDesc.du('yModulo', false);
    tmp0_serialDesc.du('yOffset', false);
    this.ddd_1 = tmp0_serialDesc;
  }
  protoOf($serializer_13).pl = function () {
    return this.ddd_1;
  };
  protoOf($serializer_13).su = function () {
    var tmp0_cached = Companion_getInstance_17().cdd_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), DoubleSerializer_getInstance(), tmp0_cached[3], BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), IntArraySerializer_getInstance(), BooleanSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), IntSerializer_getInstance(), IntArraySerializer_getInstance(), tmp0_cached[16], IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
  };
  protoOf($serializer_13).ql = function (decoder) {
    var tmp0_desc = this.ddd_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_local1 = false;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_local5 = false;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = false;
    var tmp13_local9 = 0.0;
    var tmp14_local10 = 0.0;
    var tmp15_local11 = 0.0;
    var tmp16_local12 = 0.0;
    var tmp17_local13 = 0.0;
    var tmp18_local14 = 0;
    var tmp19_local15 = null;
    var tmp20_local16 = null;
    var tmp21_local17 = 0;
    var tmp22_local18 = 0;
    var tmp23_local19 = 0;
    var tmp24_local20 = 0;
    var tmp25_local21 = 0;
    var tmp26_input = decoder.no(tmp0_desc);
    var tmp27_cached = Companion_getInstance_17().cdd_1;
    if (tmp26_input.dp()) {
      tmp4_local0 = tmp26_input.po(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp26_input.po(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp26_input.vo(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp26_input.zo(tmp0_desc, 3, tmp27_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp26_input.po(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp26_input.po(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp26_input.bp(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp26_input.zo(tmp0_desc, 7, IntArraySerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp26_input.po(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp26_input.vo(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp26_input.vo(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp26_input.vo(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp26_input.vo(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp26_input.vo(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp26_input.so(tmp0_desc, 14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp26_input.zo(tmp0_desc, 15, IntArraySerializer_getInstance(), tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp26_input.zo(tmp0_desc, 16, tmp27_cached[16], tmp20_local16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp26_input.so(tmp0_desc, 17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp26_input.so(tmp0_desc, 18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp26_input.so(tmp0_desc, 19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp26_input.so(tmp0_desc, 20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp26_input.so(tmp0_desc, 21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp26_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp26_input.po(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp26_input.po(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp26_input.vo(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp26_input.zo(tmp0_desc, 3, tmp27_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp26_input.po(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp26_input.po(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp26_input.bp(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp26_input.zo(tmp0_desc, 7, IntArraySerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp26_input.po(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp26_input.vo(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp26_input.vo(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp26_input.vo(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp26_input.vo(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp26_input.vo(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp26_input.so(tmp0_desc, 14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp26_input.zo(tmp0_desc, 15, IntArraySerializer_getInstance(), tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp26_input.zo(tmp0_desc, 16, tmp27_cached[16], tmp20_local16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp26_input.so(tmp0_desc, 17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp26_input.so(tmp0_desc, 18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp26_input.so(tmp0_desc, 19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp26_input.so(tmp0_desc, 20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp26_input.so(tmp0_desc, 21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp26_input.oo(tmp0_desc);
    return AutoLayerRuleDefinition_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, null);
  };
  var $serializer_instance_13;
  function $serializer_getInstance_13() {
    if ($serializer_instance_13 == null)
      new $serializer_13();
    return $serializer_instance_13;
  }
  function AutoLayerRuleDefinition_init_$Init$(seen1, active, breakOnMatch, chance, checker, flipX, flipY, outOfBoundsValue, pattern, perlinActive, perlinOctaves, perlinScale, perlinSeed, pivotX, pivotY, size, tileIDS, tileMode, uid, xModulo, xOffset, yModulo, yOffset, serializationConstructorMarker, $this) {
    if (!(4194239 === (4194239 & seen1))) {
      throwMissingFieldException(seen1, 4194239, $serializer_getInstance_13().ddd_1);
    }
    $this.edd_1 = active;
    $this.fdd_1 = breakOnMatch;
    $this.gdd_1 = chance;
    $this.hdd_1 = checker;
    $this.idd_1 = flipX;
    $this.jdd_1 = flipY;
    if (0 === (seen1 & 64))
      $this.kdd_1 = null;
    else
      $this.kdd_1 = outOfBoundsValue;
    $this.ldd_1 = pattern;
    $this.mdd_1 = perlinActive;
    $this.ndd_1 = perlinOctaves;
    $this.odd_1 = perlinScale;
    $this.pdd_1 = perlinSeed;
    $this.qdd_1 = pivotX;
    $this.rdd_1 = pivotY;
    $this.sdd_1 = size;
    $this.tdd_1 = tileIDS;
    $this.udd_1 = tileMode;
    $this.vdd_1 = uid;
    $this.wdd_1 = xModulo;
    $this.xdd_1 = xOffset;
    $this.ydd_1 = yModulo;
    $this.zdd_1 = yOffset;
    return $this;
  }
  function AutoLayerRuleDefinition_init_$Create$(seen1, active, breakOnMatch, chance, checker, flipX, flipY, outOfBoundsValue, pattern, perlinActive, perlinOctaves, perlinScale, perlinSeed, pivotX, pivotY, size, tileIDS, tileMode, uid, xModulo, xOffset, yModulo, yOffset, serializationConstructorMarker) {
    return AutoLayerRuleDefinition_init_$Init$(seen1, active, breakOnMatch, chance, checker, flipX, flipY, outOfBoundsValue, pattern, perlinActive, perlinOctaves, perlinScale, perlinSeed, pivotX, pivotY, size, tileIDS, tileMode, uid, xModulo, xOffset, yModulo, yOffset, serializationConstructorMarker, objectCreate(protoOf(AutoLayerRuleDefinition)));
  }
  function AutoLayerRuleDefinition() {
  }
  protoOf(AutoLayerRuleDefinition).toString = function () {
    return 'AutoLayerRuleDefinition(active=' + this.edd_1 + ', breakOnMatch=' + this.fdd_1 + ', chance=' + this.gdd_1 + ', checker=' + this.hdd_1 + ', flipX=' + this.idd_1 + ', flipY=' + this.jdd_1 + ', outOfBoundsValue=' + this.kdd_1 + ', pattern=' + toString(this.ldd_1) + ', perlinActive=' + this.mdd_1 + ', perlinOctaves=' + this.ndd_1 + ', perlinScale=' + this.odd_1 + ', perlinSeed=' + this.pdd_1 + ', pivotX=' + this.qdd_1 + ', pivotY=' + this.rdd_1 + ', size=' + this.sdd_1 + ', tileIDS=' + toString(this.tdd_1) + ', tileMode=' + this.udd_1 + ', uid=' + this.vdd_1 + ', xModulo=' + this.wdd_1 + ', xOffset=' + this.xdd_1 + ', yModulo=' + this.ydd_1 + ', yOffset=' + this.zdd_1 + ')';
  };
  protoOf(AutoLayerRuleDefinition).hashCode = function () {
    var result = getBooleanHashCode(this.edd_1);
    result = imul(result, 31) + getBooleanHashCode(this.fdd_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.gdd_1) | 0;
    result = imul(result, 31) + this.hdd_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.idd_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.jdd_1) | 0;
    result = imul(result, 31) + (this.kdd_1 == null ? 0 : this.kdd_1) | 0;
    result = imul(result, 31) + hashCode(this.ldd_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.mdd_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ndd_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.odd_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.pdd_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.qdd_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.rdd_1) | 0;
    result = imul(result, 31) + this.sdd_1 | 0;
    result = imul(result, 31) + hashCode(this.tdd_1) | 0;
    result = imul(result, 31) + this.udd_1.hashCode() | 0;
    result = imul(result, 31) + this.vdd_1 | 0;
    result = imul(result, 31) + this.wdd_1 | 0;
    result = imul(result, 31) + this.xdd_1 | 0;
    result = imul(result, 31) + this.ydd_1 | 0;
    result = imul(result, 31) + this.zdd_1 | 0;
    return result;
  };
  protoOf(AutoLayerRuleDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AutoLayerRuleDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof AutoLayerRuleDefinition ? other : THROW_CCE();
    if (!(this.edd_1 === tmp0_other_with_cast.edd_1))
      return false;
    if (!(this.fdd_1 === tmp0_other_with_cast.fdd_1))
      return false;
    if (!equals(this.gdd_1, tmp0_other_with_cast.gdd_1))
      return false;
    if (!this.hdd_1.equals(tmp0_other_with_cast.hdd_1))
      return false;
    if (!(this.idd_1 === tmp0_other_with_cast.idd_1))
      return false;
    if (!(this.jdd_1 === tmp0_other_with_cast.jdd_1))
      return false;
    if (!(this.kdd_1 == tmp0_other_with_cast.kdd_1))
      return false;
    if (!equals(this.ldd_1, tmp0_other_with_cast.ldd_1))
      return false;
    if (!(this.mdd_1 === tmp0_other_with_cast.mdd_1))
      return false;
    if (!equals(this.ndd_1, tmp0_other_with_cast.ndd_1))
      return false;
    if (!equals(this.odd_1, tmp0_other_with_cast.odd_1))
      return false;
    if (!equals(this.pdd_1, tmp0_other_with_cast.pdd_1))
      return false;
    if (!equals(this.qdd_1, tmp0_other_with_cast.qdd_1))
      return false;
    if (!equals(this.rdd_1, tmp0_other_with_cast.rdd_1))
      return false;
    if (!(this.sdd_1 === tmp0_other_with_cast.sdd_1))
      return false;
    if (!equals(this.tdd_1, tmp0_other_with_cast.tdd_1))
      return false;
    if (!this.udd_1.equals(tmp0_other_with_cast.udd_1))
      return false;
    if (!(this.vdd_1 === tmp0_other_with_cast.vdd_1))
      return false;
    if (!(this.wdd_1 === tmp0_other_with_cast.wdd_1))
      return false;
    if (!(this.xdd_1 === tmp0_other_with_cast.xdd_1))
      return false;
    if (!(this.ydd_1 === tmp0_other_with_cast.ydd_1))
      return false;
    if (!(this.zdd_1 === tmp0_other_with_cast.zdd_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj_9($this) {
    return $this.add_1.m2();
  }
  function Checker$Companion$_anonymous__y7s1qy() {
    return createSimpleEnumSerializer('korlibs.korge.ldtk.Checker', values_9());
  }
  var Checker_Horizontal_instance;
  var Checker_None_instance;
  var Checker_Vertical_instance;
  function Companion_18() {
    Companion_instance_18 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.add_1 = lazy(tmp_0, Checker$Companion$_anonymous__y7s1qy);
  }
  protoOf(Companion_18).pl = function () {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.Checker', STRING_getInstance());
  };
  protoOf(Companion_18).ql = function (decoder) {
    var value = decoder.io();
    var tmp;
    switch (value) {
      case 'Horizontal':
        tmp = Checker_Horizontal_getInstance();
        break;
      case 'None':
        tmp = Checker_None_getInstance();
        break;
      case 'Vertical':
        tmp = Checker_Vertical_getInstance();
        break;
      default:
        throw IllegalArgumentException_init_$Create$('Checker could not parse: ' + value);
    }
    return tmp;
  };
  protoOf(Companion_18).w13 = function () {
    return _get_$cachedSerializer__te6jhj_9(this);
  };
  protoOf(Companion_18).bv = function (typeParamsSerializers) {
    return this.w13();
  };
  var Companion_instance_18;
  function Companion_getInstance_18() {
    Checker_initEntries();
    if (Companion_instance_18 == null)
      new Companion_18();
    return Companion_instance_18;
  }
  function values_9() {
    return [Checker_Horizontal_getInstance(), Checker_None_getInstance(), Checker_Vertical_getInstance()];
  }
  var Checker_entriesInitialized;
  function Checker_initEntries() {
    if (Checker_entriesInitialized)
      return Unit_instance;
    Checker_entriesInitialized = true;
    Checker_Horizontal_instance = new Checker('Horizontal', 0, 'Horizontal');
    Checker_None_instance = new Checker('None', 1, 'None');
    Checker_Vertical_instance = new Checker('Vertical', 2, 'Vertical');
    Companion_getInstance_18();
  }
  function Checker(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.cde_1 = value;
  }
  function _get_$cachedSerializer__te6jhj_10($this) {
    return $this.bdd_1.m2();
  }
  function TileMode$Companion$_anonymous__ez765a() {
    return createSimpleEnumSerializer('korlibs.korge.ldtk.TileMode', values_10());
  }
  var TileMode_Single_instance;
  var TileMode_Stamp_instance;
  function Companion_19() {
    Companion_instance_19 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.bdd_1 = lazy(tmp_0, TileMode$Companion$_anonymous__ez765a);
  }
  protoOf(Companion_19).pl = function () {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.TileMode', STRING_getInstance());
  };
  protoOf(Companion_19).ql = function (decoder) {
    var value = decoder.io();
    var tmp;
    switch (value) {
      case 'Single':
        tmp = TileMode_Single_getInstance();
        break;
      case 'Stamp':
        tmp = TileMode_Stamp_getInstance();
        break;
      default:
        throw IllegalArgumentException_init_$Create$('TileMode could not parse: ' + value);
    }
    return tmp;
  };
  protoOf(Companion_19).w13 = function () {
    return _get_$cachedSerializer__te6jhj_10(this);
  };
  protoOf(Companion_19).bv = function (typeParamsSerializers) {
    return this.w13();
  };
  var Companion_instance_19;
  function Companion_getInstance_19() {
    TileMode_initEntries();
    if (Companion_instance_19 == null)
      new Companion_19();
    return Companion_instance_19;
  }
  function values_10() {
    return [TileMode_Single_getInstance(), TileMode_Stamp_getInstance()];
  }
  var TileMode_entriesInitialized;
  function TileMode_initEntries() {
    if (TileMode_entriesInitialized)
      return Unit_instance;
    TileMode_entriesInitialized = true;
    TileMode_Single_instance = new TileMode('Single', 0, 'Single');
    TileMode_Stamp_instance = new TileMode('Stamp', 1, 'Stamp');
    Companion_getInstance_19();
  }
  function TileMode(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.fde_1 = value;
  }
  function LDTKJson$Companion$load$lambda($this$Json) {
    $this$Json.j12_1 = true;
    return Unit_instance;
  }
  function Companion_20() {
    Companion_instance_20 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.kde_1 = [null, null, null, null, null, null, null, null, null, null, null, null, null, null, new ArrayListSerializer(Companion_getInstance_24().w13()), Companion_getInstance_25().w13(), Companion_getInstance_26().w13(), null, null, new ArrayListSerializer($serializer_getInstance_15()), null, null, null, null, null, null, null, Companion_getInstance_27().w13(), new ArrayListSerializer($serializer_getInstance_19())];
  }
  protoOf(Companion_20).da5 = function (jsonString) {
    // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
    var this_0 = Json(VOID, LDTKJson$Companion$load$lambda);
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.cp();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(LDTKJson), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    return this_0.t11(tmp$ret$1, jsonString);
  };
  var Companion_instance_20;
  function Companion_getInstance_20() {
    if (Companion_instance_20 == null)
      new Companion_20();
    return Companion_instance_20;
  }
  function $serializer_14() {
    $serializer_instance_14 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.LDTKJson', this, 29);
    tmp0_serialDesc.du('__FORCED_REFS', true);
    tmp0_serialDesc.du('appBuildId', false);
    tmp0_serialDesc.du('backupLimit', false);
    tmp0_serialDesc.du('backupOnSave', false);
    tmp0_serialDesc.du('bgColor', false);
    tmp0_serialDesc.du('defaultGridSize', false);
    tmp0_serialDesc.du('defaultLevelBgColor', false);
    tmp0_serialDesc.du('defaultLevelHeight', true);
    tmp0_serialDesc.du('defaultLevelWidth', true);
    tmp0_serialDesc.du('defaultPivotX', false);
    tmp0_serialDesc.du('defaultPivotY', false);
    tmp0_serialDesc.du('defs', false);
    tmp0_serialDesc.du('exportTiled', false);
    tmp0_serialDesc.du('externalLevels', false);
    tmp0_serialDesc.du('flags', false);
    tmp0_serialDesc.du('identifierStyle', false);
    tmp0_serialDesc.du('imageExportMode', false);
    tmp0_serialDesc.du('jsonVersion', false);
    tmp0_serialDesc.du('levelNamePattern', false);
    tmp0_serialDesc.du('levels', false);
    tmp0_serialDesc.du('minifyJson', false);
    tmp0_serialDesc.du('nextUid', false);
    tmp0_serialDesc.du('pngFilePattern', true);
    tmp0_serialDesc.du('simplifiedExport', false);
    tmp0_serialDesc.du('tutorialDesc', true);
    tmp0_serialDesc.du('worldGridHeight', true);
    tmp0_serialDesc.du('worldGridWidth', true);
    tmp0_serialDesc.du('worldLayout', true);
    tmp0_serialDesc.du('worlds', false);
    this.lde_1 = tmp0_serialDesc;
  }
  protoOf($serializer_14).pl = function () {
    return this.lde_1;
  };
  protoOf($serializer_14).su = function () {
    var tmp0_cached = Companion_getInstance_20().kde_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_18()), DoubleSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), $serializer_getInstance_3(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[14], tmp0_cached[15], tmp0_cached[16], StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[19], BooleanSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(tmp0_cached[27]), tmp0_cached[28]];
  };
  protoOf($serializer_14).ql = function (decoder) {
    var tmp0_desc = this.lde_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0;
    var tmp7_local3 = false;
    var tmp8_local4 = null;
    var tmp9_local5 = 0;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = 0.0;
    var tmp14_local10 = 0.0;
    var tmp15_local11 = null;
    var tmp16_local12 = false;
    var tmp17_local13 = false;
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_local16 = null;
    var tmp21_local17 = null;
    var tmp22_local18 = null;
    var tmp23_local19 = null;
    var tmp24_local20 = false;
    var tmp25_local21 = 0;
    var tmp26_local22 = null;
    var tmp27_local23 = false;
    var tmp28_local24 = null;
    var tmp29_local25 = null;
    var tmp30_local26 = null;
    var tmp31_local27 = null;
    var tmp32_local28 = null;
    var tmp33_input = decoder.no(tmp0_desc);
    var tmp34_cached = Companion_getInstance_20().kde_1;
    if (tmp33_input.dp()) {
      tmp4_local0 = tmp33_input.bp(tmp0_desc, 0, $serializer_getInstance_18(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp33_input.vo(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp33_input.so(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp33_input.po(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp33_input.xo(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp33_input.so(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp33_input.xo(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp33_input.bp(tmp0_desc, 7, IntSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp33_input.bp(tmp0_desc, 8, IntSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp33_input.vo(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp33_input.vo(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp33_input.zo(tmp0_desc, 11, $serializer_getInstance_3(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp33_input.po(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp33_input.po(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp33_input.zo(tmp0_desc, 14, tmp34_cached[14], tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp33_input.zo(tmp0_desc, 15, tmp34_cached[15], tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp33_input.zo(tmp0_desc, 16, tmp34_cached[16], tmp20_local16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp33_input.xo(tmp0_desc, 17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp33_input.xo(tmp0_desc, 18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp33_input.zo(tmp0_desc, 19, tmp34_cached[19], tmp23_local19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp33_input.po(tmp0_desc, 20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp33_input.so(tmp0_desc, 21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp26_local22 = tmp33_input.bp(tmp0_desc, 22, StringSerializer_getInstance(), tmp26_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
      tmp27_local23 = tmp33_input.po(tmp0_desc, 23);
      tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
      tmp28_local24 = tmp33_input.bp(tmp0_desc, 24, StringSerializer_getInstance(), tmp28_local24);
      tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
      tmp29_local25 = tmp33_input.bp(tmp0_desc, 25, IntSerializer_getInstance(), tmp29_local25);
      tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
      tmp30_local26 = tmp33_input.bp(tmp0_desc, 26, IntSerializer_getInstance(), tmp30_local26);
      tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
      tmp31_local27 = tmp33_input.bp(tmp0_desc, 27, tmp34_cached[27], tmp31_local27);
      tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
      tmp32_local28 = tmp33_input.zo(tmp0_desc, 28, tmp34_cached[28], tmp32_local28);
      tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp33_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp33_input.bp(tmp0_desc, 0, $serializer_getInstance_18(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp33_input.vo(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp33_input.so(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp33_input.po(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp33_input.xo(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp33_input.so(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp33_input.xo(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp33_input.bp(tmp0_desc, 7, IntSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp33_input.bp(tmp0_desc, 8, IntSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp33_input.vo(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp33_input.vo(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp33_input.zo(tmp0_desc, 11, $serializer_getInstance_3(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp33_input.po(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp33_input.po(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp33_input.zo(tmp0_desc, 14, tmp34_cached[14], tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp33_input.zo(tmp0_desc, 15, tmp34_cached[15], tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp33_input.zo(tmp0_desc, 16, tmp34_cached[16], tmp20_local16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp33_input.xo(tmp0_desc, 17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp33_input.xo(tmp0_desc, 18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp33_input.zo(tmp0_desc, 19, tmp34_cached[19], tmp23_local19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp33_input.po(tmp0_desc, 20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp33_input.so(tmp0_desc, 21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp26_local22 = tmp33_input.bp(tmp0_desc, 22, StringSerializer_getInstance(), tmp26_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          case 23:
            tmp27_local23 = tmp33_input.po(tmp0_desc, 23);
            tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
            break;
          case 24:
            tmp28_local24 = tmp33_input.bp(tmp0_desc, 24, StringSerializer_getInstance(), tmp28_local24);
            tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
            break;
          case 25:
            tmp29_local25 = tmp33_input.bp(tmp0_desc, 25, IntSerializer_getInstance(), tmp29_local25);
            tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
            break;
          case 26:
            tmp30_local26 = tmp33_input.bp(tmp0_desc, 26, IntSerializer_getInstance(), tmp30_local26);
            tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
            break;
          case 27:
            tmp31_local27 = tmp33_input.bp(tmp0_desc, 27, tmp34_cached[27], tmp31_local27);
            tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
            break;
          case 28:
            tmp32_local28 = tmp33_input.zo(tmp0_desc, 28, tmp34_cached[28], tmp32_local28);
            tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp33_input.oo(tmp0_desc);
    return LDTKJson_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, tmp28_local24, tmp29_local25, tmp30_local26, tmp31_local27, tmp32_local28, null);
  };
  var $serializer_instance_14;
  function $serializer_getInstance_14() {
    if ($serializer_instance_14 == null)
      new $serializer_14();
    return $serializer_instance_14;
  }
  function LDTKJson_init_$Init$(seen1, forcedRefs, appBuildID, backupLimit, backupOnSave, bgColor, defaultGridSize, defaultLevelBgColor, defaultLevelHeight, defaultLevelWidth, defaultPivotX, defaultPivotY, defs, exportTiled, externalLevels, flags, identifierStyle, imageExportMode, jsonVersion, levelNamePattern, levels, minifyJSON, nextUid, pngFilePattern, simplifiedExport, tutorialDesc, worldGridHeight, worldGridWidth, worldLayout, worlds, serializationConstructorMarker, $this) {
    if (!(281017982 === (281017982 & seen1))) {
      throwMissingFieldException(seen1, 281017982, $serializer_getInstance_14().lde_1);
    }
    if (0 === (seen1 & 1))
      $this.mde_1 = null;
    else
      $this.mde_1 = forcedRefs;
    $this.nde_1 = appBuildID;
    $this.ode_1 = backupLimit;
    $this.pde_1 = backupOnSave;
    $this.qde_1 = bgColor;
    $this.rde_1 = defaultGridSize;
    $this.sde_1 = defaultLevelBgColor;
    if (0 === (seen1 & 128))
      $this.tde_1 = null;
    else
      $this.tde_1 = defaultLevelHeight;
    if (0 === (seen1 & 256))
      $this.ude_1 = null;
    else
      $this.ude_1 = defaultLevelWidth;
    $this.vde_1 = defaultPivotX;
    $this.wde_1 = defaultPivotY;
    $this.xde_1 = defs;
    $this.yde_1 = exportTiled;
    $this.zde_1 = externalLevels;
    $this.adf_1 = flags;
    $this.bdf_1 = identifierStyle;
    $this.cdf_1 = imageExportMode;
    $this.ddf_1 = jsonVersion;
    $this.edf_1 = levelNamePattern;
    $this.fdf_1 = levels;
    $this.gdf_1 = minifyJSON;
    $this.hdf_1 = nextUid;
    if (0 === (seen1 & 4194304))
      $this.idf_1 = null;
    else
      $this.idf_1 = pngFilePattern;
    $this.jdf_1 = simplifiedExport;
    if (0 === (seen1 & 16777216))
      $this.kdf_1 = null;
    else
      $this.kdf_1 = tutorialDesc;
    if (0 === (seen1 & 33554432))
      $this.ldf_1 = null;
    else
      $this.ldf_1 = worldGridHeight;
    if (0 === (seen1 & 67108864))
      $this.mdf_1 = null;
    else
      $this.mdf_1 = worldGridWidth;
    if (0 === (seen1 & 134217728))
      $this.ndf_1 = null;
    else
      $this.ndf_1 = worldLayout;
    $this.odf_1 = worlds;
    return $this;
  }
  function LDTKJson_init_$Create$(seen1, forcedRefs, appBuildID, backupLimit, backupOnSave, bgColor, defaultGridSize, defaultLevelBgColor, defaultLevelHeight, defaultLevelWidth, defaultPivotX, defaultPivotY, defs, exportTiled, externalLevels, flags, identifierStyle, imageExportMode, jsonVersion, levelNamePattern, levels, minifyJSON, nextUid, pngFilePattern, simplifiedExport, tutorialDesc, worldGridHeight, worldGridWidth, worldLayout, worlds, serializationConstructorMarker) {
    return LDTKJson_init_$Init$(seen1, forcedRefs, appBuildID, backupLimit, backupOnSave, bgColor, defaultGridSize, defaultLevelBgColor, defaultLevelHeight, defaultLevelWidth, defaultPivotX, defaultPivotY, defs, exportTiled, externalLevels, flags, identifierStyle, imageExportMode, jsonVersion, levelNamePattern, levels, minifyJSON, nextUid, pngFilePattern, simplifiedExport, tutorialDesc, worldGridHeight, worldGridWidth, worldLayout, worlds, serializationConstructorMarker, objectCreate(protoOf(LDTKJson)));
  }
  function LDTKJson(forcedRefs, appBuildID, backupLimit, backupOnSave, bgColor, defaultGridSize, defaultLevelBgColor, defaultLevelHeight, defaultLevelWidth, defaultPivotX, defaultPivotY, defs, exportTiled, externalLevels, flags, identifierStyle, imageExportMode, jsonVersion, levelNamePattern, levels, minifyJSON, nextUid, pngFilePattern, simplifiedExport, tutorialDesc, worldGridHeight, worldGridWidth, worldLayout, worlds) {
    Companion_getInstance_20();
    forcedRefs = forcedRefs === VOID ? null : forcedRefs;
    defaultLevelHeight = defaultLevelHeight === VOID ? null : defaultLevelHeight;
    defaultLevelWidth = defaultLevelWidth === VOID ? null : defaultLevelWidth;
    pngFilePattern = pngFilePattern === VOID ? null : pngFilePattern;
    tutorialDesc = tutorialDesc === VOID ? null : tutorialDesc;
    worldGridHeight = worldGridHeight === VOID ? null : worldGridHeight;
    worldGridWidth = worldGridWidth === VOID ? null : worldGridWidth;
    worldLayout = worldLayout === VOID ? null : worldLayout;
    this.mde_1 = forcedRefs;
    this.nde_1 = appBuildID;
    this.ode_1 = backupLimit;
    this.pde_1 = backupOnSave;
    this.qde_1 = bgColor;
    this.rde_1 = defaultGridSize;
    this.sde_1 = defaultLevelBgColor;
    this.tde_1 = defaultLevelHeight;
    this.ude_1 = defaultLevelWidth;
    this.vde_1 = defaultPivotX;
    this.wde_1 = defaultPivotY;
    this.xde_1 = defs;
    this.yde_1 = exportTiled;
    this.zde_1 = externalLevels;
    this.adf_1 = flags;
    this.bdf_1 = identifierStyle;
    this.cdf_1 = imageExportMode;
    this.ddf_1 = jsonVersion;
    this.edf_1 = levelNamePattern;
    this.fdf_1 = levels;
    this.gdf_1 = minifyJSON;
    this.hdf_1 = nextUid;
    this.idf_1 = pngFilePattern;
    this.jdf_1 = simplifiedExport;
    this.kdf_1 = tutorialDesc;
    this.ldf_1 = worldGridHeight;
    this.mdf_1 = worldGridWidth;
    this.ndf_1 = worldLayout;
    this.odf_1 = worlds;
  }
  protoOf(LDTKJson).toString = function () {
    return 'LDTKJson(forcedRefs=' + this.mde_1 + ', appBuildID=' + this.nde_1 + ', backupLimit=' + this.ode_1 + ', backupOnSave=' + this.pde_1 + ', bgColor=' + this.qde_1 + ', defaultGridSize=' + this.rde_1 + ', defaultLevelBgColor=' + this.sde_1 + ', defaultLevelHeight=' + this.tde_1 + ', defaultLevelWidth=' + this.ude_1 + ', defaultPivotX=' + this.vde_1 + ', defaultPivotY=' + this.wde_1 + ', defs=' + this.xde_1 + ', exportTiled=' + this.yde_1 + ', externalLevels=' + this.zde_1 + ', flags=' + this.adf_1 + ', identifierStyle=' + this.bdf_1 + ', imageExportMode=' + this.cdf_1 + ', jsonVersion=' + this.ddf_1 + ', levelNamePattern=' + this.edf_1 + ', levels=' + this.fdf_1 + ', minifyJSON=' + this.gdf_1 + ', nextUid=' + this.hdf_1 + ', pngFilePattern=' + this.idf_1 + ', simplifiedExport=' + this.jdf_1 + ', tutorialDesc=' + this.kdf_1 + ', worldGridHeight=' + this.ldf_1 + ', worldGridWidth=' + this.mdf_1 + ', worldLayout=' + this.ndf_1 + ', worlds=' + this.odf_1 + ')';
  };
  protoOf(LDTKJson).hashCode = function () {
    var result = this.mde_1 == null ? 0 : this.mde_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.nde_1) | 0;
    result = imul(result, 31) + this.ode_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.pde_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.qde_1) | 0;
    result = imul(result, 31) + this.rde_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.sde_1) | 0;
    result = imul(result, 31) + (this.tde_1 == null ? 0 : this.tde_1) | 0;
    result = imul(result, 31) + (this.ude_1 == null ? 0 : this.ude_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.vde_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.wde_1) | 0;
    result = imul(result, 31) + this.xde_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.yde_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.zde_1) | 0;
    result = imul(result, 31) + hashCode(this.adf_1) | 0;
    result = imul(result, 31) + this.bdf_1.hashCode() | 0;
    result = imul(result, 31) + this.cdf_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.ddf_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.edf_1) | 0;
    result = imul(result, 31) + hashCode(this.fdf_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.gdf_1) | 0;
    result = imul(result, 31) + this.hdf_1 | 0;
    result = imul(result, 31) + (this.idf_1 == null ? 0 : getStringHashCode(this.idf_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.jdf_1) | 0;
    result = imul(result, 31) + (this.kdf_1 == null ? 0 : getStringHashCode(this.kdf_1)) | 0;
    result = imul(result, 31) + (this.ldf_1 == null ? 0 : this.ldf_1) | 0;
    result = imul(result, 31) + (this.mdf_1 == null ? 0 : this.mdf_1) | 0;
    result = imul(result, 31) + (this.ndf_1 == null ? 0 : this.ndf_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.odf_1) | 0;
    return result;
  };
  protoOf(LDTKJson).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LDTKJson))
      return false;
    var tmp0_other_with_cast = other instanceof LDTKJson ? other : THROW_CCE();
    if (!equals(this.mde_1, tmp0_other_with_cast.mde_1))
      return false;
    if (!equals(this.nde_1, tmp0_other_with_cast.nde_1))
      return false;
    if (!(this.ode_1 === tmp0_other_with_cast.ode_1))
      return false;
    if (!(this.pde_1 === tmp0_other_with_cast.pde_1))
      return false;
    if (!(this.qde_1 === tmp0_other_with_cast.qde_1))
      return false;
    if (!(this.rde_1 === tmp0_other_with_cast.rde_1))
      return false;
    if (!(this.sde_1 === tmp0_other_with_cast.sde_1))
      return false;
    if (!(this.tde_1 == tmp0_other_with_cast.tde_1))
      return false;
    if (!(this.ude_1 == tmp0_other_with_cast.ude_1))
      return false;
    if (!equals(this.vde_1, tmp0_other_with_cast.vde_1))
      return false;
    if (!equals(this.wde_1, tmp0_other_with_cast.wde_1))
      return false;
    if (!this.xde_1.equals(tmp0_other_with_cast.xde_1))
      return false;
    if (!(this.yde_1 === tmp0_other_with_cast.yde_1))
      return false;
    if (!(this.zde_1 === tmp0_other_with_cast.zde_1))
      return false;
    if (!equals(this.adf_1, tmp0_other_with_cast.adf_1))
      return false;
    if (!this.bdf_1.equals(tmp0_other_with_cast.bdf_1))
      return false;
    if (!this.cdf_1.equals(tmp0_other_with_cast.cdf_1))
      return false;
    if (!(this.ddf_1 === tmp0_other_with_cast.ddf_1))
      return false;
    if (!(this.edf_1 === tmp0_other_with_cast.edf_1))
      return false;
    if (!equals(this.fdf_1, tmp0_other_with_cast.fdf_1))
      return false;
    if (!(this.gdf_1 === tmp0_other_with_cast.gdf_1))
      return false;
    if (!(this.hdf_1 === tmp0_other_with_cast.hdf_1))
      return false;
    if (!(this.idf_1 == tmp0_other_with_cast.idf_1))
      return false;
    if (!(this.jdf_1 === tmp0_other_with_cast.jdf_1))
      return false;
    if (!(this.kdf_1 == tmp0_other_with_cast.kdf_1))
      return false;
    if (!(this.ldf_1 == tmp0_other_with_cast.ldf_1))
      return false;
    if (!(this.mdf_1 == tmp0_other_with_cast.mdf_1))
      return false;
    if (!equals(this.ndf_1, tmp0_other_with_cast.ndf_1))
      return false;
    if (!equals(this.odf_1, tmp0_other_with_cast.odf_1))
      return false;
    return true;
  };
  function Companion_21() {
    Companion_instance_21 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.qdf_1 = [null, null, new ArrayListSerializer($serializer_getInstance_21()), null, null, null, null, Companion_getInstance_30().w13(), null, null, new ArrayListSerializer($serializer_getInstance()), null, null, new ArrayListSerializer($serializer_getInstance_16()), null, null, null, null, null, null, null];
  }
  var Companion_instance_21;
  function Companion_getInstance_21() {
    if (Companion_instance_21 == null)
      new Companion_21();
    return Companion_instance_21;
  }
  function $serializer_15() {
    $serializer_instance_15 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.Level', this, 21);
    tmp0_serialDesc.du('__bgColor', false);
    tmp0_serialDesc.du('__bgPos', true);
    tmp0_serialDesc.du('__neighbours', false);
    tmp0_serialDesc.du('__smartColor', false);
    tmp0_serialDesc.du('bgColor', true);
    tmp0_serialDesc.du('bgPivotX', false);
    tmp0_serialDesc.du('bgPivotY', false);
    tmp0_serialDesc.du('bgPos', true);
    tmp0_serialDesc.du('bgRelPath', true);
    tmp0_serialDesc.du('externalRelPath', true);
    tmp0_serialDesc.du('fieldInstances', false);
    tmp0_serialDesc.du('identifier', false);
    tmp0_serialDesc.du('iid', false);
    tmp0_serialDesc.du('layerInstances', true);
    tmp0_serialDesc.du('pxHei', false);
    tmp0_serialDesc.du('pxWid', false);
    tmp0_serialDesc.du('uid', false);
    tmp0_serialDesc.du('useAutoIdentifier', false);
    tmp0_serialDesc.du('worldDepth', false);
    tmp0_serialDesc.du('worldX', false);
    tmp0_serialDesc.du('worldY', false);
    this.rdf_1 = tmp0_serialDesc;
  }
  protoOf($serializer_15).pl = function () {
    return this.rdf_1;
  };
  protoOf($serializer_15).su = function () {
    var tmp0_cached = Companion_getInstance_21().qdf_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable($serializer_getInstance_20()), tmp0_cached[2], StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), get_nullable(tmp0_cached[7]), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[10], StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(tmp0_cached[13]), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
  };
  protoOf($serializer_15).ql = function (decoder) {
    var tmp0_desc = this.rdf_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = 0.0;
    var tmp10_local6 = 0.0;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = 0;
    var tmp19_local15 = 0;
    var tmp20_local16 = 0;
    var tmp21_local17 = false;
    var tmp22_local18 = 0;
    var tmp23_local19 = 0;
    var tmp24_local20 = 0;
    var tmp25_input = decoder.no(tmp0_desc);
    var tmp26_cached = Companion_getInstance_21().qdf_1;
    if (tmp25_input.dp()) {
      tmp4_local0 = tmp25_input.xo(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp25_input.bp(tmp0_desc, 1, $serializer_getInstance_20(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp25_input.zo(tmp0_desc, 2, tmp26_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp25_input.xo(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp25_input.bp(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp25_input.vo(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp25_input.vo(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp25_input.bp(tmp0_desc, 7, tmp26_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp25_input.bp(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp25_input.bp(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp25_input.zo(tmp0_desc, 10, tmp26_cached[10], tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp25_input.xo(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp25_input.xo(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp25_input.bp(tmp0_desc, 13, tmp26_cached[13], tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp25_input.so(tmp0_desc, 14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp25_input.so(tmp0_desc, 15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp25_input.so(tmp0_desc, 16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp25_input.po(tmp0_desc, 17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp25_input.so(tmp0_desc, 18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp25_input.so(tmp0_desc, 19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp25_input.so(tmp0_desc, 20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp25_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp25_input.xo(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp25_input.bp(tmp0_desc, 1, $serializer_getInstance_20(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp25_input.zo(tmp0_desc, 2, tmp26_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp25_input.xo(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp25_input.bp(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp25_input.vo(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp25_input.vo(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp25_input.bp(tmp0_desc, 7, tmp26_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp25_input.bp(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp25_input.bp(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp25_input.zo(tmp0_desc, 10, tmp26_cached[10], tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp25_input.xo(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp25_input.xo(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp25_input.bp(tmp0_desc, 13, tmp26_cached[13], tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp25_input.so(tmp0_desc, 14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp25_input.so(tmp0_desc, 15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp25_input.so(tmp0_desc, 16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp25_input.po(tmp0_desc, 17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp25_input.so(tmp0_desc, 18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp25_input.so(tmp0_desc, 19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp25_input.so(tmp0_desc, 20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp25_input.oo(tmp0_desc);
    return Level_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, null);
  };
  var $serializer_instance_15;
  function $serializer_getInstance_15() {
    if ($serializer_instance_15 == null)
      new $serializer_15();
    return $serializer_instance_15;
  }
  function Level_init_$Init$(seen1, bgColor, bgPos, neighbours, smartColor, levelBgColor, bgPivotX, bgPivotY, levelBgPos, bgRelPath, externalRelPath, fieldInstances, identifier, iid, layerInstances, pxHei, pxWid, uid, useAutoIdentifier, worldDepth, worldX, worldY, serializationConstructorMarker, $this) {
    if (!(2088045 === (2088045 & seen1))) {
      throwMissingFieldException(seen1, 2088045, $serializer_getInstance_15().rdf_1);
    }
    $this.sdf_1 = bgColor;
    if (0 === (seen1 & 2))
      $this.tdf_1 = null;
    else
      $this.tdf_1 = bgPos;
    $this.udf_1 = neighbours;
    $this.vdf_1 = smartColor;
    if (0 === (seen1 & 16))
      $this.wdf_1 = null;
    else
      $this.wdf_1 = levelBgColor;
    $this.xdf_1 = bgPivotX;
    $this.ydf_1 = bgPivotY;
    if (0 === (seen1 & 128))
      $this.zdf_1 = null;
    else
      $this.zdf_1 = levelBgPos;
    if (0 === (seen1 & 256))
      $this.adg_1 = null;
    else
      $this.adg_1 = bgRelPath;
    if (0 === (seen1 & 512))
      $this.bdg_1 = null;
    else
      $this.bdg_1 = externalRelPath;
    $this.cdg_1 = fieldInstances;
    $this.ddg_1 = identifier;
    $this.edg_1 = iid;
    if (0 === (seen1 & 8192))
      $this.fdg_1 = null;
    else
      $this.fdg_1 = layerInstances;
    $this.gdg_1 = pxHei;
    $this.hdg_1 = pxWid;
    $this.idg_1 = uid;
    $this.jdg_1 = useAutoIdentifier;
    $this.kdg_1 = worldDepth;
    $this.ldg_1 = worldX;
    $this.mdg_1 = worldY;
    return $this;
  }
  function Level_init_$Create$(seen1, bgColor, bgPos, neighbours, smartColor, levelBgColor, bgPivotX, bgPivotY, levelBgPos, bgRelPath, externalRelPath, fieldInstances, identifier, iid, layerInstances, pxHei, pxWid, uid, useAutoIdentifier, worldDepth, worldX, worldY, serializationConstructorMarker) {
    return Level_init_$Init$(seen1, bgColor, bgPos, neighbours, smartColor, levelBgColor, bgPivotX, bgPivotY, levelBgPos, bgRelPath, externalRelPath, fieldInstances, identifier, iid, layerInstances, pxHei, pxWid, uid, useAutoIdentifier, worldDepth, worldX, worldY, serializationConstructorMarker, objectCreate(protoOf(Level)));
  }
  function Level() {
  }
  protoOf(Level).toString = function () {
    return 'Level(bgColor=' + this.sdf_1 + ', bgPos=' + this.tdf_1 + ', neighbours=' + this.udf_1 + ', smartColor=' + this.vdf_1 + ', levelBgColor=' + this.wdf_1 + ', bgPivotX=' + this.xdf_1 + ', bgPivotY=' + this.ydf_1 + ', levelBgPos=' + this.zdf_1 + ', bgRelPath=' + this.adg_1 + ', externalRelPath=' + this.bdg_1 + ', fieldInstances=' + this.cdg_1 + ', identifier=' + this.ddg_1 + ', iid=' + this.edg_1 + ', layerInstances=' + this.fdg_1 + ', pxHei=' + this.gdg_1 + ', pxWid=' + this.hdg_1 + ', uid=' + this.idg_1 + ', useAutoIdentifier=' + this.jdg_1 + ', worldDepth=' + this.kdg_1 + ', worldX=' + this.ldg_1 + ', worldY=' + this.mdg_1 + ')';
  };
  protoOf(Level).hashCode = function () {
    var result = getStringHashCode(this.sdf_1);
    result = imul(result, 31) + (this.tdf_1 == null ? 0 : this.tdf_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.udf_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.vdf_1) | 0;
    result = imul(result, 31) + (this.wdf_1 == null ? 0 : getStringHashCode(this.wdf_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.xdf_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ydf_1) | 0;
    result = imul(result, 31) + (this.zdf_1 == null ? 0 : this.zdf_1.hashCode()) | 0;
    result = imul(result, 31) + (this.adg_1 == null ? 0 : getStringHashCode(this.adg_1)) | 0;
    result = imul(result, 31) + (this.bdg_1 == null ? 0 : getStringHashCode(this.bdg_1)) | 0;
    result = imul(result, 31) + hashCode(this.cdg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.ddg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.edg_1) | 0;
    result = imul(result, 31) + (this.fdg_1 == null ? 0 : hashCode(this.fdg_1)) | 0;
    result = imul(result, 31) + this.gdg_1 | 0;
    result = imul(result, 31) + this.hdg_1 | 0;
    result = imul(result, 31) + this.idg_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.jdg_1) | 0;
    result = imul(result, 31) + this.kdg_1 | 0;
    result = imul(result, 31) + this.ldg_1 | 0;
    result = imul(result, 31) + this.mdg_1 | 0;
    return result;
  };
  protoOf(Level).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Level))
      return false;
    var tmp0_other_with_cast = other instanceof Level ? other : THROW_CCE();
    if (!(this.sdf_1 === tmp0_other_with_cast.sdf_1))
      return false;
    if (!equals(this.tdf_1, tmp0_other_with_cast.tdf_1))
      return false;
    if (!equals(this.udf_1, tmp0_other_with_cast.udf_1))
      return false;
    if (!(this.vdf_1 === tmp0_other_with_cast.vdf_1))
      return false;
    if (!(this.wdf_1 == tmp0_other_with_cast.wdf_1))
      return false;
    if (!equals(this.xdf_1, tmp0_other_with_cast.xdf_1))
      return false;
    if (!equals(this.ydf_1, tmp0_other_with_cast.ydf_1))
      return false;
    if (!equals(this.zdf_1, tmp0_other_with_cast.zdf_1))
      return false;
    if (!(this.adg_1 == tmp0_other_with_cast.adg_1))
      return false;
    if (!(this.bdg_1 == tmp0_other_with_cast.bdg_1))
      return false;
    if (!equals(this.cdg_1, tmp0_other_with_cast.cdg_1))
      return false;
    if (!(this.ddg_1 === tmp0_other_with_cast.ddg_1))
      return false;
    if (!(this.edg_1 === tmp0_other_with_cast.edg_1))
      return false;
    if (!equals(this.fdg_1, tmp0_other_with_cast.fdg_1))
      return false;
    if (!(this.gdg_1 === tmp0_other_with_cast.gdg_1))
      return false;
    if (!(this.hdg_1 === tmp0_other_with_cast.hdg_1))
      return false;
    if (!(this.idg_1 === tmp0_other_with_cast.idg_1))
      return false;
    if (!(this.jdg_1 === tmp0_other_with_cast.jdg_1))
      return false;
    if (!(this.kdg_1 === tmp0_other_with_cast.kdg_1))
      return false;
    if (!(this.ldg_1 === tmp0_other_with_cast.ldg_1))
      return false;
    if (!(this.mdg_1 === tmp0_other_with_cast.mdg_1))
      return false;
    return true;
  };
  function Companion_22() {
    Companion_instance_22 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.ndg_1 = [null, null, null, null, null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_17()), new ArrayListSerializer($serializer_getInstance_0()), new ArrayListSerializer($serializer_getInstance_17()), null, null, null, null, null, null, null, null, null, null];
  }
  var Companion_instance_22;
  function Companion_getInstance_22() {
    if (Companion_instance_22 == null)
      new Companion_22();
    return Companion_instance_22;
  }
  function $serializer_16() {
    $serializer_instance_16 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.LayerInstance', this, 23);
    tmp0_serialDesc.du('__cHei', false);
    tmp0_serialDesc.du('__cWid', false);
    tmp0_serialDesc.du('__gridSize', false);
    tmp0_serialDesc.du('__identifier', false);
    tmp0_serialDesc.du('__opacity', false);
    tmp0_serialDesc.du('__pxTotalOffsetX', false);
    tmp0_serialDesc.du('__pxTotalOffsetY', false);
    tmp0_serialDesc.du('__tilesetDefUid', true);
    tmp0_serialDesc.du('__tilesetRelPath', true);
    tmp0_serialDesc.du('__type', false);
    tmp0_serialDesc.du('autoLayerTiles', false);
    tmp0_serialDesc.du('entityInstances', false);
    tmp0_serialDesc.du('gridTiles', false);
    tmp0_serialDesc.du('iid', false);
    tmp0_serialDesc.du('intGridCsv', false);
    tmp0_serialDesc.du('layerDefUid', false);
    tmp0_serialDesc.du('levelId', false);
    tmp0_serialDesc.du('optionalRules', false);
    tmp0_serialDesc.du('overrideTilesetUid', true);
    tmp0_serialDesc.du('pxOffsetX', false);
    tmp0_serialDesc.du('pxOffsetY', false);
    tmp0_serialDesc.du('seed', false);
    tmp0_serialDesc.du('visible', false);
    this.odg_1 = tmp0_serialDesc;
  }
  protoOf($serializer_16).pl = function () {
    return this.odg_1;
  };
  protoOf($serializer_16).su = function () {
    var tmp0_cached = Companion_getInstance_22().ndg_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), DoubleSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), tmp0_cached[10], tmp0_cached[11], tmp0_cached[12], StringSerializer_getInstance(), IntArraySerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntArraySerializer_getInstance(), get_nullable(IntSerializer_getInstance()), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  protoOf($serializer_16).ql = function (decoder) {
    var tmp0_desc = this.odg_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_local3 = null;
    var tmp8_local4 = 0.0;
    var tmp9_local5 = 0;
    var tmp10_local6 = 0;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = 0;
    var tmp20_local16 = 0;
    var tmp21_local17 = null;
    var tmp22_local18 = null;
    var tmp23_local19 = 0;
    var tmp24_local20 = 0;
    var tmp25_local21 = 0;
    var tmp26_local22 = false;
    var tmp27_input = decoder.no(tmp0_desc);
    var tmp28_cached = Companion_getInstance_22().ndg_1;
    if (tmp27_input.dp()) {
      tmp4_local0 = tmp27_input.so(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp27_input.so(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp27_input.so(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp27_input.xo(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp27_input.vo(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp27_input.so(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp27_input.so(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp27_input.bp(tmp0_desc, 7, IntSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp27_input.bp(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp27_input.xo(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp27_input.zo(tmp0_desc, 10, tmp28_cached[10], tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp27_input.zo(tmp0_desc, 11, tmp28_cached[11], tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp27_input.zo(tmp0_desc, 12, tmp28_cached[12], tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp27_input.xo(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp27_input.zo(tmp0_desc, 14, IntArraySerializer_getInstance(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp27_input.so(tmp0_desc, 15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp27_input.so(tmp0_desc, 16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp27_input.zo(tmp0_desc, 17, IntArraySerializer_getInstance(), tmp21_local17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp27_input.bp(tmp0_desc, 18, IntSerializer_getInstance(), tmp22_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp27_input.so(tmp0_desc, 19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp27_input.so(tmp0_desc, 20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp27_input.so(tmp0_desc, 21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp26_local22 = tmp27_input.po(tmp0_desc, 22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp27_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp27_input.so(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp27_input.so(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp27_input.so(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp27_input.xo(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp27_input.vo(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp27_input.so(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp27_input.so(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp27_input.bp(tmp0_desc, 7, IntSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp27_input.bp(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp27_input.xo(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp27_input.zo(tmp0_desc, 10, tmp28_cached[10], tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp27_input.zo(tmp0_desc, 11, tmp28_cached[11], tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp27_input.zo(tmp0_desc, 12, tmp28_cached[12], tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp27_input.xo(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp27_input.zo(tmp0_desc, 14, IntArraySerializer_getInstance(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp27_input.so(tmp0_desc, 15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp27_input.so(tmp0_desc, 16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp27_input.zo(tmp0_desc, 17, IntArraySerializer_getInstance(), tmp21_local17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp27_input.bp(tmp0_desc, 18, IntSerializer_getInstance(), tmp22_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp27_input.so(tmp0_desc, 19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp27_input.so(tmp0_desc, 20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp27_input.so(tmp0_desc, 21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp26_local22 = tmp27_input.po(tmp0_desc, 22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp27_input.oo(tmp0_desc);
    return LayerInstance_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, null);
  };
  var $serializer_instance_16;
  function $serializer_getInstance_16() {
    if ($serializer_instance_16 == null)
      new $serializer_16();
    return $serializer_instance_16;
  }
  function LayerInstance_init_$Init$(seen1, cHei, cWid, gridSize, identifier, opacity, pxTotalOffsetX, pxTotalOffsetY, tilesetDefUid, tilesetRelPath, type, autoLayerTiles, entityInstances, gridTiles, iid, intGridCSV, layerDefUid, levelID, optionalRules, overrideTilesetUid, pxOffsetX, pxOffsetY, seed, visible, serializationConstructorMarker, $this) {
    if (!(8126079 === (8126079 & seen1))) {
      throwMissingFieldException(seen1, 8126079, $serializer_getInstance_16().odg_1);
    }
    $this.pdg_1 = cHei;
    $this.qdg_1 = cWid;
    $this.rdg_1 = gridSize;
    $this.sdg_1 = identifier;
    $this.tdg_1 = opacity;
    $this.udg_1 = pxTotalOffsetX;
    $this.vdg_1 = pxTotalOffsetY;
    if (0 === (seen1 & 128))
      $this.wdg_1 = null;
    else
      $this.wdg_1 = tilesetDefUid;
    if (0 === (seen1 & 256))
      $this.xdg_1 = null;
    else
      $this.xdg_1 = tilesetRelPath;
    $this.ydg_1 = type;
    $this.zdg_1 = autoLayerTiles;
    $this.adh_1 = entityInstances;
    $this.bdh_1 = gridTiles;
    $this.cdh_1 = iid;
    $this.ddh_1 = intGridCSV;
    $this.edh_1 = layerDefUid;
    $this.fdh_1 = levelID;
    $this.gdh_1 = optionalRules;
    if (0 === (seen1 & 262144))
      $this.hdh_1 = null;
    else
      $this.hdh_1 = overrideTilesetUid;
    $this.idh_1 = pxOffsetX;
    $this.jdh_1 = pxOffsetY;
    $this.kdh_1 = seed;
    $this.ldh_1 = visible;
    return $this;
  }
  function LayerInstance_init_$Create$(seen1, cHei, cWid, gridSize, identifier, opacity, pxTotalOffsetX, pxTotalOffsetY, tilesetDefUid, tilesetRelPath, type, autoLayerTiles, entityInstances, gridTiles, iid, intGridCSV, layerDefUid, levelID, optionalRules, overrideTilesetUid, pxOffsetX, pxOffsetY, seed, visible, serializationConstructorMarker) {
    return LayerInstance_init_$Init$(seen1, cHei, cWid, gridSize, identifier, opacity, pxTotalOffsetX, pxTotalOffsetY, tilesetDefUid, tilesetRelPath, type, autoLayerTiles, entityInstances, gridTiles, iid, intGridCSV, layerDefUid, levelID, optionalRules, overrideTilesetUid, pxOffsetX, pxOffsetY, seed, visible, serializationConstructorMarker, objectCreate(protoOf(LayerInstance)));
  }
  function LayerInstance() {
  }
  protoOf(LayerInstance).toString = function () {
    return 'LayerInstance(cHei=' + this.pdg_1 + ', cWid=' + this.qdg_1 + ', gridSize=' + this.rdg_1 + ', identifier=' + this.sdg_1 + ', opacity=' + this.tdg_1 + ', pxTotalOffsetX=' + this.udg_1 + ', pxTotalOffsetY=' + this.vdg_1 + ', tilesetDefUid=' + this.wdg_1 + ', tilesetRelPath=' + this.xdg_1 + ', type=' + this.ydg_1 + ', autoLayerTiles=' + this.zdg_1 + ', entityInstances=' + this.adh_1 + ', gridTiles=' + this.bdh_1 + ', iid=' + this.cdh_1 + ', intGridCSV=' + toString(this.ddh_1) + ', layerDefUid=' + this.edh_1 + ', levelID=' + this.fdh_1 + ', optionalRules=' + toString(this.gdh_1) + ', overrideTilesetUid=' + this.hdh_1 + ', pxOffsetX=' + this.idh_1 + ', pxOffsetY=' + this.jdh_1 + ', seed=' + this.kdh_1 + ', visible=' + this.ldh_1 + ')';
  };
  protoOf(LayerInstance).hashCode = function () {
    var result = this.pdg_1;
    result = imul(result, 31) + this.qdg_1 | 0;
    result = imul(result, 31) + this.rdg_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.sdg_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.tdg_1) | 0;
    result = imul(result, 31) + this.udg_1 | 0;
    result = imul(result, 31) + this.vdg_1 | 0;
    result = imul(result, 31) + (this.wdg_1 == null ? 0 : this.wdg_1) | 0;
    result = imul(result, 31) + (this.xdg_1 == null ? 0 : getStringHashCode(this.xdg_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.ydg_1) | 0;
    result = imul(result, 31) + hashCode(this.zdg_1) | 0;
    result = imul(result, 31) + hashCode(this.adh_1) | 0;
    result = imul(result, 31) + hashCode(this.bdh_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.cdh_1) | 0;
    result = imul(result, 31) + hashCode(this.ddh_1) | 0;
    result = imul(result, 31) + this.edh_1 | 0;
    result = imul(result, 31) + this.fdh_1 | 0;
    result = imul(result, 31) + hashCode(this.gdh_1) | 0;
    result = imul(result, 31) + (this.hdh_1 == null ? 0 : this.hdh_1) | 0;
    result = imul(result, 31) + this.idh_1 | 0;
    result = imul(result, 31) + this.jdh_1 | 0;
    result = imul(result, 31) + this.kdh_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ldh_1) | 0;
    return result;
  };
  protoOf(LayerInstance).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LayerInstance))
      return false;
    var tmp0_other_with_cast = other instanceof LayerInstance ? other : THROW_CCE();
    if (!(this.pdg_1 === tmp0_other_with_cast.pdg_1))
      return false;
    if (!(this.qdg_1 === tmp0_other_with_cast.qdg_1))
      return false;
    if (!(this.rdg_1 === tmp0_other_with_cast.rdg_1))
      return false;
    if (!(this.sdg_1 === tmp0_other_with_cast.sdg_1))
      return false;
    if (!equals(this.tdg_1, tmp0_other_with_cast.tdg_1))
      return false;
    if (!(this.udg_1 === tmp0_other_with_cast.udg_1))
      return false;
    if (!(this.vdg_1 === tmp0_other_with_cast.vdg_1))
      return false;
    if (!(this.wdg_1 == tmp0_other_with_cast.wdg_1))
      return false;
    if (!(this.xdg_1 == tmp0_other_with_cast.xdg_1))
      return false;
    if (!(this.ydg_1 === tmp0_other_with_cast.ydg_1))
      return false;
    if (!equals(this.zdg_1, tmp0_other_with_cast.zdg_1))
      return false;
    if (!equals(this.adh_1, tmp0_other_with_cast.adh_1))
      return false;
    if (!equals(this.bdh_1, tmp0_other_with_cast.bdh_1))
      return false;
    if (!(this.cdh_1 === tmp0_other_with_cast.cdh_1))
      return false;
    if (!equals(this.ddh_1, tmp0_other_with_cast.ddh_1))
      return false;
    if (!(this.edh_1 === tmp0_other_with_cast.edh_1))
      return false;
    if (!(this.fdh_1 === tmp0_other_with_cast.fdh_1))
      return false;
    if (!equals(this.gdh_1, tmp0_other_with_cast.gdh_1))
      return false;
    if (!(this.hdh_1 == tmp0_other_with_cast.hdh_1))
      return false;
    if (!(this.idh_1 === tmp0_other_with_cast.idh_1))
      return false;
    if (!(this.jdh_1 === tmp0_other_with_cast.jdh_1))
      return false;
    if (!(this.kdh_1 === tmp0_other_with_cast.kdh_1))
      return false;
    if (!(this.ldh_1 === tmp0_other_with_cast.ldh_1))
      return false;
    return true;
  };
  function $serializer_17() {
    $serializer_instance_17 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.TileInstance', this, 5);
    tmp0_serialDesc.du('d', false);
    tmp0_serialDesc.du('f', false);
    tmp0_serialDesc.du('px', false);
    tmp0_serialDesc.du('src', false);
    tmp0_serialDesc.du('t', false);
    this.mdh_1 = tmp0_serialDesc;
  }
  protoOf($serializer_17).pl = function () {
    return this.mdh_1;
  };
  protoOf($serializer_17).su = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntArraySerializer_getInstance(), IntSerializer_getInstance(), IntArraySerializer_getInstance(), IntArraySerializer_getInstance(), IntSerializer_getInstance()];
  };
  protoOf($serializer_17).ql = function (decoder) {
    var tmp0_desc = this.mdh_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = 0;
    var tmp9_input = decoder.no(tmp0_desc);
    if (tmp9_input.dp()) {
      tmp4_local0 = tmp9_input.zo(tmp0_desc, 0, IntArraySerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.so(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.zo(tmp0_desc, 2, IntArraySerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.zo(tmp0_desc, 3, IntArraySerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.so(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.zo(tmp0_desc, 0, IntArraySerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.so(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.zo(tmp0_desc, 2, IntArraySerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.zo(tmp0_desc, 3, IntArraySerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.so(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.oo(tmp0_desc);
    return TileInstance_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  var $serializer_instance_17;
  function $serializer_getInstance_17() {
    if ($serializer_instance_17 == null)
      new $serializer_17();
    return $serializer_instance_17;
  }
  function TileInstance_init_$Init$(seen1, d, f, px, src, t, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen1))) {
      throwMissingFieldException(seen1, 31, $serializer_getInstance_17().mdh_1);
    }
    $this.ndh_1 = d;
    $this.odh_1 = f;
    $this.pdh_1 = px;
    $this.qdh_1 = src;
    $this.rdh_1 = t;
    return $this;
  }
  function TileInstance_init_$Create$(seen1, d, f, px, src, t, serializationConstructorMarker) {
    return TileInstance_init_$Init$(seen1, d, f, px, src, t, serializationConstructorMarker, objectCreate(protoOf(TileInstance)));
  }
  function TileInstance() {
  }
  protoOf(TileInstance).toString = function () {
    return 'TileInstance(d=' + toString(this.ndh_1) + ', f=' + this.odh_1 + ', px=' + toString(this.pdh_1) + ', src=' + toString(this.qdh_1) + ', t=' + this.rdh_1 + ')';
  };
  protoOf(TileInstance).hashCode = function () {
    var result = hashCode(this.ndh_1);
    result = imul(result, 31) + this.odh_1 | 0;
    result = imul(result, 31) + hashCode(this.pdh_1) | 0;
    result = imul(result, 31) + hashCode(this.qdh_1) | 0;
    result = imul(result, 31) + this.rdh_1 | 0;
    return result;
  };
  protoOf(TileInstance).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TileInstance))
      return false;
    var tmp0_other_with_cast = other instanceof TileInstance ? other : THROW_CCE();
    if (!equals(this.ndh_1, tmp0_other_with_cast.ndh_1))
      return false;
    if (!(this.odh_1 === tmp0_other_with_cast.odh_1))
      return false;
    if (!equals(this.pdh_1, tmp0_other_with_cast.pdh_1))
      return false;
    if (!equals(this.qdh_1, tmp0_other_with_cast.qdh_1))
      return false;
    if (!(this.rdh_1 === tmp0_other_with_cast.rdh_1))
      return false;
    return true;
  };
  function Companion_23() {
  }
  var Companion_instance_23;
  function Companion_getInstance_23() {
    return Companion_instance_23;
  }
  function $serializer_18() {
    $serializer_instance_18 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.ForcedRefs', this, 24);
    tmp0_serialDesc.du('AutoLayerRuleGroup', true);
    tmp0_serialDesc.du('AutoRuleDef', true);
    tmp0_serialDesc.du('Definitions', true);
    tmp0_serialDesc.du('EntityDef', true);
    tmp0_serialDesc.du('EntityInstance', true);
    tmp0_serialDesc.du('EntityReferenceInfos', true);
    tmp0_serialDesc.du('EnumDef', true);
    tmp0_serialDesc.du('EnumDefValues', true);
    tmp0_serialDesc.du('EnumTagValue', true);
    tmp0_serialDesc.du('FieldDef', true);
    tmp0_serialDesc.du('FieldInstance', true);
    tmp0_serialDesc.du('GridPoint', true);
    tmp0_serialDesc.du('IntGridValueDef', true);
    tmp0_serialDesc.du('IntGridValueInstance', true);
    tmp0_serialDesc.du('LayerDef', true);
    tmp0_serialDesc.du('LayerInstance', true);
    tmp0_serialDesc.du('Level', true);
    tmp0_serialDesc.du('LevelBgPosInfos', true);
    tmp0_serialDesc.du('NeighbourLevel', true);
    tmp0_serialDesc.du('Tile', true);
    tmp0_serialDesc.du('TileCustomMetadata', true);
    tmp0_serialDesc.du('TilesetDef', true);
    tmp0_serialDesc.du('TilesetRect', true);
    tmp0_serialDesc.du('World', true);
    this.sdh_1 = tmp0_serialDesc;
  }
  protoOf($serializer_18).pl = function () {
    return this.sdh_1;
  };
  protoOf($serializer_18).su = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_9()), get_nullable($serializer_getInstance_13()), get_nullable($serializer_getInstance_3()), get_nullable($serializer_getInstance_2()), get_nullable($serializer_getInstance_0()), get_nullable($serializer_getInstance_22()), get_nullable($serializer_getInstance_5()), get_nullable($serializer_getInstance_8()), get_nullable($serializer_getInstance_12()), get_nullable($serializer_getInstance_1()), get_nullable($serializer_getInstance()), get_nullable($serializer_getInstance_23()), get_nullable($serializer_getInstance_10()), get_nullable($serializer_getInstance_24()), get_nullable($serializer_getInstance_6()), get_nullable($serializer_getInstance_16()), get_nullable($serializer_getInstance_15()), get_nullable($serializer_getInstance_20()), get_nullable($serializer_getInstance_21()), get_nullable($serializer_getInstance_17()), get_nullable($serializer_getInstance_11()), get_nullable($serializer_getInstance_7()), get_nullable($serializer_getInstance_4()), get_nullable($serializer_getInstance_19())];
  };
  protoOf($serializer_18).ql = function (decoder) {
    var tmp0_desc = this.sdh_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_local16 = null;
    var tmp21_local17 = null;
    var tmp22_local18 = null;
    var tmp23_local19 = null;
    var tmp24_local20 = null;
    var tmp25_local21 = null;
    var tmp26_local22 = null;
    var tmp27_local23 = null;
    var tmp28_input = decoder.no(tmp0_desc);
    if (tmp28_input.dp()) {
      tmp4_local0 = tmp28_input.bp(tmp0_desc, 0, $serializer_getInstance_9(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp28_input.bp(tmp0_desc, 1, $serializer_getInstance_13(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp28_input.bp(tmp0_desc, 2, $serializer_getInstance_3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp28_input.bp(tmp0_desc, 3, $serializer_getInstance_2(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp28_input.bp(tmp0_desc, 4, $serializer_getInstance_0(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp28_input.bp(tmp0_desc, 5, $serializer_getInstance_22(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp28_input.bp(tmp0_desc, 6, $serializer_getInstance_5(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp28_input.bp(tmp0_desc, 7, $serializer_getInstance_8(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp28_input.bp(tmp0_desc, 8, $serializer_getInstance_12(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp28_input.bp(tmp0_desc, 9, $serializer_getInstance_1(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp28_input.bp(tmp0_desc, 10, $serializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp28_input.bp(tmp0_desc, 11, $serializer_getInstance_23(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp28_input.bp(tmp0_desc, 12, $serializer_getInstance_10(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp28_input.bp(tmp0_desc, 13, $serializer_getInstance_24(), tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp28_input.bp(tmp0_desc, 14, $serializer_getInstance_6(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp28_input.bp(tmp0_desc, 15, $serializer_getInstance_16(), tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp28_input.bp(tmp0_desc, 16, $serializer_getInstance_15(), tmp20_local16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp28_input.bp(tmp0_desc, 17, $serializer_getInstance_20(), tmp21_local17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp28_input.bp(tmp0_desc, 18, $serializer_getInstance_21(), tmp22_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp28_input.bp(tmp0_desc, 19, $serializer_getInstance_17(), tmp23_local19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp28_input.bp(tmp0_desc, 20, $serializer_getInstance_11(), tmp24_local20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp28_input.bp(tmp0_desc, 21, $serializer_getInstance_7(), tmp25_local21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp26_local22 = tmp28_input.bp(tmp0_desc, 22, $serializer_getInstance_4(), tmp26_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
      tmp27_local23 = tmp28_input.bp(tmp0_desc, 23, $serializer_getInstance_19(), tmp27_local23);
      tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp28_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp28_input.bp(tmp0_desc, 0, $serializer_getInstance_9(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp28_input.bp(tmp0_desc, 1, $serializer_getInstance_13(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp28_input.bp(tmp0_desc, 2, $serializer_getInstance_3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp28_input.bp(tmp0_desc, 3, $serializer_getInstance_2(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp28_input.bp(tmp0_desc, 4, $serializer_getInstance_0(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp28_input.bp(tmp0_desc, 5, $serializer_getInstance_22(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp28_input.bp(tmp0_desc, 6, $serializer_getInstance_5(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp28_input.bp(tmp0_desc, 7, $serializer_getInstance_8(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp28_input.bp(tmp0_desc, 8, $serializer_getInstance_12(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp28_input.bp(tmp0_desc, 9, $serializer_getInstance_1(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp28_input.bp(tmp0_desc, 10, $serializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp28_input.bp(tmp0_desc, 11, $serializer_getInstance_23(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp28_input.bp(tmp0_desc, 12, $serializer_getInstance_10(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp28_input.bp(tmp0_desc, 13, $serializer_getInstance_24(), tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp28_input.bp(tmp0_desc, 14, $serializer_getInstance_6(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp28_input.bp(tmp0_desc, 15, $serializer_getInstance_16(), tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp28_input.bp(tmp0_desc, 16, $serializer_getInstance_15(), tmp20_local16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp28_input.bp(tmp0_desc, 17, $serializer_getInstance_20(), tmp21_local17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp28_input.bp(tmp0_desc, 18, $serializer_getInstance_21(), tmp22_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp28_input.bp(tmp0_desc, 19, $serializer_getInstance_17(), tmp23_local19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp28_input.bp(tmp0_desc, 20, $serializer_getInstance_11(), tmp24_local20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp28_input.bp(tmp0_desc, 21, $serializer_getInstance_7(), tmp25_local21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp26_local22 = tmp28_input.bp(tmp0_desc, 22, $serializer_getInstance_4(), tmp26_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          case 23:
            tmp27_local23 = tmp28_input.bp(tmp0_desc, 23, $serializer_getInstance_19(), tmp27_local23);
            tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp28_input.oo(tmp0_desc);
    return ForcedRefs_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, null);
  };
  var $serializer_instance_18;
  function $serializer_getInstance_18() {
    if ($serializer_instance_18 == null)
      new $serializer_18();
    return $serializer_instance_18;
  }
  function ForcedRefs_init_$Init$(seen1, autoLayerRuleGroup, autoRuleDef, definitions, entityDef, entityInstance, entityReferenceInfos, enumDef, enumDefValues, enumTagValue, fieldDef, fieldInstance, gridPoint, intGridValueDef, intGridValueInstance, layerDef, layerInstance, level, levelBgPosInfos, neighbourLevel, tile, tileCustomMetadata, tilesetDef, tilesetRect, world, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen1))) {
      throwMissingFieldException(seen1, 0, $serializer_getInstance_18().sdh_1);
    }
    if (0 === (seen1 & 1))
      $this.tdh_1 = null;
    else
      $this.tdh_1 = autoLayerRuleGroup;
    if (0 === (seen1 & 2))
      $this.udh_1 = null;
    else
      $this.udh_1 = autoRuleDef;
    if (0 === (seen1 & 4))
      $this.vdh_1 = null;
    else
      $this.vdh_1 = definitions;
    if (0 === (seen1 & 8))
      $this.wdh_1 = null;
    else
      $this.wdh_1 = entityDef;
    if (0 === (seen1 & 16))
      $this.xdh_1 = null;
    else
      $this.xdh_1 = entityInstance;
    if (0 === (seen1 & 32))
      $this.ydh_1 = null;
    else
      $this.ydh_1 = entityReferenceInfos;
    if (0 === (seen1 & 64))
      $this.zdh_1 = null;
    else
      $this.zdh_1 = enumDef;
    if (0 === (seen1 & 128))
      $this.adi_1 = null;
    else
      $this.adi_1 = enumDefValues;
    if (0 === (seen1 & 256))
      $this.bdi_1 = null;
    else
      $this.bdi_1 = enumTagValue;
    if (0 === (seen1 & 512))
      $this.cdi_1 = null;
    else
      $this.cdi_1 = fieldDef;
    if (0 === (seen1 & 1024))
      $this.ddi_1 = null;
    else
      $this.ddi_1 = fieldInstance;
    if (0 === (seen1 & 2048))
      $this.edi_1 = null;
    else
      $this.edi_1 = gridPoint;
    if (0 === (seen1 & 4096))
      $this.fdi_1 = null;
    else
      $this.fdi_1 = intGridValueDef;
    if (0 === (seen1 & 8192))
      $this.gdi_1 = null;
    else
      $this.gdi_1 = intGridValueInstance;
    if (0 === (seen1 & 16384))
      $this.hdi_1 = null;
    else
      $this.hdi_1 = layerDef;
    if (0 === (seen1 & 32768))
      $this.idi_1 = null;
    else
      $this.idi_1 = layerInstance;
    if (0 === (seen1 & 65536))
      $this.jdi_1 = null;
    else
      $this.jdi_1 = level;
    if (0 === (seen1 & 131072))
      $this.kdi_1 = null;
    else
      $this.kdi_1 = levelBgPosInfos;
    if (0 === (seen1 & 262144))
      $this.ldi_1 = null;
    else
      $this.ldi_1 = neighbourLevel;
    if (0 === (seen1 & 524288))
      $this.mdi_1 = null;
    else
      $this.mdi_1 = tile;
    if (0 === (seen1 & 1048576))
      $this.ndi_1 = null;
    else
      $this.ndi_1 = tileCustomMetadata;
    if (0 === (seen1 & 2097152))
      $this.odi_1 = null;
    else
      $this.odi_1 = tilesetDef;
    if (0 === (seen1 & 4194304))
      $this.pdi_1 = null;
    else
      $this.pdi_1 = tilesetRect;
    if (0 === (seen1 & 8388608))
      $this.qdi_1 = null;
    else
      $this.qdi_1 = world;
    return $this;
  }
  function ForcedRefs_init_$Create$(seen1, autoLayerRuleGroup, autoRuleDef, definitions, entityDef, entityInstance, entityReferenceInfos, enumDef, enumDefValues, enumTagValue, fieldDef, fieldInstance, gridPoint, intGridValueDef, intGridValueInstance, layerDef, layerInstance, level, levelBgPosInfos, neighbourLevel, tile, tileCustomMetadata, tilesetDef, tilesetRect, world, serializationConstructorMarker) {
    return ForcedRefs_init_$Init$(seen1, autoLayerRuleGroup, autoRuleDef, definitions, entityDef, entityInstance, entityReferenceInfos, enumDef, enumDefValues, enumTagValue, fieldDef, fieldInstance, gridPoint, intGridValueDef, intGridValueInstance, layerDef, layerInstance, level, levelBgPosInfos, neighbourLevel, tile, tileCustomMetadata, tilesetDef, tilesetRect, world, serializationConstructorMarker, objectCreate(protoOf(ForcedRefs)));
  }
  function ForcedRefs(autoLayerRuleGroup, autoRuleDef, definitions, entityDef, entityInstance, entityReferenceInfos, enumDef, enumDefValues, enumTagValue, fieldDef, fieldInstance, gridPoint, intGridValueDef, intGridValueInstance, layerDef, layerInstance, level, levelBgPosInfos, neighbourLevel, tile, tileCustomMetadata, tilesetDef, tilesetRect, world) {
    autoLayerRuleGroup = autoLayerRuleGroup === VOID ? null : autoLayerRuleGroup;
    autoRuleDef = autoRuleDef === VOID ? null : autoRuleDef;
    definitions = definitions === VOID ? null : definitions;
    entityDef = entityDef === VOID ? null : entityDef;
    entityInstance = entityInstance === VOID ? null : entityInstance;
    entityReferenceInfos = entityReferenceInfos === VOID ? null : entityReferenceInfos;
    enumDef = enumDef === VOID ? null : enumDef;
    enumDefValues = enumDefValues === VOID ? null : enumDefValues;
    enumTagValue = enumTagValue === VOID ? null : enumTagValue;
    fieldDef = fieldDef === VOID ? null : fieldDef;
    fieldInstance = fieldInstance === VOID ? null : fieldInstance;
    gridPoint = gridPoint === VOID ? null : gridPoint;
    intGridValueDef = intGridValueDef === VOID ? null : intGridValueDef;
    intGridValueInstance = intGridValueInstance === VOID ? null : intGridValueInstance;
    layerDef = layerDef === VOID ? null : layerDef;
    layerInstance = layerInstance === VOID ? null : layerInstance;
    level = level === VOID ? null : level;
    levelBgPosInfos = levelBgPosInfos === VOID ? null : levelBgPosInfos;
    neighbourLevel = neighbourLevel === VOID ? null : neighbourLevel;
    tile = tile === VOID ? null : tile;
    tileCustomMetadata = tileCustomMetadata === VOID ? null : tileCustomMetadata;
    tilesetDef = tilesetDef === VOID ? null : tilesetDef;
    tilesetRect = tilesetRect === VOID ? null : tilesetRect;
    world = world === VOID ? null : world;
    this.tdh_1 = autoLayerRuleGroup;
    this.udh_1 = autoRuleDef;
    this.vdh_1 = definitions;
    this.wdh_1 = entityDef;
    this.xdh_1 = entityInstance;
    this.ydh_1 = entityReferenceInfos;
    this.zdh_1 = enumDef;
    this.adi_1 = enumDefValues;
    this.bdi_1 = enumTagValue;
    this.cdi_1 = fieldDef;
    this.ddi_1 = fieldInstance;
    this.edi_1 = gridPoint;
    this.fdi_1 = intGridValueDef;
    this.gdi_1 = intGridValueInstance;
    this.hdi_1 = layerDef;
    this.idi_1 = layerInstance;
    this.jdi_1 = level;
    this.kdi_1 = levelBgPosInfos;
    this.ldi_1 = neighbourLevel;
    this.mdi_1 = tile;
    this.ndi_1 = tileCustomMetadata;
    this.odi_1 = tilesetDef;
    this.pdi_1 = tilesetRect;
    this.qdi_1 = world;
  }
  protoOf(ForcedRefs).toString = function () {
    return 'ForcedRefs(autoLayerRuleGroup=' + this.tdh_1 + ', autoRuleDef=' + this.udh_1 + ', definitions=' + this.vdh_1 + ', entityDef=' + this.wdh_1 + ', entityInstance=' + this.xdh_1 + ', entityReferenceInfos=' + this.ydh_1 + ', enumDef=' + this.zdh_1 + ', enumDefValues=' + this.adi_1 + ', enumTagValue=' + this.bdi_1 + ', fieldDef=' + this.cdi_1 + ', fieldInstance=' + this.ddi_1 + ', gridPoint=' + this.edi_1 + ', intGridValueDef=' + this.fdi_1 + ', intGridValueInstance=' + this.gdi_1 + ', layerDef=' + this.hdi_1 + ', layerInstance=' + this.idi_1 + ', level=' + this.jdi_1 + ', levelBgPosInfos=' + this.kdi_1 + ', neighbourLevel=' + this.ldi_1 + ', tile=' + this.mdi_1 + ', tileCustomMetadata=' + this.ndi_1 + ', tilesetDef=' + this.odi_1 + ', tilesetRect=' + this.pdi_1 + ', world=' + this.qdi_1 + ')';
  };
  protoOf(ForcedRefs).hashCode = function () {
    var result = this.tdh_1 == null ? 0 : this.tdh_1.hashCode();
    result = imul(result, 31) + (this.udh_1 == null ? 0 : this.udh_1.hashCode()) | 0;
    result = imul(result, 31) + (this.vdh_1 == null ? 0 : this.vdh_1.hashCode()) | 0;
    result = imul(result, 31) + (this.wdh_1 == null ? 0 : this.wdh_1.hashCode()) | 0;
    result = imul(result, 31) + (this.xdh_1 == null ? 0 : this.xdh_1.hashCode()) | 0;
    result = imul(result, 31) + (this.ydh_1 == null ? 0 : this.ydh_1.hashCode()) | 0;
    result = imul(result, 31) + (this.zdh_1 == null ? 0 : this.zdh_1.hashCode()) | 0;
    result = imul(result, 31) + (this.adi_1 == null ? 0 : this.adi_1.hashCode()) | 0;
    result = imul(result, 31) + (this.bdi_1 == null ? 0 : this.bdi_1.hashCode()) | 0;
    result = imul(result, 31) + (this.cdi_1 == null ? 0 : this.cdi_1.hashCode()) | 0;
    result = imul(result, 31) + (this.ddi_1 == null ? 0 : this.ddi_1.hashCode()) | 0;
    result = imul(result, 31) + (this.edi_1 == null ? 0 : this.edi_1.hashCode()) | 0;
    result = imul(result, 31) + (this.fdi_1 == null ? 0 : this.fdi_1.hashCode()) | 0;
    result = imul(result, 31) + (this.gdi_1 == null ? 0 : this.gdi_1.hashCode()) | 0;
    result = imul(result, 31) + (this.hdi_1 == null ? 0 : this.hdi_1.hashCode()) | 0;
    result = imul(result, 31) + (this.idi_1 == null ? 0 : this.idi_1.hashCode()) | 0;
    result = imul(result, 31) + (this.jdi_1 == null ? 0 : this.jdi_1.hashCode()) | 0;
    result = imul(result, 31) + (this.kdi_1 == null ? 0 : this.kdi_1.hashCode()) | 0;
    result = imul(result, 31) + (this.ldi_1 == null ? 0 : this.ldi_1.hashCode()) | 0;
    result = imul(result, 31) + (this.mdi_1 == null ? 0 : this.mdi_1.hashCode()) | 0;
    result = imul(result, 31) + (this.ndi_1 == null ? 0 : this.ndi_1.hashCode()) | 0;
    result = imul(result, 31) + (this.odi_1 == null ? 0 : this.odi_1.hashCode()) | 0;
    result = imul(result, 31) + (this.pdi_1 == null ? 0 : this.pdi_1.hashCode()) | 0;
    result = imul(result, 31) + (this.qdi_1 == null ? 0 : this.qdi_1.hashCode()) | 0;
    return result;
  };
  protoOf(ForcedRefs).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ForcedRefs))
      return false;
    var tmp0_other_with_cast = other instanceof ForcedRefs ? other : THROW_CCE();
    if (!equals(this.tdh_1, tmp0_other_with_cast.tdh_1))
      return false;
    if (!equals(this.udh_1, tmp0_other_with_cast.udh_1))
      return false;
    if (!equals(this.vdh_1, tmp0_other_with_cast.vdh_1))
      return false;
    if (!equals(this.wdh_1, tmp0_other_with_cast.wdh_1))
      return false;
    if (!equals(this.xdh_1, tmp0_other_with_cast.xdh_1))
      return false;
    if (!equals(this.ydh_1, tmp0_other_with_cast.ydh_1))
      return false;
    if (!equals(this.zdh_1, tmp0_other_with_cast.zdh_1))
      return false;
    if (!equals(this.adi_1, tmp0_other_with_cast.adi_1))
      return false;
    if (!equals(this.bdi_1, tmp0_other_with_cast.bdi_1))
      return false;
    if (!equals(this.cdi_1, tmp0_other_with_cast.cdi_1))
      return false;
    if (!equals(this.ddi_1, tmp0_other_with_cast.ddi_1))
      return false;
    if (!equals(this.edi_1, tmp0_other_with_cast.edi_1))
      return false;
    if (!equals(this.fdi_1, tmp0_other_with_cast.fdi_1))
      return false;
    if (!equals(this.gdi_1, tmp0_other_with_cast.gdi_1))
      return false;
    if (!equals(this.hdi_1, tmp0_other_with_cast.hdi_1))
      return false;
    if (!equals(this.idi_1, tmp0_other_with_cast.idi_1))
      return false;
    if (!equals(this.jdi_1, tmp0_other_with_cast.jdi_1))
      return false;
    if (!equals(this.kdi_1, tmp0_other_with_cast.kdi_1))
      return false;
    if (!equals(this.ldi_1, tmp0_other_with_cast.ldi_1))
      return false;
    if (!equals(this.mdi_1, tmp0_other_with_cast.mdi_1))
      return false;
    if (!equals(this.ndi_1, tmp0_other_with_cast.ndi_1))
      return false;
    if (!equals(this.odi_1, tmp0_other_with_cast.odi_1))
      return false;
    if (!equals(this.pdi_1, tmp0_other_with_cast.pdi_1))
      return false;
    if (!equals(this.qdi_1, tmp0_other_with_cast.qdi_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj_11($this) {
    return $this.gde_1.m2();
  }
  function Flag$Companion$_anonymous__vfldct() {
    return createSimpleEnumSerializer('korlibs.korge.ldtk.Flag', values_11());
  }
  var Flag_DiscardPreCSVIntGrid_instance;
  var Flag_ExportPreCSVIntGridFormat_instance;
  var Flag_IgnoreBackupSuggest_instance;
  var Flag_MultiWorlds_instance;
  var Flag_PrependIndexToLevelFileNames_instance;
  var Flag_UseMultilinesType_instance;
  function Companion_24() {
    Companion_instance_24 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.gde_1 = lazy(tmp_0, Flag$Companion$_anonymous__vfldct);
  }
  protoOf(Companion_24).pl = function () {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.Flag', STRING_getInstance());
  };
  protoOf(Companion_24).ql = function (decoder) {
    var value = decoder.io();
    var tmp;
    switch (value) {
      case 'DiscardPreCsvIntGrid':
        tmp = Flag_DiscardPreCSVIntGrid_getInstance();
        break;
      case 'ExportPreCsvIntGridFormat':
        tmp = Flag_ExportPreCSVIntGridFormat_getInstance();
        break;
      case 'IgnoreBackupSuggest':
        tmp = Flag_IgnoreBackupSuggest_getInstance();
        break;
      case 'MultiWorlds':
        tmp = Flag_MultiWorlds_getInstance();
        break;
      case 'PrependIndexToLevelFileNames':
        tmp = Flag_PrependIndexToLevelFileNames_getInstance();
        break;
      case 'UseMultilinesType':
        tmp = Flag_UseMultilinesType_getInstance();
        break;
      default:
        throw IllegalArgumentException_init_$Create$('Flag could not parse: ' + value);
    }
    return tmp;
  };
  protoOf(Companion_24).w13 = function () {
    return _get_$cachedSerializer__te6jhj_11(this);
  };
  protoOf(Companion_24).bv = function (typeParamsSerializers) {
    return this.w13();
  };
  var Companion_instance_24;
  function Companion_getInstance_24() {
    Flag_initEntries();
    if (Companion_instance_24 == null)
      new Companion_24();
    return Companion_instance_24;
  }
  function values_11() {
    return [Flag_DiscardPreCSVIntGrid_getInstance(), Flag_ExportPreCSVIntGridFormat_getInstance(), Flag_IgnoreBackupSuggest_getInstance(), Flag_MultiWorlds_getInstance(), Flag_PrependIndexToLevelFileNames_getInstance(), Flag_UseMultilinesType_getInstance()];
  }
  var Flag_entriesInitialized;
  function Flag_initEntries() {
    if (Flag_entriesInitialized)
      return Unit_instance;
    Flag_entriesInitialized = true;
    Flag_DiscardPreCSVIntGrid_instance = new Flag('DiscardPreCSVIntGrid', 0, 'DiscardPreCsvIntGrid');
    Flag_ExportPreCSVIntGridFormat_instance = new Flag('ExportPreCSVIntGridFormat', 1, 'ExportPreCsvIntGridFormat');
    Flag_IgnoreBackupSuggest_instance = new Flag('IgnoreBackupSuggest', 2, 'IgnoreBackupSuggest');
    Flag_MultiWorlds_instance = new Flag('MultiWorlds', 3, 'MultiWorlds');
    Flag_PrependIndexToLevelFileNames_instance = new Flag('PrependIndexToLevelFileNames', 4, 'PrependIndexToLevelFileNames');
    Flag_UseMultilinesType_instance = new Flag('UseMultilinesType', 5, 'UseMultilinesType');
    Companion_getInstance_24();
  }
  function Flag(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.tdi_1 = value;
  }
  function _get_$cachedSerializer__te6jhj_12($this) {
    return $this.hde_1.m2();
  }
  function IdentifierStyle$Companion$_anonymous__e7aoxl() {
    return createSimpleEnumSerializer('korlibs.korge.ldtk.IdentifierStyle', values_12());
  }
  var IdentifierStyle_Capitalize_instance;
  var IdentifierStyle_Free_instance;
  var IdentifierStyle_Lowercase_instance;
  var IdentifierStyle_Uppercase_instance;
  function Companion_25() {
    Companion_instance_25 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.hde_1 = lazy(tmp_0, IdentifierStyle$Companion$_anonymous__e7aoxl);
  }
  protoOf(Companion_25).pl = function () {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.IdentifierStyle', STRING_getInstance());
  };
  protoOf(Companion_25).ql = function (decoder) {
    var value = decoder.io();
    var tmp;
    switch (value) {
      case 'Capitalize':
        tmp = IdentifierStyle_Capitalize_getInstance();
        break;
      case 'Free':
        tmp = IdentifierStyle_Free_getInstance();
        break;
      case 'Lowercase':
        tmp = IdentifierStyle_Lowercase_getInstance();
        break;
      case 'Uppercase':
        tmp = IdentifierStyle_Uppercase_getInstance();
        break;
      default:
        throw IllegalArgumentException_init_$Create$('IdentifierStyle could not parse: ' + value);
    }
    return tmp;
  };
  protoOf(Companion_25).w13 = function () {
    return _get_$cachedSerializer__te6jhj_12(this);
  };
  protoOf(Companion_25).bv = function (typeParamsSerializers) {
    return this.w13();
  };
  var Companion_instance_25;
  function Companion_getInstance_25() {
    IdentifierStyle_initEntries();
    if (Companion_instance_25 == null)
      new Companion_25();
    return Companion_instance_25;
  }
  function values_12() {
    return [IdentifierStyle_Capitalize_getInstance(), IdentifierStyle_Free_getInstance(), IdentifierStyle_Lowercase_getInstance(), IdentifierStyle_Uppercase_getInstance()];
  }
  var IdentifierStyle_entriesInitialized;
  function IdentifierStyle_initEntries() {
    if (IdentifierStyle_entriesInitialized)
      return Unit_instance;
    IdentifierStyle_entriesInitialized = true;
    IdentifierStyle_Capitalize_instance = new IdentifierStyle('Capitalize', 0, 'Capitalize');
    IdentifierStyle_Free_instance = new IdentifierStyle('Free', 1, 'Free');
    IdentifierStyle_Lowercase_instance = new IdentifierStyle('Lowercase', 2, 'Lowercase');
    IdentifierStyle_Uppercase_instance = new IdentifierStyle('Uppercase', 3, 'Uppercase');
    Companion_getInstance_25();
  }
  function IdentifierStyle(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.wdi_1 = value;
  }
  function _get_$cachedSerializer__te6jhj_13($this) {
    return $this.ide_1.m2();
  }
  function ImageExportMode$Companion$_anonymous__oljsbh() {
    return createSimpleEnumSerializer('korlibs.korge.ldtk.ImageExportMode', values_13());
  }
  var ImageExportMode_LayersAndLevels_instance;
  var ImageExportMode_None_instance;
  var ImageExportMode_OneImagePerLayer_instance;
  var ImageExportMode_OneImagePerLevel_instance;
  function Companion_26() {
    Companion_instance_26 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.ide_1 = lazy(tmp_0, ImageExportMode$Companion$_anonymous__oljsbh);
  }
  protoOf(Companion_26).pl = function () {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.ImageExportMode', STRING_getInstance());
  };
  protoOf(Companion_26).ql = function (decoder) {
    var value = decoder.io();
    var tmp;
    switch (value) {
      case 'LayersAndLevels':
        tmp = ImageExportMode_LayersAndLevels_getInstance();
        break;
      case 'None':
        tmp = ImageExportMode_None_getInstance();
        break;
      case 'OneImagePerLayer':
        tmp = ImageExportMode_OneImagePerLayer_getInstance();
        break;
      case 'OneImagePerLevel':
        tmp = ImageExportMode_OneImagePerLevel_getInstance();
        break;
      default:
        throw IllegalArgumentException_init_$Create$('ImageExportMode could not parse: ' + value);
    }
    return tmp;
  };
  protoOf(Companion_26).w13 = function () {
    return _get_$cachedSerializer__te6jhj_13(this);
  };
  protoOf(Companion_26).bv = function (typeParamsSerializers) {
    return this.w13();
  };
  var Companion_instance_26;
  function Companion_getInstance_26() {
    ImageExportMode_initEntries();
    if (Companion_instance_26 == null)
      new Companion_26();
    return Companion_instance_26;
  }
  function values_13() {
    return [ImageExportMode_LayersAndLevels_getInstance(), ImageExportMode_None_getInstance(), ImageExportMode_OneImagePerLayer_getInstance(), ImageExportMode_OneImagePerLevel_getInstance()];
  }
  var ImageExportMode_entriesInitialized;
  function ImageExportMode_initEntries() {
    if (ImageExportMode_entriesInitialized)
      return Unit_instance;
    ImageExportMode_entriesInitialized = true;
    ImageExportMode_LayersAndLevels_instance = new ImageExportMode('LayersAndLevels', 0, 'LayersAndLevels');
    ImageExportMode_None_instance = new ImageExportMode('None', 1, 'None');
    ImageExportMode_OneImagePerLayer_instance = new ImageExportMode('OneImagePerLayer', 2, 'OneImagePerLayer');
    ImageExportMode_OneImagePerLevel_instance = new ImageExportMode('OneImagePerLevel', 3, 'OneImagePerLevel');
    Companion_getInstance_26();
  }
  function ImageExportMode(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.zdi_1 = value;
  }
  function _get_$cachedSerializer__te6jhj_14($this) {
    return $this.jde_1.m2();
  }
  function WorldLayout$Companion$_anonymous__u3nwqb() {
    return createSimpleEnumSerializer('korlibs.korge.ldtk.WorldLayout', values_14());
  }
  var WorldLayout_Free_instance;
  var WorldLayout_GridVania_instance;
  var WorldLayout_LinearHorizontal_instance;
  var WorldLayout_LinearVertical_instance;
  function Companion_27() {
    Companion_instance_27 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.jde_1 = lazy(tmp_0, WorldLayout$Companion$_anonymous__u3nwqb);
  }
  protoOf(Companion_27).pl = function () {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.WorldLayout', STRING_getInstance());
  };
  protoOf(Companion_27).ql = function (decoder) {
    var value = decoder.io();
    var tmp;
    switch (value) {
      case 'Free':
        tmp = WorldLayout_Free_getInstance();
        break;
      case 'GridVania':
        tmp = WorldLayout_GridVania_getInstance();
        break;
      case 'LinearHorizontal':
        tmp = WorldLayout_LinearHorizontal_getInstance();
        break;
      case 'LinearVertical':
        tmp = WorldLayout_LinearVertical_getInstance();
        break;
      default:
        throw IllegalArgumentException_init_$Create$('WorldLayout could not parse: ' + value);
    }
    return tmp;
  };
  protoOf(Companion_27).w13 = function () {
    return _get_$cachedSerializer__te6jhj_14(this);
  };
  protoOf(Companion_27).bv = function (typeParamsSerializers) {
    return this.w13();
  };
  var Companion_instance_27;
  function Companion_getInstance_27() {
    WorldLayout_initEntries();
    if (Companion_instance_27 == null)
      new Companion_27();
    return Companion_instance_27;
  }
  function values_14() {
    return [WorldLayout_Free_getInstance(), WorldLayout_GridVania_getInstance(), WorldLayout_LinearHorizontal_getInstance(), WorldLayout_LinearVertical_getInstance()];
  }
  var WorldLayout_entriesInitialized;
  function WorldLayout_initEntries() {
    if (WorldLayout_entriesInitialized)
      return Unit_instance;
    WorldLayout_entriesInitialized = true;
    WorldLayout_Free_instance = new WorldLayout('Free', 0, 'Free');
    WorldLayout_GridVania_instance = new WorldLayout('GridVania', 1, 'GridVania');
    WorldLayout_LinearHorizontal_instance = new WorldLayout('LinearHorizontal', 2, 'LinearHorizontal');
    WorldLayout_LinearVertical_instance = new WorldLayout('LinearVertical', 3, 'LinearVertical');
    Companion_getInstance_27();
  }
  function WorldLayout(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.cdj_1 = value;
  }
  function Companion_28() {
    Companion_instance_28 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.ddj_1 = [null, null, null, null, new ArrayListSerializer($serializer_getInstance_15()), null, null, Companion_getInstance_27().w13()];
  }
  var Companion_instance_28;
  function Companion_getInstance_28() {
    if (Companion_instance_28 == null)
      new Companion_28();
    return Companion_instance_28;
  }
  function $serializer_19() {
    $serializer_instance_19 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.World', this, 8);
    tmp0_serialDesc.du('defaultLevelHeight', false);
    tmp0_serialDesc.du('defaultLevelWidth', false);
    tmp0_serialDesc.du('identifier', false);
    tmp0_serialDesc.du('iid', false);
    tmp0_serialDesc.du('levels', false);
    tmp0_serialDesc.du('worldGridHeight', false);
    tmp0_serialDesc.du('worldGridWidth', false);
    tmp0_serialDesc.du('worldLayout', true);
    this.edj_1 = tmp0_serialDesc;
  }
  protoOf($serializer_19).pl = function () {
    return this.edj_1;
  };
  protoOf($serializer_19).su = function () {
    var tmp0_cached = Companion_getInstance_28().ddj_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[4], IntSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(tmp0_cached[7])];
  };
  protoOf($serializer_19).ql = function (decoder) {
    var tmp0_desc = this.edj_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = 0;
    var tmp10_local6 = 0;
    var tmp11_local7 = null;
    var tmp12_input = decoder.no(tmp0_desc);
    var tmp13_cached = Companion_getInstance_28().ddj_1;
    if (tmp12_input.dp()) {
      tmp4_local0 = tmp12_input.so(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.so(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.xo(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.xo(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.zo(tmp0_desc, 4, tmp13_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.so(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.so(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.bp(tmp0_desc, 7, tmp13_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.so(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.so(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.xo(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.xo(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.zo(tmp0_desc, 4, tmp13_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.so(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.so(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.bp(tmp0_desc, 7, tmp13_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp12_input.oo(tmp0_desc);
    return World_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  var $serializer_instance_19;
  function $serializer_getInstance_19() {
    if ($serializer_instance_19 == null)
      new $serializer_19();
    return $serializer_instance_19;
  }
  function World_init_$Init$(seen1, defaultLevelHeight, defaultLevelWidth, identifier, iid, levels, worldGridHeight, worldGridWidth, worldLayout, serializationConstructorMarker, $this) {
    if (!(127 === (127 & seen1))) {
      throwMissingFieldException(seen1, 127, $serializer_getInstance_19().edj_1);
    }
    $this.fdj_1 = defaultLevelHeight;
    $this.gdj_1 = defaultLevelWidth;
    $this.hdj_1 = identifier;
    $this.idj_1 = iid;
    $this.jdj_1 = levels;
    $this.kdj_1 = worldGridHeight;
    $this.ldj_1 = worldGridWidth;
    if (0 === (seen1 & 128))
      $this.mdj_1 = null;
    else
      $this.mdj_1 = worldLayout;
    return $this;
  }
  function World_init_$Create$(seen1, defaultLevelHeight, defaultLevelWidth, identifier, iid, levels, worldGridHeight, worldGridWidth, worldLayout, serializationConstructorMarker) {
    return World_init_$Init$(seen1, defaultLevelHeight, defaultLevelWidth, identifier, iid, levels, worldGridHeight, worldGridWidth, worldLayout, serializationConstructorMarker, objectCreate(protoOf(World)));
  }
  function World() {
  }
  protoOf(World).toString = function () {
    return 'World(defaultLevelHeight=' + this.fdj_1 + ', defaultLevelWidth=' + this.gdj_1 + ', identifier=' + this.hdj_1 + ', iid=' + this.idj_1 + ', levels=' + this.jdj_1 + ', worldGridHeight=' + this.kdj_1 + ', worldGridWidth=' + this.ldj_1 + ', worldLayout=' + this.mdj_1 + ')';
  };
  protoOf(World).hashCode = function () {
    var result = this.fdj_1;
    result = imul(result, 31) + this.gdj_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.hdj_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.idj_1) | 0;
    result = imul(result, 31) + hashCode(this.jdj_1) | 0;
    result = imul(result, 31) + this.kdj_1 | 0;
    result = imul(result, 31) + this.ldj_1 | 0;
    result = imul(result, 31) + (this.mdj_1 == null ? 0 : this.mdj_1.hashCode()) | 0;
    return result;
  };
  protoOf(World).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof World))
      return false;
    var tmp0_other_with_cast = other instanceof World ? other : THROW_CCE();
    if (!(this.fdj_1 === tmp0_other_with_cast.fdj_1))
      return false;
    if (!(this.gdj_1 === tmp0_other_with_cast.gdj_1))
      return false;
    if (!(this.hdj_1 === tmp0_other_with_cast.hdj_1))
      return false;
    if (!(this.idj_1 === tmp0_other_with_cast.idj_1))
      return false;
    if (!equals(this.jdj_1, tmp0_other_with_cast.jdj_1))
      return false;
    if (!(this.kdj_1 === tmp0_other_with_cast.kdj_1))
      return false;
    if (!(this.ldj_1 === tmp0_other_with_cast.ldj_1))
      return false;
    if (!equals(this.mdj_1, tmp0_other_with_cast.mdj_1))
      return false;
    return true;
  };
  function Companion_29() {
    Companion_instance_29 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.ndj_1 = [new ArrayListSerializer(DoubleSerializer_getInstance()), new ArrayListSerializer(DoubleSerializer_getInstance()), null];
  }
  var Companion_instance_29;
  function Companion_getInstance_29() {
    if (Companion_instance_29 == null)
      new Companion_29();
    return Companion_instance_29;
  }
  function $serializer_20() {
    $serializer_instance_20 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.LevelBackgroundPosition', this, 3);
    tmp0_serialDesc.du('cropRect', false);
    tmp0_serialDesc.du('scale', false);
    tmp0_serialDesc.du('topLeftPx', false);
    this.odj_1 = tmp0_serialDesc;
  }
  protoOf($serializer_20).pl = function () {
    return this.odj_1;
  };
  protoOf($serializer_20).su = function () {
    var tmp0_cached = Companion_getInstance_29().ndj_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1], IntArraySerializer_getInstance()];
  };
  protoOf($serializer_20).ql = function (decoder) {
    var tmp0_desc = this.odj_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.no(tmp0_desc);
    var tmp8_cached = Companion_getInstance_29().ndj_1;
    if (tmp7_input.dp()) {
      tmp4_local0 = tmp7_input.zo(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.zo(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zo(tmp0_desc, 2, IntArraySerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.zo(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.zo(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zo(tmp0_desc, 2, IntArraySerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.oo(tmp0_desc);
    return LevelBackgroundPosition_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  var $serializer_instance_20;
  function $serializer_getInstance_20() {
    if ($serializer_instance_20 == null)
      new $serializer_20();
    return $serializer_instance_20;
  }
  function LevelBackgroundPosition_init_$Init$(seen1, cropRect, scale, topLeftPx, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_20().odj_1);
    }
    $this.pdj_1 = cropRect;
    $this.qdj_1 = scale;
    $this.rdj_1 = topLeftPx;
    return $this;
  }
  function LevelBackgroundPosition_init_$Create$(seen1, cropRect, scale, topLeftPx, serializationConstructorMarker) {
    return LevelBackgroundPosition_init_$Init$(seen1, cropRect, scale, topLeftPx, serializationConstructorMarker, objectCreate(protoOf(LevelBackgroundPosition)));
  }
  function LevelBackgroundPosition() {
  }
  protoOf(LevelBackgroundPosition).toString = function () {
    return 'LevelBackgroundPosition(cropRect=' + this.pdj_1 + ', scale=' + this.qdj_1 + ', topLeftPx=' + toString(this.rdj_1) + ')';
  };
  protoOf(LevelBackgroundPosition).hashCode = function () {
    var result = hashCode(this.pdj_1);
    result = imul(result, 31) + hashCode(this.qdj_1) | 0;
    result = imul(result, 31) + hashCode(this.rdj_1) | 0;
    return result;
  };
  protoOf(LevelBackgroundPosition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LevelBackgroundPosition))
      return false;
    var tmp0_other_with_cast = other instanceof LevelBackgroundPosition ? other : THROW_CCE();
    if (!equals(this.pdj_1, tmp0_other_with_cast.pdj_1))
      return false;
    if (!equals(this.qdj_1, tmp0_other_with_cast.qdj_1))
      return false;
    if (!equals(this.rdj_1, tmp0_other_with_cast.rdj_1))
      return false;
    return true;
  };
  function $serializer_21() {
    $serializer_instance_21 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.NeighbourLevel', this, 2);
    tmp0_serialDesc.du('dir', false);
    tmp0_serialDesc.du('levelIid', false);
    this.sdj_1 = tmp0_serialDesc;
  }
  protoOf($serializer_21).pl = function () {
    return this.sdj_1;
  };
  protoOf($serializer_21).su = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  protoOf($serializer_21).ql = function (decoder) {
    var tmp0_desc = this.sdj_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.no(tmp0_desc);
    if (tmp6_input.dp()) {
      tmp4_local0 = tmp6_input.xo(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.xo(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.xo(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.xo(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.oo(tmp0_desc);
    return NeighbourLevel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  var $serializer_instance_21;
  function $serializer_getInstance_21() {
    if ($serializer_instance_21 == null)
      new $serializer_21();
    return $serializer_instance_21;
  }
  function NeighbourLevel_init_$Init$(seen1, dir, levelIid, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_21().sdj_1);
    }
    $this.tdj_1 = dir;
    $this.udj_1 = levelIid;
    return $this;
  }
  function NeighbourLevel_init_$Create$(seen1, dir, levelIid, serializationConstructorMarker) {
    return NeighbourLevel_init_$Init$(seen1, dir, levelIid, serializationConstructorMarker, objectCreate(protoOf(NeighbourLevel)));
  }
  function NeighbourLevel() {
  }
  protoOf(NeighbourLevel).toString = function () {
    return 'NeighbourLevel(dir=' + this.tdj_1 + ', levelIid=' + this.udj_1 + ')';
  };
  protoOf(NeighbourLevel).hashCode = function () {
    var result = getStringHashCode(this.tdj_1);
    result = imul(result, 31) + getStringHashCode(this.udj_1) | 0;
    return result;
  };
  protoOf(NeighbourLevel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NeighbourLevel))
      return false;
    var tmp0_other_with_cast = other instanceof NeighbourLevel ? other : THROW_CCE();
    if (!(this.tdj_1 === tmp0_other_with_cast.tdj_1))
      return false;
    if (!(this.udj_1 === tmp0_other_with_cast.udj_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj_15($this) {
    return $this.pdf_1.m2();
  }
  function BgPos$Companion$_anonymous__iejcu8() {
    return createSimpleEnumSerializer('korlibs.korge.ldtk.BgPos', values_15());
  }
  var BgPos_Contain_instance;
  var BgPos_Cover_instance;
  var BgPos_CoverDirty_instance;
  var BgPos_Unscaled_instance;
  function Companion_30() {
    Companion_instance_30 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.pdf_1 = lazy(tmp_0, BgPos$Companion$_anonymous__iejcu8);
  }
  protoOf(Companion_30).pl = function () {
    return PrimitiveSerialDescriptor('com.soywiz.korge.ldtk.BgPos', STRING_getInstance());
  };
  protoOf(Companion_30).ql = function (decoder) {
    var value = decoder.io();
    var tmp;
    switch (value) {
      case 'Contain':
        tmp = BgPos_Contain_getInstance();
        break;
      case 'Cover':
        tmp = BgPos_Cover_getInstance();
        break;
      case 'CoverDirty':
        tmp = BgPos_CoverDirty_getInstance();
        break;
      case 'Unscaled':
        tmp = BgPos_Unscaled_getInstance();
        break;
      default:
        throw IllegalArgumentException_init_$Create$('BgPos could not parse: ' + value);
    }
    return tmp;
  };
  protoOf(Companion_30).w13 = function () {
    return _get_$cachedSerializer__te6jhj_15(this);
  };
  protoOf(Companion_30).bv = function (typeParamsSerializers) {
    return this.w13();
  };
  var Companion_instance_30;
  function Companion_getInstance_30() {
    BgPos_initEntries();
    if (Companion_instance_30 == null)
      new Companion_30();
    return Companion_instance_30;
  }
  function values_15() {
    return [BgPos_Contain_getInstance(), BgPos_Cover_getInstance(), BgPos_CoverDirty_getInstance(), BgPos_Unscaled_getInstance()];
  }
  var BgPos_entriesInitialized;
  function BgPos_initEntries() {
    if (BgPos_entriesInitialized)
      return Unit_instance;
    BgPos_entriesInitialized = true;
    BgPos_Contain_instance = new BgPos('Contain', 0, 'Contain');
    BgPos_Cover_instance = new BgPos('Cover', 1, 'Cover');
    BgPos_CoverDirty_instance = new BgPos('CoverDirty', 2, 'CoverDirty');
    BgPos_Unscaled_instance = new BgPos('Unscaled', 3, 'Unscaled');
    Companion_getInstance_30();
  }
  function BgPos(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.xdj_1 = value;
  }
  function $serializer_22() {
    $serializer_instance_22 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.FieldInstanceEntityReference', this, 4);
    tmp0_serialDesc.du('entityIid', false);
    tmp0_serialDesc.du('layerIid', false);
    tmp0_serialDesc.du('levelIid', false);
    tmp0_serialDesc.du('worldIid', false);
    this.ydj_1 = tmp0_serialDesc;
  }
  protoOf($serializer_22).pl = function () {
    return this.ydj_1;
  };
  protoOf($serializer_22).su = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  protoOf($serializer_22).ql = function (decoder) {
    var tmp0_desc = this.ydj_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.no(tmp0_desc);
    if (tmp8_input.dp()) {
      tmp4_local0 = tmp8_input.xo(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.xo(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.xo(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.xo(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.xo(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.xo(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.xo(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.xo(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.oo(tmp0_desc);
    return FieldInstanceEntityReference_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  var $serializer_instance_22;
  function $serializer_getInstance_22() {
    if ($serializer_instance_22 == null)
      new $serializer_22();
    return $serializer_instance_22;
  }
  function FieldInstanceEntityReference_init_$Init$(seen1, entityIid, layerIid, levelIid, worldIid, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_22().ydj_1);
    }
    $this.zdj_1 = entityIid;
    $this.adk_1 = layerIid;
    $this.bdk_1 = levelIid;
    $this.cdk_1 = worldIid;
    return $this;
  }
  function FieldInstanceEntityReference_init_$Create$(seen1, entityIid, layerIid, levelIid, worldIid, serializationConstructorMarker) {
    return FieldInstanceEntityReference_init_$Init$(seen1, entityIid, layerIid, levelIid, worldIid, serializationConstructorMarker, objectCreate(protoOf(FieldInstanceEntityReference)));
  }
  function FieldInstanceEntityReference() {
  }
  protoOf(FieldInstanceEntityReference).toString = function () {
    return 'FieldInstanceEntityReference(entityIid=' + this.zdj_1 + ', layerIid=' + this.adk_1 + ', levelIid=' + this.bdk_1 + ', worldIid=' + this.cdk_1 + ')';
  };
  protoOf(FieldInstanceEntityReference).hashCode = function () {
    var result = getStringHashCode(this.zdj_1);
    result = imul(result, 31) + getStringHashCode(this.adk_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.bdk_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.cdk_1) | 0;
    return result;
  };
  protoOf(FieldInstanceEntityReference).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FieldInstanceEntityReference))
      return false;
    var tmp0_other_with_cast = other instanceof FieldInstanceEntityReference ? other : THROW_CCE();
    if (!(this.zdj_1 === tmp0_other_with_cast.zdj_1))
      return false;
    if (!(this.adk_1 === tmp0_other_with_cast.adk_1))
      return false;
    if (!(this.bdk_1 === tmp0_other_with_cast.bdk_1))
      return false;
    if (!(this.cdk_1 === tmp0_other_with_cast.cdk_1))
      return false;
    return true;
  };
  function $serializer_23() {
    $serializer_instance_23 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.FieldInstanceGridPoint', this, 2);
    tmp0_serialDesc.du('cx', false);
    tmp0_serialDesc.du('cy', false);
    this.ddk_1 = tmp0_serialDesc;
  }
  protoOf($serializer_23).pl = function () {
    return this.ddk_1;
  };
  protoOf($serializer_23).su = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance()];
  };
  protoOf($serializer_23).ql = function (decoder) {
    var tmp0_desc = this.ddk_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.no(tmp0_desc);
    if (tmp6_input.dp()) {
      tmp4_local0 = tmp6_input.so(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.so(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.so(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.so(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.oo(tmp0_desc);
    return FieldInstanceGridPoint_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  var $serializer_instance_23;
  function $serializer_getInstance_23() {
    if ($serializer_instance_23 == null)
      new $serializer_23();
    return $serializer_instance_23;
  }
  function FieldInstanceGridPoint_init_$Init$(seen1, cx, cy, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_23().ddk_1);
    }
    $this.edk_1 = cx;
    $this.fdk_1 = cy;
    return $this;
  }
  function FieldInstanceGridPoint_init_$Create$(seen1, cx, cy, serializationConstructorMarker) {
    return FieldInstanceGridPoint_init_$Init$(seen1, cx, cy, serializationConstructorMarker, objectCreate(protoOf(FieldInstanceGridPoint)));
  }
  function FieldInstanceGridPoint() {
  }
  protoOf(FieldInstanceGridPoint).toString = function () {
    return 'FieldInstanceGridPoint(cx=' + this.edk_1 + ', cy=' + this.fdk_1 + ')';
  };
  protoOf(FieldInstanceGridPoint).hashCode = function () {
    var result = this.edk_1;
    result = imul(result, 31) + this.fdk_1 | 0;
    return result;
  };
  protoOf(FieldInstanceGridPoint).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FieldInstanceGridPoint))
      return false;
    var tmp0_other_with_cast = other instanceof FieldInstanceGridPoint ? other : THROW_CCE();
    if (!(this.edk_1 === tmp0_other_with_cast.edk_1))
      return false;
    if (!(this.fdk_1 === tmp0_other_with_cast.fdk_1))
      return false;
    return true;
  };
  function $serializer_24() {
    $serializer_instance_24 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('korlibs.korge.ldtk.IntGridValueInstance', this, 2);
    tmp0_serialDesc.du('coordId', false);
    tmp0_serialDesc.du('v', false);
    this.gdk_1 = tmp0_serialDesc;
  }
  protoOf($serializer_24).pl = function () {
    return this.gdk_1;
  };
  protoOf($serializer_24).su = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance()];
  };
  protoOf($serializer_24).ql = function (decoder) {
    var tmp0_desc = this.gdk_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.no(tmp0_desc);
    if (tmp6_input.dp()) {
      tmp4_local0 = tmp6_input.so(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.so(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.ep(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.so(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.so(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.oo(tmp0_desc);
    return IntGridValueInstance_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  var $serializer_instance_24;
  function $serializer_getInstance_24() {
    if ($serializer_instance_24 == null)
      new $serializer_24();
    return $serializer_instance_24;
  }
  function IntGridValueInstance_init_$Init$(seen1, coordID, v, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_24().gdk_1);
    }
    $this.hdk_1 = coordID;
    $this.idk_1 = v;
    return $this;
  }
  function IntGridValueInstance_init_$Create$(seen1, coordID, v, serializationConstructorMarker) {
    return IntGridValueInstance_init_$Init$(seen1, coordID, v, serializationConstructorMarker, objectCreate(protoOf(IntGridValueInstance)));
  }
  function IntGridValueInstance() {
  }
  protoOf(IntGridValueInstance).toString = function () {
    return 'IntGridValueInstance(coordID=' + this.hdk_1 + ', v=' + this.idk_1 + ')';
  };
  protoOf(IntGridValueInstance).hashCode = function () {
    var result = this.hdk_1;
    result = imul(result, 31) + this.idk_1 | 0;
    return result;
  };
  protoOf(IntGridValueInstance).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IntGridValueInstance))
      return false;
    var tmp0_other_with_cast = other instanceof IntGridValueInstance ? other : THROW_CCE();
    if (!(this.hdk_1 === tmp0_other_with_cast.hdk_1))
      return false;
    if (!(this.idk_1 === tmp0_other_with_cast.idk_1))
      return false;
    return true;
  };
  function AllowedRefs_Any_getInstance() {
    AllowedRefs_initEntries();
    return AllowedRefs_Any_instance;
  }
  function AllowedRefs_OnlySame_getInstance() {
    AllowedRefs_initEntries();
    return AllowedRefs_OnlySame_instance;
  }
  function AllowedRefs_OnlyTags_getInstance() {
    AllowedRefs_initEntries();
    return AllowedRefs_OnlyTags_instance;
  }
  function EditorDisplayMode_ArrayCountNoLabel_getInstance() {
    EditorDisplayMode_initEntries();
    return EditorDisplayMode_ArrayCountNoLabel_instance;
  }
  function EditorDisplayMode_ArrayCountWithLabel_getInstance() {
    EditorDisplayMode_initEntries();
    return EditorDisplayMode_ArrayCountWithLabel_instance;
  }
  function EditorDisplayMode_EntityTile_getInstance() {
    EditorDisplayMode_initEntries();
    return EditorDisplayMode_EntityTile_instance;
  }
  function EditorDisplayMode_Hidden_getInstance() {
    EditorDisplayMode_initEntries();
    return EditorDisplayMode_Hidden_instance;
  }
  function EditorDisplayMode_NameAndValue_getInstance() {
    EditorDisplayMode_initEntries();
    return EditorDisplayMode_NameAndValue_instance;
  }
  function EditorDisplayMode_PointPath_getInstance() {
    EditorDisplayMode_initEntries();
    return EditorDisplayMode_PointPath_instance;
  }
  function EditorDisplayMode_PointPathLoop_getInstance() {
    EditorDisplayMode_initEntries();
    return EditorDisplayMode_PointPathLoop_instance;
  }
  function EditorDisplayMode_PointStar_getInstance() {
    EditorDisplayMode_initEntries();
    return EditorDisplayMode_PointStar_instance;
  }
  function EditorDisplayMode_Points_getInstance() {
    EditorDisplayMode_initEntries();
    return EditorDisplayMode_Points_instance;
  }
  function EditorDisplayMode_RadiusGrid_getInstance() {
    EditorDisplayMode_initEntries();
    return EditorDisplayMode_RadiusGrid_instance;
  }
  function EditorDisplayMode_RadiusPx_getInstance() {
    EditorDisplayMode_initEntries();
    return EditorDisplayMode_RadiusPx_instance;
  }
  function EditorDisplayMode_RefLinkBetweenCenters_getInstance() {
    EditorDisplayMode_initEntries();
    return EditorDisplayMode_RefLinkBetweenCenters_instance;
  }
  function EditorDisplayMode_RefLinkBetweenPivots_getInstance() {
    EditorDisplayMode_initEntries();
    return EditorDisplayMode_RefLinkBetweenPivots_instance;
  }
  function EditorDisplayMode_ValueOnly_getInstance() {
    EditorDisplayMode_initEntries();
    return EditorDisplayMode_ValueOnly_instance;
  }
  function EditorDisplayPos_Above_getInstance() {
    EditorDisplayPos_initEntries();
    return EditorDisplayPos_Above_instance;
  }
  function EditorDisplayPos_Beneath_getInstance() {
    EditorDisplayPos_initEntries();
    return EditorDisplayPos_Beneath_instance;
  }
  function EditorDisplayPos_Center_getInstance() {
    EditorDisplayPos_initEntries();
    return EditorDisplayPos_Center_instance;
  }
  function TextLanguageMode_LangC_getInstance() {
    TextLanguageMode_initEntries();
    return TextLanguageMode_LangC_instance;
  }
  function TextLanguageMode_LangHaxe_getInstance() {
    TextLanguageMode_initEntries();
    return TextLanguageMode_LangHaxe_instance;
  }
  function TextLanguageMode_LangJS_getInstance() {
    TextLanguageMode_initEntries();
    return TextLanguageMode_LangJS_instance;
  }
  function TextLanguageMode_LangJSON_getInstance() {
    TextLanguageMode_initEntries();
    return TextLanguageMode_LangJSON_instance;
  }
  function TextLanguageMode_LangLog_getInstance() {
    TextLanguageMode_initEntries();
    return TextLanguageMode_LangLog_instance;
  }
  function TextLanguageMode_LangLua_getInstance() {
    TextLanguageMode_initEntries();
    return TextLanguageMode_LangLua_instance;
  }
  function TextLanguageMode_LangMarkdown_getInstance() {
    TextLanguageMode_initEntries();
    return TextLanguageMode_LangMarkdown_instance;
  }
  function TextLanguageMode_LangPython_getInstance() {
    TextLanguageMode_initEntries();
    return TextLanguageMode_LangPython_instance;
  }
  function TextLanguageMode_LangRuby_getInstance() {
    TextLanguageMode_initEntries();
    return TextLanguageMode_LangRuby_instance;
  }
  function TextLanguageMode_LangXML_getInstance() {
    TextLanguageMode_initEntries();
    return TextLanguageMode_LangXML_instance;
  }
  function LimitBehavior_DiscardOldOnes_getInstance() {
    LimitBehavior_initEntries();
    return LimitBehavior_DiscardOldOnes_instance;
  }
  function LimitBehavior_MoveLastOne_getInstance() {
    LimitBehavior_initEntries();
    return LimitBehavior_MoveLastOne_instance;
  }
  function LimitBehavior_PreventAdding_getInstance() {
    LimitBehavior_initEntries();
    return LimitBehavior_PreventAdding_instance;
  }
  function LimitScope_PerLayer_getInstance() {
    LimitScope_initEntries();
    return LimitScope_PerLayer_instance;
  }
  function LimitScope_PerLevel_getInstance() {
    LimitScope_initEntries();
    return LimitScope_PerLevel_instance;
  }
  function LimitScope_PerWorld_getInstance() {
    LimitScope_initEntries();
    return LimitScope_PerWorld_instance;
  }
  function RenderMode_Cross_getInstance() {
    RenderMode_initEntries();
    return RenderMode_Cross_instance;
  }
  function RenderMode_Ellipse_getInstance() {
    RenderMode_initEntries();
    return RenderMode_Ellipse_instance;
  }
  function RenderMode_Rectangle_getInstance() {
    RenderMode_initEntries();
    return RenderMode_Rectangle_instance;
  }
  function RenderMode_Tile_getInstance() {
    RenderMode_initEntries();
    return RenderMode_Tile_instance;
  }
  function TileRenderMode_Cover_getInstance() {
    TileRenderMode_initEntries();
    return TileRenderMode_Cover_instance;
  }
  function TileRenderMode_FitInside_getInstance() {
    TileRenderMode_initEntries();
    return TileRenderMode_FitInside_instance;
  }
  function TileRenderMode_FullSizeCropped_getInstance() {
    TileRenderMode_initEntries();
    return TileRenderMode_FullSizeCropped_instance;
  }
  function TileRenderMode_FullSizeUncropped_getInstance() {
    TileRenderMode_initEntries();
    return TileRenderMode_FullSizeUncropped_instance;
  }
  function TileRenderMode_NineSlice_getInstance() {
    TileRenderMode_initEntries();
    return TileRenderMode_NineSlice_instance;
  }
  function TileRenderMode_Repeat_getInstance() {
    TileRenderMode_initEntries();
    return TileRenderMode_Repeat_instance;
  }
  function TileRenderMode_Stretch_getInstance() {
    TileRenderMode_initEntries();
    return TileRenderMode_Stretch_instance;
  }
  function Type_AutoLayer_getInstance() {
    Type_initEntries();
    return Type_AutoLayer_instance;
  }
  function Type_Entities_getInstance() {
    Type_initEntries();
    return Type_Entities_instance;
  }
  function Type_IntGrid_getInstance() {
    Type_initEntries();
    return Type_IntGrid_instance;
  }
  function Type_Tiles_getInstance() {
    Type_initEntries();
    return Type_Tiles_instance;
  }
  function EmbedAtlas_LdtkIcons_getInstance() {
    EmbedAtlas_initEntries();
    return EmbedAtlas_LdtkIcons_instance;
  }
  function Checker_Horizontal_getInstance() {
    Checker_initEntries();
    return Checker_Horizontal_instance;
  }
  function Checker_None_getInstance() {
    Checker_initEntries();
    return Checker_None_instance;
  }
  function Checker_Vertical_getInstance() {
    Checker_initEntries();
    return Checker_Vertical_instance;
  }
  function TileMode_Single_getInstance() {
    TileMode_initEntries();
    return TileMode_Single_instance;
  }
  function TileMode_Stamp_getInstance() {
    TileMode_initEntries();
    return TileMode_Stamp_instance;
  }
  function Flag_DiscardPreCSVIntGrid_getInstance() {
    Flag_initEntries();
    return Flag_DiscardPreCSVIntGrid_instance;
  }
  function Flag_ExportPreCSVIntGridFormat_getInstance() {
    Flag_initEntries();
    return Flag_ExportPreCSVIntGridFormat_instance;
  }
  function Flag_IgnoreBackupSuggest_getInstance() {
    Flag_initEntries();
    return Flag_IgnoreBackupSuggest_instance;
  }
  function Flag_MultiWorlds_getInstance() {
    Flag_initEntries();
    return Flag_MultiWorlds_instance;
  }
  function Flag_PrependIndexToLevelFileNames_getInstance() {
    Flag_initEntries();
    return Flag_PrependIndexToLevelFileNames_instance;
  }
  function Flag_UseMultilinesType_getInstance() {
    Flag_initEntries();
    return Flag_UseMultilinesType_instance;
  }
  function IdentifierStyle_Capitalize_getInstance() {
    IdentifierStyle_initEntries();
    return IdentifierStyle_Capitalize_instance;
  }
  function IdentifierStyle_Free_getInstance() {
    IdentifierStyle_initEntries();
    return IdentifierStyle_Free_instance;
  }
  function IdentifierStyle_Lowercase_getInstance() {
    IdentifierStyle_initEntries();
    return IdentifierStyle_Lowercase_instance;
  }
  function IdentifierStyle_Uppercase_getInstance() {
    IdentifierStyle_initEntries();
    return IdentifierStyle_Uppercase_instance;
  }
  function ImageExportMode_LayersAndLevels_getInstance() {
    ImageExportMode_initEntries();
    return ImageExportMode_LayersAndLevels_instance;
  }
  function ImageExportMode_None_getInstance() {
    ImageExportMode_initEntries();
    return ImageExportMode_None_instance;
  }
  function ImageExportMode_OneImagePerLayer_getInstance() {
    ImageExportMode_initEntries();
    return ImageExportMode_OneImagePerLayer_instance;
  }
  function ImageExportMode_OneImagePerLevel_getInstance() {
    ImageExportMode_initEntries();
    return ImageExportMode_OneImagePerLevel_instance;
  }
  function WorldLayout_Free_getInstance() {
    WorldLayout_initEntries();
    return WorldLayout_Free_instance;
  }
  function WorldLayout_GridVania_getInstance() {
    WorldLayout_initEntries();
    return WorldLayout_GridVania_instance;
  }
  function WorldLayout_LinearHorizontal_getInstance() {
    WorldLayout_initEntries();
    return WorldLayout_LinearHorizontal_instance;
  }
  function WorldLayout_LinearVertical_getInstance() {
    WorldLayout_initEntries();
    return WorldLayout_LinearVertical_instance;
  }
  function BgPos_Contain_getInstance() {
    BgPos_initEntries();
    return BgPos_Contain_instance;
  }
  function BgPos_Cover_getInstance() {
    BgPos_initEntries();
    return BgPos_Cover_instance;
  }
  function BgPos_CoverDirty_getInstance() {
    BgPos_initEntries();
    return BgPos_CoverDirty_instance;
  }
  function BgPos_Unscaled_getInstance() {
    BgPos_initEntries();
    return BgPos_Unscaled_instance;
  }
  //region block: post-declaration
  protoOf($serializer).tu = typeParametersSerializers;
  protoOf($serializer_0).tu = typeParametersSerializers;
  protoOf($serializer_1).tu = typeParametersSerializers;
  protoOf($serializer_2).tu = typeParametersSerializers;
  protoOf($serializer_3).tu = typeParametersSerializers;
  protoOf($serializer_4).tu = typeParametersSerializers;
  protoOf($serializer_5).tu = typeParametersSerializers;
  protoOf($serializer_6).tu = typeParametersSerializers;
  protoOf($serializer_7).tu = typeParametersSerializers;
  protoOf($serializer_8).tu = typeParametersSerializers;
  protoOf($serializer_9).tu = typeParametersSerializers;
  protoOf($serializer_10).tu = typeParametersSerializers;
  protoOf($serializer_11).tu = typeParametersSerializers;
  protoOf($serializer_12).tu = typeParametersSerializers;
  protoOf($serializer_13).tu = typeParametersSerializers;
  protoOf($serializer_14).tu = typeParametersSerializers;
  protoOf($serializer_15).tu = typeParametersSerializers;
  protoOf($serializer_16).tu = typeParametersSerializers;
  protoOf($serializer_17).tu = typeParametersSerializers;
  protoOf($serializer_18).tu = typeParametersSerializers;
  protoOf($serializer_19).tu = typeParametersSerializers;
  protoOf($serializer_20).tu = typeParametersSerializers;
  protoOf($serializer_21).tu = typeParametersSerializers;
  protoOf($serializer_22).tu = typeParametersSerializers;
  protoOf($serializer_23).tu = typeParametersSerializers;
  protoOf($serializer_24).tu = typeParametersSerializers;
  //endregion
  //region block: init
  Companion_instance_23 = new Companion_23();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Companion_getInstance_20;
  //endregion
  return _;
}));
